const es = {
  _name: 'Español',
  _flag: '🇪🇸',

    'comm.anonymousVisitor': 'Visitante anónimo',
  'comm.deletedVisitor': 'Visitante eliminado',
'notifAuto.timezone': 'Zona horaria',
  'notifAuto.timezoneHint': 'Determina cuándo se envían los recordatorios',
  'notifAuto.tzKyiv': 'Kiev (UTC+2/+3)',
  'notifAuto.tzWarsaw': 'Varsovia (UTC+1/+2)',
  'notifAuto.tzBerlin': 'Berlín (UTC+1/+2)',
  'notifAuto.tzParis': 'París (UTC+1/+2)',
  'notifAuto.tzLondon': 'Londres (UTC+0/+1)',
  'notifAuto.tzMadrid': 'Madrid (UTC+1/+2)',
  'notifAuto.tzRome': 'Roma (UTC+1/+2)',
  'notifAuto.tzNewYork': 'Nueva York (UTC-5/-4)',

  'errors.rateLimited': 'Demasiadas solicitudes. Inténtalo en {seconds} s 🙂',
  'errors.serverError': 'Error del servidor. Inténtalo de nuevo en un momento',
  'errors.networkError': 'Sin conexión. Comprueba tu internet',

  // ── Navigation sections ──
  'nav.businessMonitor': 'Monitor de Negocio',
  'nav.dashboard': 'Panel',
  'nav.clients': 'Clientes',
  'nav.communication': 'Comunicación',
  'nav.staff': 'Personal',
  'nav.inventory': 'Almacén',
  'nav.salary': 'Nóminas',
  'nav.finances': 'Finanzas',
  'nav.system': 'Sistema',
  'nav.integrations': 'Integraciones',
  'nav.sales': 'Ventas',

  // ── Navigation items ──
  'nav.pos': 'Tienda',
  'nav.salesProducts': 'Despacho de almacén',
  'nav.salesServices': 'Reservar servicios',
  'nav.clientsBase': 'Base de clientes',
  'nav.categories': 'Categorías de clientes',
  'nav.messages': 'Mensajes',
  'nav.employees': 'Empleados',
  'nav.schedule': 'Horario de trabajo',
  'nav.scheduleTemplates': 'Plantillas de horarios',
  'nav.services': 'Servicios',
  'nav.tariffPlans': 'Planes tarifarios',
  'nav.products': 'Productos',
  'nav.stock': 'Existencias',
  'nav.purchases': 'Compras',
  'nav.movements': 'Movimientos de stock',
  'nav.orders': 'Pedidos',
  'nav.salaryCalc': 'Cálculo',
  'nav.salarySchemes': 'Esquemas de motivación',
  'nav.financialOps': 'Operaciones financieras',
  'nav.cashRegister': 'Caja',
  'nav.reports': 'Informes',
  'nav.financialResult': 'Resultado financiero',
  'nav.users': 'Usuarios',
  'nav.roles': 'Roles',
  'nav.checkbox': 'Checkbox POS',
  'nav.telegram': 'Recordatorios Telegram',
  'nav.sms': 'Envío SMS',
  'nav.email': 'Envío Email',
  'nav.novaPoshta': 'Nova Poshta',
  'nav.meestExpress': 'Meest Express',
  'nav.olx': 'OLX',
  'olx.tagline': 'Mensajes de anuncios + sincronización de catálogo',
  'olx.connected': 'Conectado',
  'olx.notConnected': 'No conectado',
  'olx.connectIntro': 'Conecta tu cuenta de OLX vía OAuth para recibir mensajes de anuncios en el CRM y publicar productos como anuncios.',
  'olx.connectBtn': 'Conectar OLX',
  'olx.tabOpened': 'OLX abierto en una pestaña nueva. Autoriza y regresa.',
  'olx.connectFailed': 'Error de conexión:',
  'olx.connectedToast': 'OLX conectado',
  'olx.confirmDisconnect': '¿Desconectar la integración OLX?',
  'olx.disconnected': 'OLX desconectado',
  'olx.disconnectBtn': 'Desconectar',
  'olx.testBtn': 'Probar conexión',
  'olx.testOk': 'Conectado como: {name} (ID {id})',
  'olx.testFailed': 'Prueba fallida',
  'olx.accountId': 'OLX ID',
  'olx.scope': 'Permisos',
  'olx.connectedAt': 'Conectado el',
  'olx.reconnectRequired': 'Re-autorización requerida',
  'olx.reconnectExplain': 'OLX revocó nuestros tokens (generalmente tras 30 días de inactividad o un cambio de contraseña). Haz clic en «Conectar OLX» para reanudar.',
  'olx.refreshBtn': 'Buscar mensajes nuevos',
  'olx.refreshFound': 'Recibidos {n} mensajes nuevos — revísalos en Comunicaciones',
  'olx.refreshNoNew': 'Sin mensajes nuevos',
  'olx.refreshFailed': 'Actualización fallida',
  'comm.olxThreadMissing': 'No se pudo determinar el hilo OLX',
  'olx.howItWorks': 'Cómo funciona',
  'olx.step1': 'Haz clic en «Conectar OLX» — la autorización OLX se abre en una nueva pestaña.',
  'olx.step2': 'Inicia sesión en tu cuenta OLX y concede acceso a la aplicación.',
  'olx.step3': 'Regresa a esta pestaña — el estado se actualizará automáticamente; verifica con «Probar conexión».',
  'olx.capabilities': 'Qué desbloquea la integración',
  'olx.capInboxTitle': 'Chats de anuncios — dentro del CRM',
  'olx.capInboxText': 'Cada mensaje de comprador de tus anuncios OLX aparece en Sidebar → Comunicación. Se revisa cada 10 min; usa «Buscar mensajes nuevos» arriba para una consulta inmediata.',
  'olx.capOutboundTitle': 'Responder desde el CRM directamente al chat OLX',
  'olx.capOutboundText': 'Abre un hilo en Comunicación, elige el canal OLX — tu mensaje llega al chat OLX del comprador como si lo hubieras escrito en olx.ua.',
  'olx.capPublishTitle': 'Publicar productos como anuncios OLX',
  'olx.capPublishText': 'Sidebar → Inventario → abre un producto → «Publicar en OLX». Título, descripción, precio y foto se rellenan desde la ficha — eliges categoría, ciudad y contacto, y el anuncio se envía a moderación OLX.',
  'olx.limitations': 'Limitaciones',
  'olx.limitationsText': 'Los pedidos de OLX Delivery aún no están expuestos por la API de partners. Gestiónalos en olx.ua por ahora.',
  'nav.locations': 'Ubicaciones',
  'nav.myPlan': 'Mi Plan',
  'nav.onlineBooking': 'Reserva online',
  'nav.help': 'Ayuda',
  'booking.title': 'Reserva online',
  'booking.subtitle': 'Configurar la página pública de reservas para sus clientes',
  'booking.enable': 'Activar reserva online',
  'booking.yourLink': 'Su enlace',
  'booking.copy': 'Copiar',
  'booking.urlCopied': 'Enlace copiado',
  'booking.linkHint': 'Comparta este enlace con sus clientes — en Instagram, Telegram, su web',
  'booking.businessInfo': 'Información del negocio',
  'booking.businessName': 'Nombre del negocio',
  'booking.businessNameHint': 'Cómo le verán los clientes',
  'booking.slug': 'Identificador URL',
  'booking.slugHint': 'Letras latinas, números, guiones. Ej: mi-salon',
  'booking.description': 'Descripción',
  'booking.descriptionHint': 'Breve descripción de su negocio',
  'booking.themeColor': 'Color del tema',
  'booking.locale': 'Idioma de la página',
  'booking.rules': 'Reglas de reserva',
  'booking.minHours': 'Antelación mínima',
  'booking.hours': 'horas',
  'booking.minHoursHint': 'Con cuántas horas de antelación se puede reservar',
  'booking.maxDays': 'Profundidad máx.',
  'booking.days': 'días',
  'booking.maxDaysHint': 'Cuántos días de anticipación está disponible la reserva',
  'booking.allowedServices': 'Servicios para reserva online',
  'booking.allowedServicesHint': 'Seleccione los servicios disponibles para reserva online. Si no selecciona ninguno — todos estarán disponibles.',
  'booking.allowedStaff': 'Especialistas para reserva online',
  'booking.allowedStaffHint': 'Seleccione los especialistas disponibles para reserva online. Si no selecciona ninguno — todos estarán disponibles.',
  'booking.selectAll': 'Seleccionar todo',
  'booking.deselectAll': 'Deseleccionar todo',
  'booking.tabGeneral': 'General',
  'booking.tabServices': 'Servicios',
  'booking.tabProducts': 'Productos',
  'booking.tabAfter': 'Después',
  'booking.serviceCategories': 'Categorías de servicios',
  'booking.serviceCategoriesHint': 'Seleccione categorías para reserva online. Si ninguna — todas disponibles.',
  'booking.productCategories': 'Categorías de productos',
  'booking.productCategoriesHint': 'Seleccione categorías para venta online. Si ninguna — todas disponibles.',
  'booking.noCategoriesYet': 'Aún no hay categorías. Créelas en la sección correspondiente.',
  'booking.mode': 'Modo de operación',
  'booking.modeServices': 'Servicios',
  'booking.modeShop': 'Tienda',
  'booking.modeBoth': 'Ambos',
  'booking.modeHint': 'Servicios — reserva de citas. Tienda — pedidos online. Ambos — servicios y productos.',
  'booking.shopSettings': 'Configuración de tienda',
  'booking.shopMinOrder': 'Pedido mínimo',
  'booking.shopShowOutOfStock': 'Sin stock',
  'booking.shopShowOutOfStockLabel': 'Mostrar productos sin stock',
  'booking.shopDelivery': 'Métodos de envío',
  'booking.deliveryPickup': 'Recogida',
  'booking.deliveryNP': 'Nova Poshta',
  'booking.deliveryMeest': 'Meest Express',
  'booking.deliveryCourier': 'Mensajero',
  'booking.gallery': 'Galería',
  'booking.galleryHint': 'Fotos de trabajos, interior, productos — hasta 10 imágenes',
  'booking.galleryCount': 'fotos',
  'booking.promo': 'Banner promocional',
  'booking.promoEnable': 'Mostrar banner',
  'booking.promoText': 'Texto de la promoción',
  'booking.promoPlaceholder': 'Ej.: 20% de descuento en la primera visita',
  'booking.promoColor': 'Color',
  'booking.colorScheme': 'Esquema de colores',
  'booking.bgColor': 'Color de fondo',
  'booking.presetLight': 'Claro',
  'booking.presetDark': 'Oscuro',
  'booking.presetWarm': 'Cálido',
  'booking.presetFresh': 'Fresco',
  'booking.presetRose': 'Rosa',
  'booking.presetPurple': 'Púrpura',
  'booking.branding': 'Marca',
  'booking.logo': 'Logotipo',
  'booking.uploadLogo': 'Subir logo',
  'booking.changeLogo': 'Cambiar logo',
  'booking.headerImage': 'Fondo del encabezado',
  'booking.uploadImage': 'Subir foto',
  'booking.changeImage': 'Cambiar foto',
  'booking.logoTooLarge': 'El logo es demasiado grande. Máximo 1 MB.',
  'booking.imageTooLarge': 'La imagen es demasiado grande. Máximo 5 MB.',
  'booking.headerImageHint': 'Foto de su negocio — salón, estudio, tienda',
  'booking.contacts': 'Contactos',
  'booking.contactsHint': 'La dirección y el horario se toman de la configuración de ubicaciones',
  'booking.address': 'Dirección',
  'booking.addressHint': 'Calle, número, ciudad',
  'booking.businessPhone': 'Teléfono',
  'booking.website': 'Sitio web',
  'booking.workingHours': 'Horario de trabajo',
  'booking.workingHoursHint': 'Lun-Vie 9:00-18:00',
  'booking.afterBooking': 'Después de reservar',
  'booking.successMsg': 'Mensaje de confirmación',
  'booking.successMsgHint': 'Ej: ¡Le esperamos! No olvide su documento.',
  'booking.cancelPolicy': 'Política de cancelación',
  'booking.cancelPolicyHint': 'Ej: Puede cancelar hasta 24 horas antes',
  'booking.disableTitle': '¿Desactivar reserva online?',
  'booking.disableText': 'Los clientes ya no podrán reservar online. Puede reactivarlo en cualquier momento.',
  'booking.disableConfirm': 'Desactivar',

  // ── Calendar months & days ──
  'months.0': 'Enero', 'months.1': 'Febrero', 'months.2': 'Marzo',
  'months.3': 'Abril', 'months.4': 'Mayo', 'months.5': 'Junio',
  'months.6': 'Julio', 'months.7': 'Agosto', 'months.8': 'Septiembre',
  'months.9': 'Octubre', 'months.10': 'Noviembre', 'months.11': 'Diciembre',
  'dow.0': 'Lu', 'dow.1': 'Ma', 'dow.2': 'Mi',
  'dow.3': 'Ju', 'dow.4': 'Vi', 'dow.5': 'Sá', 'dow.6': 'Do',

  // ── Common UI ──
  'common.save': 'Guardar',
  'common.saving': 'Guardando...',
  'common.saved': 'Guardado',
  'common.cancel': 'Cancelar',
  'common.delete': 'Eliminar',
  'common.edit': 'Editar',
  'common.add': 'Agregar',
  'common.search': 'Buscar',
  'onboarding.title': 'Configure su negocio',
  'onboarding.subtitle': '{done} de {total} pasos completados',
  'onboarding.allDone': '¡Todo configurado!',
  'onboarding.allDoneHint': 'Estás listo para trabajar 💪',
  'onboarding.stepBusiness': 'Tipo de negocio seleccionado',
  'onboarding.stepStaff': 'Agregar primer empleado',
  'onboarding.stepService': 'Agregar primer servicio',
  'onboarding.stepAppointment': 'Crear primera cita',
  'onboarding.stepClient': 'Agregar primer cliente',
  'onboarding.noStaffYet': 'Sin empleados',
  'onboarding.noStaffHint': 'Agregue su primer empleado para comenzar a aceptar citas',
  'onboarding.goAddStaff': '+ Agregar empleado',
  'gsearch.placeholder': 'Buscar clientes, citas, empleados...',
  'gsearch.quickActions': 'Acciones rápidas',
  'gsearch.customers': 'Clientes',
  'gsearch.staff': 'Empleados',
  'gsearch.appointments': 'Citas',
  'gsearch.noResults': 'No se encontró nada',
  'gsearch.goCalendar': 'Agenda — hoy',
  'gsearch.goClients': 'Base de clientes',
  'gsearch.goFinances': 'Finanzas',
  'gsearch.goDashboard': 'Panel',
  'gsearch.newClient': 'Nuevo cliente',
  'common.close': 'Cerrar',
  'common.loading': 'Cargando...',
  'common.yes': 'Sí',
  'common.no': 'No',
  'common.and': 'y',
  'common.confirm': 'Confirmar',
  'common.back': 'Atrás',
  'common.next': 'Siguiente',
  'common.create': 'Crear',
  'common.actions': 'Acciones',
  'common.name': 'Nombre',
  'common.phone': 'Teléfono',
  'common.email': 'Email',
  'common.date': 'Fecha',
  'common.time': 'Hora',
  'common.status': 'Estado',
  'common.total': 'Total',
  'common.price': 'Precio',
  'common.quantity': 'Cantidad',
  'common.note': 'Nota',
  'common.all': 'Todos',
  'common.filter': 'Filtro',
  'common.export': 'Exportar',
  'common.shown': 'Mostrado',
  'common.of': 'de',
  'common.logout': 'Cerrar sesión',
  'common.profile': 'Perfil',
  'common.settings': 'Configuración',
  'common.language': 'Idioma',

  // ── Clients page ──
  'clients.title': 'Base de clientes',
  'clients.subtitle': 'Gestión de fichas de clientes',
  'clients.addClient': 'Agregar cliente',
  'clients.import': 'Importar',
  'import.title': 'Importar clientes',
  'import.uploadHint': 'Suba un archivo con su base de clientes. Se admiten Excel y CSV.',
  'import.maxRows': 'máximo {max} filas',
  'import.tooManyRowsTitle': 'Archivo demasiado grande',
  'import.tooManyRowsBody': 'El archivo tiene {count} filas — el máximo por importación es {max}. Divida el archivo en partes más pequeñas o contacte con soporte.',
  'import.selectFile': 'Seleccionar archivo',
  'import.downloadTemplate': 'Descargar plantilla',
  'import.or': 'o',
  'import.rows': 'filas',
  'import.fieldName': 'Nombre',
  'import.fieldLastName': 'Apellido',
  'import.fieldFirstName': 'Nombre',
  'import.fieldPhone': 'Teléfono',
  'import.fieldAdditionalPhone': 'Tel. adicional',
  'import.fieldEmail': 'Email',
  'import.fieldGender': 'Género',
  'import.fieldBirthday': 'Fecha de nacimiento',
  'import.fieldCategory': 'Categoría',
  'import.fieldCardNumber': 'Nº de tarjeta',
  'import.fieldNote': 'Nota',

  'importProducts.btn': 'Importar',
  'importProducts.btnTitle': 'Importar productos en masa desde Excel/CSV',
  'importProducts.title': 'Importar productos',
  'importProducts.uploadHint': 'Sube un archivo Excel o CSV con tus productos. Campos obligatorios: nombre y precio de venta.',
  'importProducts.maxRows': 'máximo {max} filas',
  'importProducts.tooManyRowsTitle': 'Archivo demasiado grande',
  'importProducts.tooManyRowsBody': 'El archivo tiene {count} filas — máximo por importación es {max}. Divídelo en archivos más pequeños.',
  'importProducts.selectFile': 'Seleccionar archivo',
  'importProducts.downloadTemplate': 'Descargar plantilla',
  'importProducts.or': 'o',
  'importProducts.rows': 'filas',
  'importProducts.fieldName': 'Nombre',
  'importProducts.fieldSku': 'SKU',
  'importProducts.fieldCategory': 'Categoría',
  'importProducts.fieldUnit': 'Unidad',
  'importProducts.fieldMinStock': 'Stock mín.',
  'importProducts.fieldSellPrice': 'Precio de venta',
  'importProducts.statusCol': 'Estado',
  'importProducts.mapHint': 'Asocia las columnas del archivo con los campos del producto. Los obligatorios están marcados con asterisco.',
  'importProducts.notMapped': 'no seleccionado',
  'importProducts.back': 'Atrás',
  'importProducts.next': 'Siguiente',
  'importProducts.startOver': 'Otro archivo',
  'importProducts.willImport': 'serán importados',
  'importProducts.willSkip': 'serán omitidos',
  'importProducts.newCategories': 'categorías nuevas',
  'importProducts.newCategoriesWarning': 'El archivo menciona categorías que aún no existen — se crearán automáticamente al importar.',
  'importProducts.errMissingName': 'Nombre vacío',
  'importProducts.errInvalidPrice': 'Precio inválido',
  'importProducts.errInvalidMinStock': 'Stock mínimo inválido',
  'importProducts.errSkuExisting': 'SKU ya existe',
  'importProducts.previewTruncated': 'Mostrando primeras 100 de {count}',
  'importProducts.importing': 'Importando...',
  'importProducts.importBtn': 'Importar {count}',
  'importProducts.doneTitle': 'Importados {count} productos',
  'importProducts.doneNewCategories': 'Creadas {count} categorías nuevas',
  'importProducts.doneSkipped': 'Omitidas {count} filas',
  'importProducts.close': 'Cerrar',
  'importProducts.toastSuccess': 'Productos importados',

  'importServices.btn': 'Importar',
  'importServices.btnTitle': 'Importar servicios en masa desde Excel/CSV',
  'importServices.title': 'Importar servicios',
  'importServices.uploadHint': 'Sube un archivo Excel o CSV con tus servicios. Requerido: nombre y precio. La duración por defecto es 30 min.',
  'importServices.maxRows': 'máximo {max} filas',
  'importServices.tooManyRowsTitle': 'Archivo demasiado grande',
  'importServices.tooManyRowsBody': 'El archivo tiene {count} filas — máximo por importación es {max}.',
  'importServices.selectFile': 'Seleccionar archivo',
  'importServices.downloadTemplate': 'Descargar plantilla',
  'importServices.or': 'o',
  'importServices.rows': 'filas',
  'importServices.fieldName': 'Nombre',
  'importServices.fieldGroup': 'Grupo',
  'importServices.fieldPrice': 'Precio',
  'importServices.fieldDuration': 'Duración (min)',
  'importServices.statusCol': 'Estado',
  'importServices.mapHint': 'Asocia las columnas del archivo con los campos del servicio. Los obligatorios están marcados con asterisco.',
  'importServices.notMapped': 'no seleccionado',
  'importServices.back': 'Atrás',
  'importServices.next': 'Siguiente',
  'importServices.startOver': 'Otro archivo',
  'importServices.willImport': 'serán importados',
  'importServices.willSkip': 'serán omitidos',
  'importServices.newGroups': 'grupos nuevos',
  'importServices.newGroupsWarning': 'El archivo menciona grupos que aún no existen — se crearán automáticamente.',
  'importServices.errMissingName': 'Nombre vacío',
  'importServices.errInvalidPrice': 'Precio inválido',
  'importServices.errInvalidDuration': 'Duración inválida (1-1440 min)',
  'importServices.errNameExisting': 'El servicio ya existe',
  'importServices.previewTruncated': 'Mostrando primeras 100 de {count}',
  'importServices.importing': 'Importando...',
  'importServices.importBtn': 'Importar {count}',
  'importServices.doneTitle': 'Importados {count} servicios',
  'importServices.doneNewGroups': 'Creados {count} grupos nuevos',
  'importServices.doneSkipped': 'Omitidas {count} filas',
  'importServices.close': 'Cerrar',
  'importServices.toastSuccess': 'Servicios importados',

  'import.skip': 'omitir',
  'import.phoneRequired': 'El campo "Teléfono" es obligatorio',
  'import.preview': 'Vista previa',
  'import.back': 'Atrás',
  'import.adjustColumns': 'Ajustar columnas',
  'import.newClients': 'Nuevos clientes',
  'import.duplicates': 'Duplicados (omitidos)',
  'import.duplicate': 'duplicado',
  'import.new': 'nuevo',
  'import.status': 'Estado',
  'import.andMore': '...y {count} más',
  'import.importing': 'Importando...',
  'import.importBtn': 'Importar ({count})',
  'import.success': '¡{count} clientes importados!',
  'import.skippedDuplicates': '{count} duplicados omitidos',
  'import.error': 'Error de importación',
  'import.close': 'Cerrar',
  'helpPage.title': 'Help',
  'helpPage.subtitle': 'Guides and instructions for Systemic CRM',
  'clients.searchPlaceholder': 'Buscar por nombre, teléfono, email, número de tarjeta...',
  'clients.allCategories': 'Todas las categorías',
  'clients.clientsCount': 'Clientes',
  'clients.grid': 'Cuadrícula',
  'clients.list': 'Lista',
  'clients.deleteTitle': '¿Eliminar cliente?',
  'clients.deleteMessage': 'Está a punto de eliminar la ficha del cliente',
  'clients.cannotDeleteTitle': 'No se puede eliminar',
  'clients.cannotDeleteMessage': 'El cliente tiene citas o historial financiero y no puede ser eliminado',
  'clients.duplicatePhone': 'Ya existe un cliente con este número de teléfono',
  'clients.duplicatePhoneWithName': 'Ya existe un cliente con este teléfono: {name}',
  'clients.openExisting': 'Abrir cliente',
  'clients.understood': 'Entendido',
  'clients.deleteWarning': 'Esta acción es irreversible. Todos los datos del cliente se perderán.',

  // ── Delete modal ──
  'delete.title': 'Confirmar eliminación',
  'delete.message': 'Está a punto de eliminar un registro',
  'delete.confirm': 'Sí, eliminar',
  'delete.warning': 'Esta acción es irreversible. Todos los datos se perderán.',

  // ── Sidebar ──
  'sidebar.crmSystem': 'Sistema CRM',
  'sidebar.version': 'v1.0',

  // ── Login ──
  'login.title': 'Iniciar sesión',
  'login.setupTitle': 'Configuración del sistema',
  'login.setupSubtitle': 'Cree una cuenta de administrador',
  'login.subtitle': 'Ingrese sus credenciales',
  'login.email': 'Email',
  'login.password': 'Contraseña',
  'login.submit': 'Entrar',
  'login.setupSubmit': 'Crear administrador',
  'login.wait': 'Espere…',
  'login.forgotPassword': '¿Olvidó su contraseña?',
  'login.resetTitle': 'Restablecer contraseña',
  'login.resetSubtitle': 'Ingrese su email — le enviaremos instrucciones',
  'login.resetSend': 'Enviar',
  'login.resetSentHint': 'Revise su correo — le enviamos instrucciones',
  'login.backToLogin': 'Volver al inicio de sesión',
  'login.nameLabel': 'Nombre',
  'login.namePlaceholder': 'Su nombre',
  'login.businessLabel': 'Nombre del negocio',
  'login.businessPlaceholder': 'Mi salón / tienda / estudio',
  'login.errorEnterBusiness': 'Ingrese el nombre del negocio',
  'login.businessTypeLabel': 'Tipo de negocio',
  'login.businessTypePlaceholder': 'Seleccione el tipo de negocio...',
  'login.errorSelectBusinessType': 'Seleccione el tipo de negocio',
  'login.showPassword': 'Mostrar contraseña',
  'login.hidePassword': 'Ocultar contraseña',
  'login.errorInvalidCreds': 'Email o contraseña incorrectos',
  'login.errorTooMany': 'Demasiados intentos. Intente más tarde.',
  'login.errorGeneric': 'Error de inicio de sesión: ',
  'login.errorEnterName': 'Ingrese su nombre',
  'login.errorEnterEmail': 'Ingrese email',
  'login.errorMinPassword': 'La contraseña debe tener al menos 6 caracteres',
  'login.errorSetup': 'Error: ',
  'login.tabLogin': 'Iniciar sesión',
  'login.tabRegister': 'Registrarse',
  'login.registerTitle': 'Crear cuenta',
  'login.registerSubtitle': '7 días gratis, todos los módulos incluidos',
  'login.registerSubmit': 'Registrarse',
  'login.registerSuccess': '¡Cuenta creada! Iniciando sesión...',
  'login.errorEmailExists': 'Este correo ya está registrado',
  'login.errorRegister': 'Error de registro: ',
  'login.confirmPassword': 'Confirmar contraseña',
  'login.errorPasswordMismatch': 'Las contraseñas no coinciden',
  'login.agreeTerms': 'Al registrarse, acepta los',
  'login.agreeCheckbox': 'Acepto los',
  'login.errorAgreeTerms': 'Debe aceptar los términos de servicio',
  'login.terms': 'Términos de servicio',
  'login.privacy': 'Política de privacidad',

  // ── Blocked ──
  'blocked.title': 'Cuenta bloqueada',
  'blocked.desc': 'Contacte al administrador para restaurar el acceso',
  'blocked.trialExpired': 'Periodo de prueba finalizado',
  'blocked.trialExpiredDesc': 'Elija un plan para continuar',
  'blocked.paymentOverdue': 'Suscripción vencida',
  'blocked.paymentOverdueDesc': 'Su suscripción ha expirado. Por favor, renuévela para continuar trabajando.',
  'blocked.subscriptionExpiredDesc': 'Su suscripción ha expirado. Por favor, renuévela para continuar trabajando.',
  'blocked.contact': 'Contactar soporte',
  'blocked.logout': 'Salir',

  // ── My Plan ──
  'myPlan.title': 'Mi Plan',
  'myPlan.subtitle': 'Gestión de suscripción',
  'myPlan.loadError': 'No se pudieron cargar los datos del plan',
  'myPlan.trial': 'Prueba',
  'myPlan.active': 'Activo',
  'myPlan.trialExpired': 'Prueba expirada',
  'myPlan.blocked': 'Bloqueado',
  'myPlan.daysLeft': 'días restantes',
  'myPlan.month': 'mes',
  'myPlan.year': 'año',
  'myPlan.orYearly': 'o',
  'myPlan.chooseBillingPeriod': 'elige período de pago',
  'myPlan.periodMonthly': 'Mensual',
  'myPlan.periodYearly': 'Anual',
  'myPlan.yearlySaving': 'ahorras {n} ₴ vs mensual',
  'myPlan.monthlyTotal': '{n} ₴/año',
  'myPlan.proceedToPayment': 'Proceder al pago',
  'myPlan.cancel': 'Cancelar',
  'myPlan.oldRateTitle': 'Tienes una tarifa anterior',
  'myPlan.oldRateText': 'Actualmente pagas {old} ₴; la tarifa actual para {plan} es {new} ₴. Puedes mantener la tarifa anterior indefinidamente o cambiar a la nueva.',
  'myPlan.upgradeRate': 'Cambiar a nueva tarifa',
  'myPlan.users': 'Usuarios',
  'myPlan.locations': 'Ubicaciones',
  'myPlan.availablePlans': 'Planes disponibles',
  'myPlan.popular': 'Popular',
  'myPlan.usersIncl': 'usuarios',
  'myPlan.locationsIncl': 'ubicaciones',
  'myPlan.allModules': 'Los 46 módulos',
  'myPlan.trialActive': 'Prueba activa',
  'myPlan.currentPlan': 'Plan actual',
  'myPlan.upgrade': 'Elegir plan',
  'myPlan.changePlan': 'Cambiar plan',
  'myPlan.trialHint': 'Después del período de prueba, elija un plan para continuar. Todos sus datos se conservarán.',
  'myPlan.limitUsers': 'Límite de usuarios alcanzado. Actualice su plan para agregar más.',
  'myPlan.limitLocations': 'Límite de ubicaciones alcanzado. Actualice su plan para agregar más.',
  'myPlan.cancelSubscription': 'Cancelar suscripción',
  'myPlan.cancelledNotice': 'Suscripción cancelada. Tu plan permanece activo hasta el final del período pagado.',
  'myPlan.cancelTitle': '¿Cancelar suscripción?',
  'myPlan.cancelDescription': 'Tu plan seguirá activo hasta el final del período pagado. Después, tu cuenta será degradada a un plan de prueba.',
  'myPlan.cancelReasonLabel': 'Motivo de cancelación (opcional)',
  'myPlan.cancelReasonPlaceholder': 'Cuéntanos por qué decidiste cancelar...',
  'myPlan.confirmCancel': 'Sí, cancelar',
  'myPlan.keepSubscription': 'Mantener suscripción',
  'myPlan.cancelError': 'Error de cancelación',
  'myPlan.subscriptionExpired': 'vencido',

  // ── Checkout (post-registration) ──
  'checkout.title': '¡Tu cuenta está lista!',
  'checkout.subtitle': 'Elige cómo empezar con Systemic CRM',
  'checkout.recommended': 'Recomendado',
  'checkout.payNow': 'Pagar y empezar',
  'checkout.trialTitle': 'Prueba gratuita',
  'checkout.days': 'días',
  'checkout.trialFeature1': 'Acceso completo a todas las funciones',
  'checkout.trialFeature2': 'Sin compromiso',
  'checkout.trialFeature3': 'Tus datos se conservan tras el pago',
  'checkout.tryFree': 'Probar gratis',

  // ── Dashboard ──
  'dash.title': 'Panel',
  'dash.myOffice': 'Mi oficina',
  'dash.subtitle': 'Pantalla principal',
  'dash.personalStats': 'Estadísticas personales',
  'dash.todayAppointments': 'Citas hoy',
  'dash.completed': 'completadas',
  'dash.todayRevenue': 'Ingresos de hoy',
  'dash.clientsCount': 'Clientes',
  'dash.newThisMonth': 'este mes',
  'dash.unread': 'No leídos',
  'dash.todaySchedule': 'Horario de hoy',
  'dash.allAppointments': 'Todas las citas',
  'dash.noAppointmentsToday': 'No hay citas hoy',
  'dash.moreAppointments': 'citas',
  'dash.weekRevenue': 'Ingresos semanales',
  'dash.needsAttention': 'Requiere atención',
  'dash.unreadMessages': 'mensajes no leídos',
  'dash.lowStock': 'stock bajo',
  'dash.topClients': 'Top clientes (mes)',
  'dash.noPaymentsThisMonth': 'Sin pagos este mes',
  'dash.birthdays': 'Cumpleaños',
  'dash.noBirthdaysThisWeek': 'Sin cumpleaños esta semana',
  'dash.today': '¡Hoy!',
  'dash.tomorrow': 'Mañana',
  'dash.inDays': 'En {n} días',
  'dash.congratulate': 'Felicitar',
  'dash.atRisk': 'En riesgo de pérdida',
  'dash.allClientsActive': 'Todos los clientes están activos',
  'dash.daysWithoutVisit': 'días sin visita',
  'dash.write': 'Escribir',
  'dash.todayOrderSales': 'Ventas de productos',
  'dash.serviceSales': 'Ventas de servicios',
  'dash.appointmentsToday': 'citas hoy',
  'dash.ordersToday': 'pedidos hoy',
  'dash.activeOrders': 'activos',
  'dash.recentOrders': 'Pedidos recientes',
  'dash.allOrders': 'Todos los pedidos',
  'dash.items': 'artículos',
  'dash.statusWaiting': 'Esperando',
  'dash.statusConfirmed': 'Completado',
  'dash.statusArrived': 'Llegó',
  'dash.statusNoShow': 'No vino',
  'dash.dowSun': 'Do', 'dash.dowMon': 'Lu', 'dash.dowTue': 'Ma',
  'dash.dowWed': 'Mi', 'dash.dowThu': 'Ju', 'dash.dowFri': 'Vi', 'dash.dowSat': 'Sá',

  // ── Profile modal ──
  'profile.title': 'Perfil',
  'profile.name': 'Nombre',
  'profile.namePlaceholder': 'Su nombre',
  'profile.email': 'Email',
  'profile.changePassword': 'Cambiar contraseña',
  'profile.passwordHint': 'Deje los campos vacíos si no desea cambiar la contraseña',
  'profile.currentPassword': 'Contraseña actual',
  'profile.newPassword': 'Nueva contraseña',
  'profile.newPasswordPlaceholder': 'Mínimo 6 caracteres',
  'profile.confirmPassword': 'Confirmar contraseña',
  'profile.confirmPasswordPlaceholder': 'Repita la nueva contraseña',
  'profile.saved': '¡Guardado!',
  'profile.passwordChanged': 'Contraseña cambiada',
  'profile.homePage': 'Página de inicio',
  'profile.startingLocation': 'Ubicación inicial',
  'profile.startingLocationAuto': 'Automática (por defecto)',
  'profile.homeBizMonitor': 'Monitor de Negocio',
  'profile.homeDashboard': 'Panel',
  'profile.homeCalendar': 'Calendario',
  'profile.homeClients': 'Clientes',
  'profile.homePos': 'Tienda',
  'profile.homeOrders': 'Pedidos',
  'profile.homeFinances': 'Finanzas',
  'profile.homeCommunication': 'Mensajes',
  'profile.homeStaff': 'Personal',
  'profile.homeStock': 'Inventario',
  'profile.homePurchases': 'Compras',
  'profile.homeProduction': 'Producción',
  'profile.homeSalary': 'Nóminas',
  'profile.homeCashRegister': 'Caja',
  'profile.homeReports': 'Informes',
  'profile.homeFinResult': 'Resultado financiero',
  'profile.profileUpdated': 'Perfil actualizado',
  'profile.errorEnterName': 'Ingrese su nombre',
  'profile.errorEnterCurrentPassword': 'Ingrese la contraseña actual',
  'profile.errorMinPassword': 'La nueva contraseña debe tener al menos 6 caracteres',
  'profile.errorPasswordMismatch': 'Las contraseñas no coinciden',
  'profile.errorWrongPassword': 'Contraseña actual incorrecta',
  'profile.errorTooMany': 'Demasiados intentos. Intente más tarde.',
  'profile.errorGeneric': 'Error: ',

  // ── Calendar page ──
  'cal.monthGen.0': 'de enero', 'cal.monthGen.1': 'de febrero', 'cal.monthGen.2': 'de marzo',
  'cal.monthGen.3': 'de abril', 'cal.monthGen.4': 'de mayo', 'cal.monthGen.5': 'de junio',
  'cal.monthGen.6': 'de julio', 'cal.monthGen.7': 'de agosto', 'cal.monthGen.8': 'de septiembre',
  'cal.monthGen.9': 'de octubre', 'cal.monthGen.10': 'de noviembre', 'cal.monthGen.11': 'de diciembre',
  'cal.weekday.0': 'Domingo', 'cal.weekday.1': 'Lunes', 'cal.weekday.2': 'Martes',
  'cal.weekday.3': 'Miércoles', 'cal.weekday.4': 'Jueves', 'cal.weekday.5': 'Viernes', 'cal.weekday.6': 'Sábado',
  'cal.today': 'Hoy',
  'cal.daySchedule': 'Horario del día',
  'cal.appointments': 'citas',
  'cal.working': 'Trabaja',
  'cal.dayOff': 'Día libre',
  'cal.noStaffWorking': 'No hay empleados trabajando este día',
  'cal.clickToAdd': 'Haga clic en la hora para agregar una cita',
  'cal.service': 'Servicio',
  'cal.paid': 'Pagado',
  'cal.unpaid': 'No pagado',
  'cal.batchBooking': 'Reserva múltiple',
  'cal.batchCreated': 'Citas creadas',
  'cal.fiscalReceiptCreated': 'Recibo fiscal creado',
  'cal.fiscalReceiptError': 'Error de fiscalización',
  'cal.refundRecorded': 'Reembolso registrado',
  'cal.cannotDeletePaid': 'No se puede eliminar una cita pagada. Primero haga un reembolso.',

  // ── Appointment modal ──
  'apt.newTitle': 'Nueva cita',
  'apt.editTitle': 'Editar cita',
  'apt.closeEsc': 'Cerrar (Esc)',
  'apt.client': 'Cliente',
  'apt.nameOrPhone': 'Nombre o teléfono',
  'apt.startTyping': 'Empiece a escribir...',
  'apt.phone': 'Teléfono',
  'apt.viewProfile': 'Ir al perfil',
  'apt.dateAndTime': 'Fecha y hora',
  'apt.date': 'Fecha',
  'apt.startTime': 'Inicio',
  'apt.endTime': 'Fin',
  'apt.servicesAndPayment': 'Servicios y pago',
  'apt.pricelist': 'Tarifa',
  'apt.addService': 'Agregar servicio',
  'apt.standardPrice': 'Precio estándar',
  'apt.tariffPlan': 'Plan tarifario',
  'apt.min': 'min',
  'apt.discount': 'Descuento',
  'apt.uah': 'UAH',
  'apt.total': 'Total',
  'apt.toPay': 'A pagar',
  'apt.paymentMethod': 'Método de pago',
  'apt.cash': 'Efectivo',
  'apt.terminal': 'Terminal',
  'apt.transfer': 'Transferencia',
  'apt.paid': 'Pagado',
  'apt.clientGave': 'El cliente dio',
  'apt.change': 'Cambio',
  'apt.note': 'Nota',
  'apt.author': 'Autor',
  'apt.notePlaceholder': 'Comentario de la cita...',
  'apt.notesPlaceholder': 'Comentario de la cita...',
  'apt.book': 'Reservar',
  'apt.saveChanges': 'Guardar cambios',
  'apt.cancel': 'Cancelar',
  'apt.delete': 'Eliminar',
  'apt.printBill': 'Presupuesto',
  'apt.deleteTitle': '¿Eliminar cita?',
  'apt.deleteMessage': 'Está a punto de eliminar esta cita. Esta acción no se puede deshacer.',
  'apt.payBtn': 'Pagar',
  'apt.confirmPayment': '¿Confirmar pago?',
  'apt.refund': 'Reembolso',
  'apt.refundTitle': 'Reembolso',
  'apt.refundMessage': '¿Está seguro de que desea reembolsar esta cita?',
  'apt.refundWarning': 'Esta acción no se puede deshacer.',
  'apt.confirmRefund': 'Confirmar reembolso',
  'apt.refunded': 'Reembolsado',
  'apt.back': 'Atrás',
  'apt.batchBooking': 'Reserva múltiple',
  'apt.createMultiple': 'Crear varias',
  'apt.materials': 'Materiales',
  'apt.product': 'Producto',
  'apt.qty': 'Cant.',
  'apt.pcs': 'uds',
  'apt.add': 'Agregar',
  'apt.noProductsAdded': 'No se han agregado productos',
  'apt.noProductsInStock': 'No hay productos en stock',
  'apt.notEnough': 'Insuficiente',
  'apt.notEnoughInStock': 'Insuficiente en stock',
  'apt.notEnoughStock': 'Stock insuficiente',
  'apt.appointmentNote': 'Nota de la cita',
  'apt.clientDocs': 'Documentos del cliente',
  'apt.addDocument': 'Agregar documento',
  'apt.docName': 'Nombre del documento',
  'apt.docNamePlaceholder': 'Ingrese el nombre...',
  'apt.docText': 'Texto del documento',
  'apt.noDocsYet': 'Aún no hay documentos',
  'apt.attachFile': 'Adjuntar archivo',
  'apt.maxFileSize': 'Tamaño máx. de archivo: 2 MB',
  'apt.errClientName': 'Ingrese el nombre del cliente',
  'apt.errClientPhone': 'Ingrese el teléfono del cliente',
  'apt.errDate': 'Seleccione una fecha',
  'apt.errDiscount': 'El descuento no puede superar el importe',
  'apt.errDayOff': 'El especialista no trabaja este día',
  'apt.errOutsideWorkingHours': 'El horario está fuera del horario laboral ({start} – {end})',
  'apt.errOverlap': 'El horario se superpone con la cita {start}–{end} ({client})',
  'apt.workingHoursHint': 'Horario laboral: {start} – {end}',
  'apt.statusWaiting': 'Esperando',
  'apt.statusConfirmed': 'Completado',
  'apt.statusArrived': 'Llegó',
  'apt.statusNoShow': 'No vino',

  // ── Batch appointment modal ──
  'batchApt.title': 'Reserva múltiple',
  'batchApt.subtitle': 'Creación de varias citas a la vez',
  'batchApt.closeEsc': 'Cerrar (Esc)',
  'batchApt.client': 'Cliente',
  'batchApt.nameOrPhone': 'Nombre o teléfono',
  'batchApt.phone': 'Teléfono',
  'batchApt.staffMember': 'Especialista',
  'batchApt.service': 'Servicio',
  'batchApt.discount': 'Descuento',
  'batchApt.uah': 'UAH',
  'batchApt.addDate': 'Agregar fecha',
  'batchApt.delete': 'Eliminar',
  'batchApt.entries': 'citas',
  'batchApt.entrySingle': 'cita',
  'batchApt.entryPlural': 'citas',
  'batchApt.create': 'Crear',
  'batchApt.cancel': 'Cancelar',
  'batchApt.errClientName': 'Ingrese el nombre del cliente',
  'batchApt.errClientPhone': 'Ingrese el teléfono del cliente',
  'batchApt.errDiscount': 'El descuento no puede superar el importe',
  'batchApt.errNoRows': 'Agregue al menos una cita',

  // ── Customer card ──
  'custCard.edit': 'Editar',
  'custCard.delete': 'Eliminar',
  'custCard.book': 'Reservar',
  'custCard.order': 'Pedido',
  'custCard.sell': 'Vender',
  'custCard.sellProduct': 'Producto',
  'custCard.sellService': 'Servicio',
  'custCard.sellSubscription': 'Abono',
  'custCard.openFinances': 'Finanzas',
  'custCard.paid': 'Pagado',
  'custCard.sold': 'Vendido',
  'custCard.balance': 'Saldo',
  'custCard.importance': 'Importancia',
  'custCard.forbidOnlineBooking': 'Reserva online prohibida',

  // ── Customer grid ──
  'custGrid.noCustomersFound': 'No se encontraron clientes',
  'custGrid.tryChangeSearch': 'Intente cambiar la consulta de búsqueda o el filtro de categoría',

  // ── Customer modal ──
  'custModal.newCustomer': 'Nuevo cliente',
  'custModal.editCustomer': 'Editar cliente',
  'custModal.closeEsc': 'Cerrar (Esc)',
  'custModal.tabMain': 'Principal',
  'custModal.tabDetails': 'Detalles',
  'custModal.tabVisits': 'Visitas',
  'custModal.tabFinancial': 'Finanzas',
  'custModal.tabAnalytics': 'Analítica',
  'custModal.tabNotes': 'Notas',
  'custModal.tabDocuments': 'Documentos',
  'custModal.personalData': 'Datos personales',
  'custModal.fullName': 'Nombre y apellido',
  'custModal.fullNamePlaceholder': 'Ingrese el nombre completo',
  'custModal.mobilePhone': 'Teléfono móvil',
  'custModal.additionalPhone': 'Teléfono adicional',
  'custModal.birthDate': 'Fecha de nacimiento',
  'custModal.day': 'Día',
  'custModal.month': 'Mes',
  'custModal.year': 'Año',
  'custModal.gender': 'Género',
  'custModal.genderMale': 'Masculino',
  'custModal.genderFemale': 'Femenino',
  'custModal.genderOther': 'Otro',
  'custModal.cardNumber': 'Número de tarjeta',
  'custModal.profilePhoto': 'Foto de perfil',
  'custModal.uploadPhoto': 'Subir foto',
  'custModal.changePhoto': 'Cambiar foto',
  'custModal.deletePhoto': 'Eliminar foto',
  'custModal.avatar': 'Avatar',
  'custModal.categoryAndClassification': 'Categoría y clasificación',
  'custModal.category': 'Categoría',
  'custModal.importanceLabel': 'Importancia',
  'custModal.discountLabel': 'Descuento',
  'custModal.discountRange': '0–100%',
    'custModal.referral': 'Referral program',
  'custModal.referredBy': 'Referred by',
  'custModal.referredByHint': 'Select the client who referred this person',
'custModal.restrictions': 'Restricciones',
  'custModal.forbidOnlineBooking': 'Prohibir reserva online',
  'custModal.forbidOnlineBookingDesc': 'El cliente no podrá reservar por su cuenta',
  'custModal.telegramReminders': 'Recordatorios Telegram',
  'custModal.telegramConnected': 'Telegram conectado',
  'custModal.setupTelegramBot': 'Configure el bot de Telegram',
  'custModal.sendLinkToCustomer': 'Enviar enlace al cliente',
  'custModal.send': 'Enviar',
  'custModal.sending': 'Enviando...',
  'custModal.specifyPhoneFirst': 'Especifique el teléfono primero',
  'custModal.save': 'Guardar',
  'custModal.cancel': 'Cancelar',
  'custModal.close': 'Cerrar',
  'custModal.editBtn': 'Editar',
  'custModal.viewCustomer': 'Ficha del cliente',
  'custModal.back': 'Atrás',
  'custModal.next': 'Siguiente',
  'custModal.nameRequired': 'El nombre es obligatorio',
  'custModal.phoneRequired': 'El teléfono es obligatorio',
  'custModal.nameDuplicate': 'Ya existe un cliente con este nombre',
  'custModal.phoneDuplicate': 'Ya existe un cliente con este número de teléfono',
  'custModal.note': 'Nota',
  'custModal.notePlaceholder': 'Agregar nota...',
  'custModal.comments': 'Comentarios',
  'custModal.commentsPlaceholder': 'Escribir comentario...',
  'custModal.writeMessagePlaceholder': 'Escribir mensaje...',
  // Customer modal — visits tab
  'custModal.visitHistory': 'Historial de visitas',
  'custModal.totalVisits': 'Total de visitas',
  'custModal.lastVisit': 'Última visita',
  'custModal.visitFrequency': 'Frecuencia de visitas',
  'custModal.days': 'días',
  'custModal.visitsByMonth': 'Visitas por mes',
  'custModal.noVisitsYet': 'Aún no hay visitas',
  'custModal.tabOrders': 'Compras',
  'custModal.orderHistory': 'Historial de pedidos',
  'custModal.ordersTotal': 'Pedidos',
  'custModal.ordersDelivered': 'Entregados',
  'custModal.ordersPaid': 'Pagado',
  'custModal.noOrdersYet': 'Aún no hay compras',
  'custModal.posSalesCount': 'Ventas',
  'custModal.orderStatusNew': 'Nuevo',
  'custModal.orderStatusConfirmed': 'Confirmado',
  'custModal.orderStatusPacked': 'Empaquetado',
  'custModal.orderStatusShipped': 'Enviado',
  'custModal.orderStatusDelivered': 'Entregado',
  'custModal.orderStatusCancelled': 'Cancelado',
  'custModal.posCompleted': 'Completado',
  'custModal.posSourceLabel': 'Tienda',
  'custModal.orderSourceLabel': 'Pedido',
  'custModal.subscriptionsLabel': 'Suscripciones',
  'custModal.completed': 'Completado',
  'custModal.noShow': 'No vino',
  'custModal.statusWaiting': 'Esperando',
  'custModal.statusConfirmed': 'Completado',
  'custModal.statusArrived': 'Llegó',
  'custModal.statusNoShow': 'No vino',
  // Customer modal — financial tab
  'custModal.financialIndicators': 'Indicadores financieros',
  'custModal.finPaid': 'Pagado',
  'custModal.finBalance': 'Saldo',
  'custModal.avgCheck': 'Ticket medio',
  'custModal.ltv': 'LTV',
  'custModal.charges': 'Cargos',
  'custModal.noChargesYet': 'Aún no hay cargos',
  'custModal.noPaymentsYet': 'Aún no hay pagos',
  'custModal.date': 'Fecha',
  'custModal.dateTime': 'Fecha/hora',
  'custModal.service': 'Servicio',
  'custModal.serviceLabel': 'Servicio',
  'custModal.price': 'Precio',
  'custModal.discount': 'Descuento',
  'custModal.total': 'Total',
  'custModal.paidLabel': 'Pago',
  'custModal.payment': 'Pago',
  'custModal.paymentMethod': 'Método de pago',
  'custModal.amount': 'Importe',
  'custModal.totalAmount': 'Importe total',
  'custModal.methodCash': 'Efectivo',
  'custModal.methodCard': 'Tarjeta',
  'custModal.methodTransfer': 'Transferencia',
  'custModal.cash': 'Efectivo',
  'custModal.terminal': 'Terminal',
  'custModal.transfer': 'Transferencia',
  'custModal.online': 'Online',
  'custModal.refund': 'Reembolso',
  'custModal.sold': 'Vendido',
  'custModal.finCharged': 'Cobrado',
  'custModal.serviceCharges': 'Cargos por servicios',
  'custModal.productCharges': 'Cargos por productos',
  'custModal.productLabel': 'Producto',
  'custModal.noProductChargesYet': 'Aún no hay ventas de productos',
  'custModal.time': 'Hora',
  'custModal.unknown': 'Desconocido',
  // Customer modal — analytics tab
  'custModal.favoriteMaster': 'Especialista favorito',
  'custModal.favoriteService': 'Servicio favorito',
  'custModal.favoriteProduct': 'Producto favorito',
  'custModal.lastActivity': 'Última actividad',
  'custModal.spendingBreakdown': 'Desglose de gastos',
  'custModal.purchasesByMonth': 'Compras por mes',
  'custModal.churn_low': 'Cliente activo',
  'custModal.churn_medium': 'Riesgo de abandono — no ha visitado en un tiempo',
  'custModal.churn_high': 'Alto riesgo de abandono — contacto necesario',
  // Customer modal — documents tab
  'custModal.customerDocuments': 'Documentos del cliente',
  'custModal.addDocument': 'Agregar documento',
  'custModal.addDoc': 'Agregar',
  'custModal.addBtn': 'Agregar',
  'custModal.noDocumentsYet': 'Aún no hay documentos',
  'custModal.docName': 'Nombre del documento',
  'custModal.docNamePlaceholder': 'Ingrese el nombre...',
  'custModal.docNameRequired': 'Ingrese el nombre del documento',
  'custModal.docText': 'Texto del documento',
  'custModal.docTextPlaceholder': 'Ingrese el texto...',
  'custModal.attachFile': 'Adjuntar archivo',
  'custModal.fileUpTo2MB': 'Archivo hasta 2 MB',
  'custModal.fileTooLarge': 'El archivo es demasiado grande (máx. 2 MB)',
  'custModal.emptyDocument': 'Documento vacío',
  'custModal.deleteDoc': 'Eliminar documento',
  'custModal.deleteThisDoc': '¿Eliminar este documento?',
  'custModal.deleteBtn': 'Eliminar',
  'custModal.download': 'Descargar',
  'custModal.copy': 'Copiar',
  'custModal.specifyPhoneForDocs': 'Especifique el teléfono para documentos',
  'custModal.loading': 'Cargando...',
  'custModal.error': 'Error',
  // Customer modal — month abbreviations
  'custModal.monthJan': 'Enero', 'custModal.monthFeb': 'Febrero', 'custModal.monthMar': 'Marzo',
  'custModal.monthApr': 'Abril', 'custModal.monthMay': 'Mayo', 'custModal.monthJun': 'Junio',
  'custModal.monthJul': 'Julio', 'custModal.monthAug': 'Agosto', 'custModal.monthSep': 'Septiembre',
  'custModal.monthOct': 'Octubre', 'custModal.monthNov': 'Noviembre', 'custModal.monthDec': 'Diciembre',
  'custModal.monthAbbrJan': 'Ene', 'custModal.monthAbbrFeb': 'Feb', 'custModal.monthAbbrMar': 'Mar',
  'custModal.monthAbbrApr': 'Abr', 'custModal.monthAbbrMay': 'May', 'custModal.monthAbbrJun': 'Jun',
  'custModal.monthAbbrJul': 'Jul', 'custModal.monthAbbrAug': 'Ago', 'custModal.monthAbbrSep': 'Sep',
  'custModal.monthAbbrOct': 'Oct', 'custModal.monthAbbrNov': 'Nov', 'custModal.monthAbbrDec': 'Dic',
  'custModal.monthShortJan': 'Ene', 'custModal.monthShortFeb': 'Feb', 'custModal.monthShortMar': 'Mar',
  'custModal.monthShortApr': 'Abr', 'custModal.monthShortMay': 'May', 'custModal.monthShortJun': 'Jun',
  'custModal.monthShortJul': 'Jul', 'custModal.monthShortAug': 'Ago', 'custModal.monthShortSep': 'Sep',
  'custModal.monthShortOct': 'Oct', 'custModal.monthShortNov': 'Nov', 'custModal.monthShortDec': 'Dic',

  // ── Categories page ──
  'categories.title': 'Categorías de clientes',
  'categories.subtitle': 'Gestión de categorías y niveles de importancia',
  'categories.categoriesTab': 'Categorías',
  'categories.importanceTab': 'Importancia',
  'categories.categoriesDesc': 'Agrupe clientes por tipos',
  'categories.importanceDesc': 'Defina niveles de importancia de clientes',
  'categories.addCategory': 'Agregar categoría',
  'categories.newCategory': 'Nueva categoría',
  'categories.editCategory': 'Editar categoría',
  'categories.noCategories': 'Aún no hay categorías',
  'categories.categoryName': 'Nombre de categoría',
  'categories.name': 'Nombre',
  'categories.namePlaceholder': 'Ingrese el nombre...',
  'categories.nameDuplicate': 'Ya existe una categoría con este nombre',
  'categories.importanceDuplicate': 'Ya existe un nivel de importancia con este nombre',
  'categories.icon': 'Icono',
  'categories.changeIcon': 'Cambiar icono',
  'categories.chooseIcon': 'Elija un icono',
  'categories.color': 'Color',
  'categories.bgColor': 'Color de fondo',
  'categories.textColor': 'Color del texto',
  'categories.borderColor': 'Color del borde',
  'categories.indicatorColor': 'Color del indicador',
  'categories.preview': 'Vista previa',
  'categories.save': 'Guardar',
  'categories.cancel': 'Cancelar',
  'categories.delete': 'Eliminar',
  'categories.edit': 'Editar',
  'categories.add': 'Agregar',
  'categories.confirmDelete': '¿Está seguro de que desea eliminar?',
  'categories.hasCustomersBlocked': 'Esta categoría tiene clientes y no puede ser eliminada',
  'categories.yes': 'Sí',
  'categories.no': 'No',
  'categories.addLevel': 'Agregar nivel',
  'categories.newImportanceLevel': 'Nuevo nivel de importancia',
  'categories.editLevel': 'Editar nivel',
  'categories.noImportanceLevels': 'Aún no hay niveles de importancia',
  'categories.levelName': 'Nombre del nivel',
  'categories.levelPlaceholder': 'Ingrese el nombre del nivel...',
  'categories.iconBusiness': 'Negocios',
  'categories.iconClients': 'Clientes',
  'categories.iconNature': 'Naturaleza',
  'categories.iconOther': 'Otros',
  'categories.iconStatus': 'Estado',
  'categories.iconSymbols': 'Símbolos',

  // ── Staff page ──
  'staff.title': 'Empleados',
  'staff.subtitle': 'Gestión de personal',
  'staff.addStaff': 'Agregar empleado',
  'staff.searchPlaceholder': 'Buscar por nombre, cargo, teléfono...',
  'staff.activeStaff': 'Activos',
  'staff.activeStaffDesc': 'empleados',
  'staff.statusActive': 'Activo (mostrar en calendario)',
  'staff.statusActiveHidden': 'Activo (ocultar del calendario)',
  'staff.statusDismissed': 'Despedido',
  'staff.shown': 'Mostrado',
  'staff.of': 'de',
  'staff.total': 'total',
  'staff.notFound': 'No se encontraron empleados',
  'staff.notFoundHint': 'Intente cambiar la consulta de búsqueda',
  'staff.newStaff': 'Nuevo empleado',
  'staff.editStaff': 'Editar empleado',
  'staff.closeEsc': 'Cerrar (Esc)',
  'staff.tabMain': 'Principal',
  'staff.tabDetails': 'Detalles',
  'staff.tabServices': 'Servicios',
  'staff.tabSchedule': 'Horario',
  'staff.personalData': 'Datos personales',
  'staff.fullName': 'Nombre completo',
  'staff.fullNamePlaceholder': 'Ingrese el nombre completo',
  'staff.nameRequired': 'El nombre es obligatorio',
  'staff.nameDuplicate': 'Ya existe un empleado con este nombre',
  'staff.phoneDuplicate': 'Ya existe un empleado con este número de teléfono',
  'staff.phone': 'Teléfono',
  'staff.position': 'Cargo',
  'staff.positionPlaceholder': 'Ingrese el cargo...',
  'staff.status': 'Estado',
  'staff.active': 'Activo',
  'staff.profilePhoto': 'Foto de perfil',
  'staff.uploadPhoto': 'Subir foto',
  'staff.changePhoto': 'Cambiar foto',
  'staff.avatar': 'Avatar',
  'staff.avatarColor': 'Color del avatar',
  'staff.birthDate': 'Fecha de nacimiento',
  'staff.day': 'Día',
  'staff.month': 'Mes',
  'staff.year': 'Año',
  'staff.address': 'Dirección',
  'staff.addressPlaceholder': 'Ingrese la dirección...',
  'staff.note': 'Nota',
  'staff.notePlaceholder': 'Agregar nota...',
  'staff.salaryScheme': 'Esquema de nómina',
  'staff.notSelected': 'No seleccionado',
  'staff.locations': 'Ubicaciones',
  'staff.servicesEmpty': 'No hay servicios asignados',
  'staff.servicesHint': 'Seleccione los servicios que presta este empleado',
  'staff.priceUah': 'Precio (UAH)',
  'staff.uah': 'UAH',
  'staff.min': 'min',
  'staff.mins': 'min',
  'staff.workSchedule': 'Horario de trabajo',
  'staff.dayOff': 'Día libre',
  'staff.save': 'Guardar',
  'staff.saveChanges': 'Guardar cambios',
  'staff.cancel': 'Cancelar',
  'staff.back': 'Atrás',
  'staff.next': 'Siguiente',
  'staff.add': 'Agregar',
  'staff.edit': 'Editar',
  'staff.delete': 'Eliminar',
  'staff.deleteConfirmTitle': '¿Eliminar empleado?',
  'staff.deleteForever': 'Eliminar definitivamente',
  'staff.hasAppointments': 'El empleado tiene citas y no puede ser eliminado',
  'staff.understood': 'Entendido',
  'staff.scheduleConflict': 'Conflicto de horario',
  'staff.dayMon': 'Lu', 'staff.dayTue': 'Ma', 'staff.dayWed': 'Mi',
  'staff.dayThu': 'Ju', 'staff.dayFri': 'Vi', 'staff.daySat': 'Sá', 'staff.daySun': 'Do',
  'staff.monthJan': 'Enero', 'staff.monthFeb': 'Febrero', 'staff.monthMar': 'Marzo',
  'staff.monthApr': 'Abril', 'staff.monthMay': 'Mayo', 'staff.monthJun': 'Junio',
  'staff.monthJul': 'Julio', 'staff.monthAug': 'Agosto', 'staff.monthSep': 'Septiembre',
  'staff.monthOct': 'Octubre', 'staff.monthNov': 'Noviembre', 'staff.monthDec': 'Diciembre',

  // ── Schedule page ──
  'schedule.title': 'Horario de trabajo',
  'schedule.subtitle': 'Gestión del horario de trabajo de empleados',
  'schedule.active': 'Activos',
  'schedule.inactive': 'Inactivos',
  'schedule.staffMember': 'Empleado',
  'schedule.hrsPerWeek': 'H/sem',
  'schedule.prevWeek': '← Semana anterior',
  'schedule.nextWeek': 'Semana siguiente →',
  'schedule.current': 'Actual',
  'schedule.working': 'Trabaja',
  'schedule.dayOff': 'Día libre',
  'schedule.noActiveStaff': 'No hay empleados activos',
  'schedule.noActiveStaffHint': 'Agregue empleados en la sección "Personal"',
  'schedule.scheduleSettings': 'Configuración del horario',
  'schedule.dayType': 'Tipo de día',
  'schedule.workDay': 'Día laborable',
  'schedule.workHours': 'Horas de trabajo',
  'schedule.breaks': 'Descansos',
  'schedule.noBreaks': 'Sin descansos',
  'schedule.oneBreak': '1 descanso',
  'schedule.nBreaks': 'descansos',
  'schedule.addBreak': 'Agregar descanso',
  'schedule.deleteBreak': 'Eliminar descanso',
  'schedule.save': 'Guardar',
  'schedule.cancel': 'Cancelar',
  'schedule.apply': 'Aplicar',
  'schedule.vacation': 'Vacaciones',
  'schedule.sickLeave': 'Baja médica',
  'schedule.repeat1': '2 semanas (1 ciclo)',
  'schedule.repeatN': '{n} semanas',
  'schedule.repeatWeekly': 'Semanal (año)',
  'schedule.templateAppliedWeeks': 'Plantilla aplicada para {n} semanas',
  'schedule.scheduleTemplate': 'Plantilla de horario',
  'schedule.noTemplate': 'Sin plantilla',
  'schedule.saveTwoWeeksTemplate': 'Guardar como plantilla (2 semanas)',
  'schedule.templateDuplicate': 'A template with this name already exists',
  'schedule.templateNamePlaceholder': 'Nombre de la plantilla...',
  'schedule.scheduleConflict': 'Conflicto de horario',
  'schedule.appointmentConflict': 'No se puede cambiar el horario: cita a las {time} ({count} en total) fuera del nuevo horario laboral',
  'schedule.h': 'h',
  'schedule.hrs': 'h',
  'schedule.min': 'min',
  'schedule.dayMonFull': 'Lunes', 'schedule.dayTueFull': 'Martes', 'schedule.dayWedFull': 'Miércoles',
  'schedule.dayThuFull': 'Jueves', 'schedule.dayFriFull': 'Viernes', 'schedule.daySatFull': 'Sábado', 'schedule.daySunFull': 'Domingo',
  'schedule.dayMon': 'Lu', 'schedule.dayTue': 'Ma', 'schedule.dayWed': 'Mi',
  'schedule.dayThu': 'Ju', 'schedule.dayFri': 'Vi', 'schedule.daySat': 'Sá', 'schedule.daySun': 'Do',

  // ── Schedule templates page ──
  'schedTpl.title': 'Plantillas de horarios',
  'schedTpl.subtitle': 'Cree y gestione plantillas de horarios de trabajo',
  'schedTpl.templates': 'Plantillas',
  'schedTpl.newTemplate': 'Nueva plantilla',
  'schedTpl.noTemplates': 'Aún no hay plantillas',
  'schedTpl.noTemplatesHint': 'Cree una plantilla de horario para aplicarla rápidamente',
  'schedTpl.templateSettings': 'Configuración de la plantilla',
  'schedTpl.templateNamePlaceholder': 'Nombre de la plantilla...',
  'schedTpl.dayType': 'Tipo de día',
  'schedTpl.workDay': 'Día laborable',
  'schedTpl.dayOff': 'Día libre',
  'schedTpl.vacation': 'Vacaciones',
  'schedTpl.sickLeave': 'Baja médica',
  'schedTpl.workHours': 'Horas de trabajo',
  'schedTpl.breaks': 'Descansos',
  'schedTpl.noBreaks': 'Sin descansos',
  'schedTpl.addBreak': 'Agregar descanso',
  'schedTpl.save': 'Guardar',
  'schedTpl.cancel': 'Cancelar',
  'schedTpl.create': 'Crear',
  'schedTpl.delete': 'Eliminar',
  'schedTpl.rename': 'Renombrar',
  'schedTpl.deleteTitle': '¿Eliminar plantilla?',
  'schedTpl.deleteMessage': 'Está a punto de eliminar esta plantilla. Esta acción no se puede deshacer.',
  'schedTpl.hPerWeek': 'h/sem',
  'schedTpl.hrs': 'h',
  'schedTpl.min': 'min',
  'schedTpl.workShort': 'Lab',
  'schedTpl.offShort': 'Lib',
  'schedTpl.week1': 'Semana 1',
  'schedTpl.week2': 'Semana 2',
  'schedTpl.dayMonFull': 'Lunes', 'schedTpl.dayTueFull': 'Martes', 'schedTpl.dayWedFull': 'Miércoles',
  'schedTpl.dayThuFull': 'Jueves', 'schedTpl.dayFriFull': 'Viernes', 'schedTpl.daySatFull': 'Sábado', 'schedTpl.daySunFull': 'Domingo',
  'schedTpl.dayMon': 'Lu', 'schedTpl.dayTue': 'Ma', 'schedTpl.dayWed': 'Mi',
  'schedTpl.dayThu': 'Ju', 'schedTpl.dayFri': 'Vi', 'schedTpl.daySat': 'Sá', 'schedTpl.daySun': 'Do',

  // ── Services page ──
  'services.title': 'Servicios',
  'services.subtitle': 'Catálogo de servicios',
  'services.servicesCount': 'Servicios',
  'services.groups': 'Grupos',
  'services.addService': 'Agregar servicio',
  'services.newGroup': 'Nuevo grupo',
  'services.emptyCatalog': 'El catálogo de servicios está vacío',
  'services.emptyCatalogHint': 'Agregue un grupo y servicios',
  'services.noServicesInGroup': 'No hay servicios en este grupo',
  'services.serviceName': 'Nombre del servicio',
  'services.durationMin': 'Duración (min)',
  'services.durationMinError': 'La duración debe ser mayor que 0',
  'services.priceUah': 'Precio (UAH)',
  'services.priceNegativeError': 'El precio no puede ser negativo',
  'services.nameDuplicate': 'Ya existe un servicio con este nombre',
  'services.groupDuplicate': 'Ya existe un grupo con este nombre',
  'services.min': 'min',
  'services.uah': 'UAH',
  'services.save': 'Guardar',
  'services.cancel': 'Cancelar',
  'services.edit': 'Editar',
  'services.delete': 'Eliminar',
  'services.renameGroup': 'Renombrar grupo',
  'services.deleteGroup': 'Eliminar grupo',
  'services.deleteGroupTitle': '¿Eliminar grupo?',
  'services.deleteGroupMessage': 'Todos los servicios de este grupo también serán eliminados.',
  'services.deleteServiceTitle': '¿Eliminar servicio?',
  'services.deleteServiceMessage': 'Esta acción no se puede deshacer.',
  'services.cannotDelete': 'No se puede eliminar',
  'services.serviceHasAppointments': 'Este servicio tiene citas y no puede ser eliminado',
  'services.groupHasAppointments': 'Este grupo tiene servicios con citas y no puede ser eliminado',
  'services.cannotDeleteGroupHasServices': 'Primero mueve o elimina los servicios de este grupo',
  'services.deleteError': 'Error al eliminar',
  'services.understood': 'Entendido',

  // ── Tariff plans page ──
  'tariffs.title': 'Planes tarifarios',
  'tariffs.subtitle': 'Gestión de planes tarifarios',
  'tariffs.tariffsCount': 'Tarifas',
  'tariffs.addTariff': 'Agregar tarifa',
  'tariffs.noTariffs': 'No hay planes tarifarios',
  'tariffs.newTariffPlan': 'Nuevo plan tarifario',
  'tariffs.editTariff': 'Editar tarifa',
  'tariffs.tariffName': 'Nombre de la tarifa',
  'tariffs.tariffNamePlaceholder': 'Ingrese el nombre de la tarifa...',
  'tariffs.nameDuplicate': 'Ya existe una tarifa con este nombre',
  'tariffs.tariffType': 'Tipo de tarifa',
  'tariffs.discount': 'Descuento',
  'tariffs.surcharge': 'Recargo',
  'tariffs.noChange': 'Sin cambios',
  'tariffs.priceModifierPercent': 'Modificador de precio (%)',
  'tariffs.percentModifier': '% modificador',
  'tariffs.modifier': 'Modificador',
  'tariffs.modifierHint': 'Valor negativo — descuento, positivo — recargo',
  'tariffs.modifierPlaceholder': 'Por ejemplo: -10 o +15',
  'tariffs.activeCheckbox': 'Activo',
  'tariffs.active': 'Activo',
  'tariffs.inactive': 'Inactivo',
  'tariffs.tabServices': 'Servicios',
  'tariffs.tabProducts': 'Productos',
  'tariffs.servicePrices': 'Precios de servicios',
  'tariffs.customPriceServices': 'Precios individuales de servicios',
  'tariffs.customPriceProducts': 'Precios individuales de productos: {n}',
  'tariffs.productPrices': 'Precios de productos',
  'tariffs.productPricesHint': 'Busque y agregue productos para establecer precios promocionales',
  'tariffs.searchProduct': 'Buscar producto por nombre o referencia...',
  'tariffs.noCategory': 'Sin categoría',
  'tariffs.priceList': 'Lista de precios',
  'tariffs.leaveEmptyDefault': 'Deje vacío para precio estándar',
  'tariffs.uah': 'UAH',
  'tariffs.save': 'Guardar',
  'tariffs.create': 'Crear',
  'tariffs.cancel': 'Cancelar',
  'tariffs.edit': 'Editar',
  'tariffs.delete': 'Eliminar',
  'tariffs.deleteConfirm': '¿Está seguro de que desea eliminar esta tarifa?',
  'tariffs.cannotDelete': 'No se puede eliminar la tarifa',
  'tariffs.appointmentsCount': 'citas',
  'tariffs.ordersCount': 'pedidos',
  'tariffs.yes': 'Sí',
  'tariffs.no': 'No',

  // ── Finances page ──
  'fin.title': 'Operaciones financieras',
  'fin.subtitle': 'Registro de pagos y reembolsos',
  'fin.searchPlaceholder': 'Buscar por cliente, teléfono, servicio...',
  'fin.period': 'Período',
  'fin.today': 'Hoy',
  'fin.week': 'Semana',
  'fin.month': 'Mes',
  'fin.from': 'desde',
  'fin.to': 'hasta',
  'fin.allTime': 'Todo el tiempo',
  'fin.typeLabel': 'Tipo',
  'fin.all': 'Todos',
  'fin.payments': 'Pagos',
  'fin.refunds': 'Reembolsos',
  'fin.type_all': 'Todos',
  'fin.type_payment': 'Pago',
  'fin.type_refund': 'Reembolso',
  'fin.type_product_sale': 'Venta de producto',
  'fin.methodLabel': 'Método de pago',
  'fin.cash': 'Efectivo',
  'fin.terminal': 'Terminal',
  'fin.transfer': 'Transferencia',
  'fin.online': 'Online',
  'fin.total': 'Total',
  'fin.uah': 'UAH',
  'fin.exportExcel': 'Exportar Excel',
  'fin.exportFileName': 'Operaciones_financieras',
  'fin.noOperations': 'No hay operaciones',
  'fin.noOperationsHint': 'Intente cambiar los filtros o el período',
  'fin.colDate': 'Fecha',
  'fin.colClient': 'Cliente',
  'fin.colPhone': 'Teléfono',
  'fin.colService': 'Servicio',
  'fin.colMaster': 'Especialista',
  'fin.colType': 'Tipo',
  'fin.colPayMethod': 'Método de pago',
  'fin.colMethod': 'Método',
  'fin.colAmount': 'Importe',
  'fin.colSum': 'Importe',
  'fin.colAuthor': 'Autor',
  'fin.colReceipt': 'Recibo',
  'fin.service': 'Servicio',
  'fin.receipt': 'Recibo',
  'fin.receiptNum': 'Recibo N.°',
  'fin.receiptSubtitle': 'Recibo fiscal',
  'fin.receiptDate': 'Fecha',
  'fin.receiptClient': 'Cliente',
  'fin.receiptPhone': 'Teléfono',
  'fin.receiptMaster': 'Especialista',
  'fin.receiptMethod': 'Método de pago',
  'fin.receiptTotal': 'Importe',
  'fin.receiptThanks': '¡Gracias por su visita!',
  'fin.printReceipt': 'Imprimir recibo',
  'fin.fiscalCode': 'Código fiscal',
  'fin.noFiscal': 'Sin fiscalización',
  'fin.retryFiscal': 'Reintentar fiscalización',
  'fin.fiscalRetrySuccess': 'Fiscalización reintentada con éxito',
  'fin.fiscalRetryError': 'Error al reintentar fiscalización',

  // ── Cash register page ──
  'cashReg.title': 'Caja',
  'cashReg.subtitle': 'Gestión de turnos de caja',
  'cashReg.currentShift': 'Turno actual',
  'cashReg.openNewShift': 'Abrir nuevo turno',
  'cashReg.openNewShiftHint': 'El turno no está abierto. Abra un turno para recibir pagos.',
  'cashReg.openingBalance': 'Saldo inicial',
  'cashReg.openingBalanceLabel': 'Saldo inicial de caja',
  'cashReg.openShift': 'Abrir turno',
  'cashReg.closeShift': 'Cerrar turno',
  'cashReg.prro': 'POS',
  'cashReg.processing': 'Procesando...',
  'cashReg.opened': 'Abierto',
  'cashReg.closed': 'Cerrado',
  'cashReg.openedAt': 'Abierto a las',
  'cashReg.openBal': 'Saldo apertura',
  'cashReg.closeBal': 'Saldo cierre',
  'cashReg.revenue': 'Ingresos',
  'cashReg.totalRevenue': 'Ingresos totales',
  'cashReg.operations': 'Operaciones',
  'cashReg.inRegister': 'En caja',
  'cashReg.cash': 'Efectivo',
  'cashReg.terminal': 'Terminal',
  'cashReg.transfer': 'Transferencia',
  'cashReg.uah': 'UAH',
  'cashReg.shift': 'Turno',
  'cashReg.shiftLog': 'Registro de turnos',
  'cashReg.historyEmpty': 'El historial de turnos está vacío',
  'cashReg.historyEmptyHint': 'Aquí aparecerán los turnos cerrados',
  'cashReg.shiftOpened': 'Turno abierto',
  'cashReg.shiftClosed': 'Turno cerrado',
  'cashReg.checkboxNotConfigured': 'Para usar la caja, configure la conexión Checkbox ПРРО en Configuración → Checkbox ПРРО',

  // ── Reports page ──
  'reports.reportType_cash_day': 'Ingresos por período',
  'reports.reportType_work_hours': 'Horas de trabajo',
  'reports.reportType_services_sales': 'Ventas de servicios',
  'reports.reportType_mutual': 'Liquidaciones con clientes',
  'reports.reportType_inventory_flow': 'Flujo de inventario',
  'reports.reportType_client_analytics': 'Analítica de clientes',
  'reports.reportType_staff_revenue': 'Ingresos por empleado',
  'reports.reportType_service_profitability': 'Rentabilidad de servicios',
  'reports.reportType_abc_analysis': 'Análisis ABC de productos',
  'reports.reportType_revenue_dynamics': 'Dinámica de ingresos',
  'reports.reportType_discount_analytics': 'Analítica de descuentos',
  'reports.reportType_purchases_by_supplier': 'Compras por proveedor',
  'reports.reportType_purchase_dynamics': 'Dinámica de compras',
  'reports.reportType_top_purchased_products': 'Top productos comprados',
  'reports.reportType_supplier_price_compare': 'Comparación de precios de proveedores',
  'reports.reportType_product_turnover': 'Rotación de productos',
  'reports.reportType_subscriptions': 'Suscripciones',
  'reports.subsEmpty': 'No hay suscripciones en el período seleccionado',
  'reports.subsAll': 'Todas',
  'reports.subsActive': 'Activas',
  'reports.subsNearExpiry': 'Por vencer',
  'reports.subsNearExpiryHint': 'vencen en <14 días',
  'reports.subsExpired': 'Vencidas',
  'reports.subsUsedUp': 'Usadas',
  'reports.subsRefunded': 'Reembolsadas',
  'reports.subsRevenue': 'Ingresos',
  'reports.subsSold': 'vendidas',
  'reports.subsUnusedVisits': 'Visitas no usadas',
  'reports.subsUnusedHint': 'en activas + vencidas',
  'reports.subsPurchaseDate': 'Fecha de compra',
  'reports.subsPlan': 'Plan',
  'reports.subsBoughtVisits': 'Compradas',
  'reports.subsUsage': 'Uso',
  'reports.subsPaid': 'Pagado',
  'reports.subsValidUntil': 'Válida hasta',
  'reports.subsStatus': 'Estado',
  'reports.reportType_no_shows': 'Análisis de ausencias',
  'reports.nsEmpty': 'No hay citas en el período seleccionado',
  'reports.nsTotal': 'Total de citas',
  'reports.nsNoShow': 'Ausencia',
  'reports.nsCancelled': 'Canceladas',
  'reports.nsLostRevenue': 'Ingresos perdidos',
  'reports.nsRepeatOffenders': 'Reincidentes (≥2 ausencias)',
  'reports.nsByStaff': 'Por personal',
  'reports.nsByService': 'Por servicio (top-15 problemáticos)',
  'reports.nsNoShowPct': '% Ausencia',
  'reports.nsCancelPct': '% Cancelación',
  'reports.nsRepeatOffendersTitle': 'Clientes reincidentes',
  'reports.nsRepeatOffendersHint': '≥2 ausencias en el período',
  'reports.nsLastNoShow': 'Última ausencia',
  'reports.reportType_service_profitability': 'Rentabilidad de servicios',
  'reports.reportType_payment_methods': 'Métodos de pago',
  'reports.reportType_sales_by_channel': 'Ventas por canal',
  'reports.reportType_customer_ltv': 'LTV / Clientes VIP',
  'reports.profitEmpty': 'No hay servicios en el período',
  'reports.profitRevenue': 'Ingresos',
  'reports.profitCost': 'Coste',
  'reports.profitGross': 'Beneficio',
  'reports.profitMargin': 'Margen',
  'reports.profitVisits': 'Visitas',
  'reports.group': 'Grupo',
  'reports.visits': 'Visitas',
  'reports.pmEmpty': 'No hay transacciones en el período',
  'reports.tryChangeDate': 'Pruebe cambiar el período',
  'reports.pmMethod': 'Método',
  'reports.pmCount': 'Transacciones',
  'reports.pmAmount': 'Importe',
  'reports.pmShare': 'Cuota',
  'reports.pmTotalTx': 'Transacciones',
  'reports.pmMethodsCount': 'Métodos usados',
  'reports.pmCash': 'Efectivo',
  'reports.pmTerminal': 'Terminal',
  'reports.pmOnline': 'En línea',
  'reports.pmTransfer': 'Transferencia',
  'reports.pmSubscription': 'Suscripción',
  'reports.pmGiftCard': 'Tarjeta regalo',
  'reports.pmPoints': 'Puntos de fidelidad',
  'reports.pmUnknown': 'Sin especificar',
  'reports.ltvEmpty': 'No hay clientes en el período',
  'reports.ltvCustomers': 'Clientes',
  'reports.ltvTotalRevenue': 'Ingresos totales',
  'reports.ltvAvgTicket': 'Ticket medio',
  'reports.ltvVip': 'Clientes VIP (top 20%)',
  'reports.ltvSleepingVip': 'VIP dormidos',
  'reports.ltvSleepingHint': '>60 días sin visita',
  'reports.ltvTotal': 'Total',
  'reports.ltvLastVisit': 'Última visita',
  'reports.ltvSleepingBadge': '😴 VIP dormido',
  'reports.ltvVipBadge': '👑 VIP',
  'reports.reportType_salary_archive': 'Archivo de salarios',
  'reports.reportType_salary_efficiency': 'Eficiencia del personal (ROI)',
  'reports.reportType_salary_ratio': 'Ratio salario / ingresos',
  'reports.salaryArchiveEmpty': 'Aún no hay registros de salarios guardados',
  'reports.salaryArchiveEmptyHint': 'Calcula el salario en la página "Cálculo de salarios" — aparecerá aquí.',
  'reports.salaryArchiveMonth': 'Mes',
  'reports.salaryArchiveSavedAt': 'Guardado',
  'reports.salaryFund': 'Fondo total',
  'reports.salaryStaffCount': 'Personal',
  'reports.salaryAvg': 'Promedio',
  'reports.salaryRevenue': 'Ingresos del mes',
  'reports.salaryScheme': 'Esquema',
  'reports.salaryByRules': 'Por reglas',
  'reports.salaryAdjustments': 'Ajustes',
  'reports.salaryEffEmpty': 'Sin salarios calculados para el período',
  'reports.salaryEffEmptyHint': 'Prueba un período donde los salarios ya estén calculados.',
  'reports.salaryEffRevenue': 'Ingresos',
  'reports.salaryEffSalary': 'Salario',
  'reports.salaryEffProfit': 'Margen',
  'reports.salaryEffAvgRoi': 'ROI medio',
  'reports.salaryEffRoiHint': '>3 saludable, <1.5 problema',
  'reports.salaryRatioEmpty': 'Sin historial de salarios',
  'reports.salaryRatioCurrent': 'Ratio actual',
  'reports.salaryRatioAvg': 'Promedio del período',
  'reports.salaryRatioTrend': 'Cambio vs mes anterior',
  'reports.salaryRatioHealthy': 'Rango saludable',
  'reports.salaryRatioHealthyHint': 'para sector belleza',
  'reports.salaryRatioPct': 'Ratio',
  'reports.loading': 'Cargando…',
  'reports.reportType_sales_managers': 'Gerentes de venta',
  'reports.smEmpty': 'No hay pedidos en el período seleccionado',
  'reports.smUnknown': '— Sin especificar',
  'reports.smManagersCount': 'Gerentes',
  'reports.smOrdersCreated': 'Pedidos creados',
  'reports.smDelivered': 'Entregados',
  'reports.smNetRevenue': 'Ingresos netos',
  'reports.smAvgCheck': 'Ticket medio',
  'reports.smManager': 'Gerente',
  'reports.smCreated': 'Creó',
  'reports.smCancelled': 'Cancelados',
  'reports.smReturned': 'Devoluciones',
  'reports.smCancelRate': '% Cancelación',
  'reports.smReturnRate': '% Devolución',
  'reports.smAvgTime': 'Días hasta entrega',
  'reports.reportType_admin_activity': 'Actividad de administradores',
  'reports.aaEmpty': 'No hay actividad con createdBy en el período',
  'reports.aaAdmins': 'Admins activos',
  'reports.aaTotalApts': 'Citas creadas',
  'reports.aaTotalProcessed': 'Dinero procesado',
  'reports.aaSubsRevenue': 'Ingresos por suscripciones',
  'reports.aaAdmin': 'Admin',
  'reports.aaApts': 'Citas',
  'reports.aaConfirmed': 'Confirm.',
  'reports.aaNoShowPct': '% Ausencia',
  'reports.aaTx': 'Tx',
  'reports.aaProcessed': 'Importe',
  'reports.aaSubsSold': 'Suscr.',
  'reports.aaSubsRev': 'Suscr. ₴',
  'reports.aaDiscounts': 'Descuentos ₴',
  'reports.groupSales': 'Ingresos y ventas',
  'reports.groupCustomers': 'Clientes',
  'reports.groupStaff': 'Personal y salarios',
  'reports.groupLoyalty': 'Fidelidad y promos',
  'reports.groupInventory': 'Inventario',
  'reports.groupProcurement': 'Compras',
  'reports.reportType_loyalty_points': 'Puntos de fidelidad',
  'reports.reportType_coupons': 'Cupones',
  'reports.lpEmpty': 'Sin actividad de fidelidad en el período',
  'reports.lpEarned': 'Acumulado',
  'reports.lpRedeemed': 'Canjeado',
  'reports.lpReversed': 'Revertido',
  'reports.lpReversedHint': 'reembolsos / cancelaciones',
  'reports.lpNet': 'Neto del período',
  'reports.lpSourcesTitle': 'Origen de los puntos',
  'reports.lpSource': 'Origen',
  'reports.lpPoints': 'Puntos',
  'reports.lpShare': 'Cuota',
  'reports.lpRefService': 'Servicios',
  'reports.lpRefProduct': 'Productos',
  'reports.lpRefOrder': 'Pedidos',
  'reports.lpRefReferral': 'Referidos',
  'reports.lpRefBirthday': 'Cumpleaños',
  'reports.lpRefManual': 'Manual',
  'reports.lpRefSubscription': 'Suscripción',
  'reports.lpRefOther': 'Otro',
  'reports.cpEmpty': 'Aún no tienes cupones',
  'reports.cpEmptyHint': 'Agrega cupones en Fidelidad para ver estadísticas.',
  'reports.cpTotal': 'Total de cupones',
  'reports.cpUsedInPeriod': 'Usados en el período',
  'reports.cpDiscount': 'Descuento dado',
  'reports.cpOrderAmount': 'Ingresos con cupones',
  'reports.cpCode': 'Código',
  'reports.cpType': 'Tipo',
  'reports.cpValue': 'Valor',
  'reports.cpUsage': 'Usado',
  'reports.cpInPeriod': 'En período',
  'reports.cpOrderSum': 'Ingresos ₴',
  'reports.cpStatus': 'Estado',
  'reports.cpStatusActive': 'Activo',
  'reports.cpStatusExpired': 'Vencido',
  'reports.cpStatusExhausted': 'Agotado',
  'reports.cpStatusDisabled': 'Desactivado',
  'reports.reportType_production_runs': 'Producción',
  'reports.reportType_cash_shifts_report': 'Turnos de caja',
  'reports.reportType_heatmap_dow_hour': 'Mapa de calor día × hora',
  'reports.prEmpty': 'Sin producciones en el período',
  'reports.prRuns': 'Lotes',
  'reports.prCancelled': 'cancelados',
  'reports.prOutputQty': 'Cantidad producida',
  'reports.prInputCost': 'Coste de insumos',
  'reports.prAvgUnitCost': 'Coste medio unidad',
  'reports.prRecipe': 'Receta',
  'reports.csEmpty': 'Sin turnos de caja en el período',
  'reports.csEmptyHint': 'Los turnos se sincronizan con Checkbox.',
  'reports.csShifts': 'Turnos',
  'reports.csCash': 'Efectivo',
  'reports.csCard': 'Tarjeta',
  'reports.csAvgDuration': 'Duración media',
  'reports.csDiscrep': 'Con discrepancia',
  'reports.csOpened': 'Abierto',
  'reports.csClosed': 'Cerrado',
  'reports.csLocation': 'Ubicación',
  'reports.csOpenBal': 'Inicio ₴',
  'reports.csCloseBal': 'Fin ₴',
  'reports.csDiff': 'Δ',
  'reports.csOpen': 'Abierto',
  'reports.hmEmpty': 'Sin citas en el período',
  'reports.hmTotal': 'Total citas',
  'reports.hmPeak': 'Hora pico',
  'reports.hmTopDay': 'Día top',
  'reports.hmRecords': 'registros',
  'reports.hmLow': 'Bajo',
  'reports.hmMedium': 'Medio',
  'reports.hmHigh': 'Alto',
  'reports.hmPeakLegend': 'Pico',
  'reports.dowMon': 'Lun',
  'reports.dowTue': 'Mar',
  'reports.dowWed': 'Mié',
  'reports.dowThu': 'Jue',
  'reports.dowFri': 'Vie',
  'reports.dowSat': 'Sáb',
  'reports.dowSun': 'Dom',
  'reports.period_day': 'Día',
  'reports.period_week': 'Semana',
  'reports.period_month': 'Mes',
  'reports.period_year': 'Año',
  'reports.period_custom': 'Personalizado',
  'period.today': 'Hoy',
  'period.yesterday': 'Ayer',
  'period.thisWeek': 'Esta semana',
  'period.lastWeek': 'Semana pasada',
  'period.thisMonth': 'Este mes',
  'period.lastMonth': 'Mes pasado',
  'period.thisQuarter': 'Este trimestre',
  'period.thisYear': 'Este año',
  'period.last30': 'Últimos 30 días',
  'period.last90': 'Últimos 90 días',
  'period.custom': 'Personalizado',
  'reports.title': 'Informes',
  'reports.subtitle': 'Analítica e informes',
  'reports.allStaff': 'Todos los empleados',
  'reports.allClients': 'Todos los clientes',
  'reports.allCategories': 'Todas las categorías',
  'reports.allProducts': 'Todos los productos',
  'reports.allLocations': 'Todas las ubicaciones',
  'reports.appointments': 'Citas',
  'reports.clients': 'Clientes',
  'reports.masters': 'Especialistas',
  'reports.revenue': 'Ingresos',
  'reports.service': 'Servicio',
  'reports.serviceOrProduct': 'Producto/Servicio',
  'reports.client': 'Cliente',
  'reports.master': 'Especialista',
  'reports.date': 'Fecha',
  'reports.dateTime': 'Fecha/hora',
  'reports.time': 'Hora',
  'reports.duration': 'Duración',
  'reports.price': 'Precio',
  'reports.discount': 'Descuento',
  'reports.paid': 'Pagado',
  'reports.payment': 'Pago',
  'reports.method': 'Método',
  'reports.cash': 'Efectivo',
  'reports.online': 'Online',
  'reports.total': 'Total',
  'reports.grandTotal': 'Gran total',
  'reports.sum': 'Importe',
  'reports.position': 'Posición',
  'reports.positions': 'posiciones',
  'reports.product': 'Producto',
  'reports.category': 'Categoría',
  'reports.qty': 'Cant.',
  'reports.pcs': 'uds',
  'reports.cost': 'Coste',
  'reports.balance': 'Saldo',
  'reports.debt': 'Deuda',
  'reports.charges': 'Cargos',
  'reports.productCharges': 'Cargos por productos',
  'reports.serviceRefunds': 'Devoluciones por servicios',
  'reports.subscriptionVisit': 'Visita por abono',
  'reports.charged': 'Cargado',
  'reports.visits': 'Visitas',
  'reports.days': 'días',
  'reports.hrs': 'h',
  'reports.min': 'min',
  'reports.avgCheck': 'Ticket medio',
  'reports.avgDuration': 'Duración media',
  'reports.totalClients': 'Total de clientes',
  'reports.totalHours': 'Total de horas',
  'reports.servicesSold': 'Servicios prestados',
  'reports.withDiscount': 'Con descuento',
  'reports.utilization': 'Ocupación',
  'reports.worked': 'Trabajado',
  'reports.workingHours': 'Horas laborables',
  'reports.noVisitDays': 'Días sin visita',
  'reports.forOrder': 'Para pedido',
  'reports.mainRegister': 'Caja principal',
  'reports.settlementAccount': 'Cuenta de liquidación',
  'reports.other': 'Otros',
  'reports.incoming': 'Entradas',
  'reports.incomingQty': 'Cant. de entradas',
  'reports.incomingSum': 'Importe de entradas',
  'reports.incomings': 'Entradas',
  'reports.writeoff': 'Baja',
  'reports.writeoffsExpenses': 'Bajas/gastos',
  'reports.writtenOff': 'Dado de baja',
  'reports.writtenOffQty': 'Cant. de bajas',
  'reports.writtenOffSum': 'Importe de bajas',
  'reports.remainQty': 'Cant. restante',
  'reports.remainSum': 'Importe restante',
  'reports.transferMove': 'Traslado',
  'reports.together': 'Total',
  'reports.exportExcel': 'Exportar a Excel',
  'reports.exportPdf': 'Imprimir / PDF',
  'reports.print': 'Imprimir',
  'reports.noService': 'Sin servicio',
  'reports.noDataForPeriod': 'No hay datos para el período seleccionado',
  'reports.noCompletedForPeriod': 'No hay citas completadas para el período seleccionado',
  'reports.noRecordsForPeriod': 'No hay registros para el período seleccionado',
  'reports.noInventoryForPeriod': 'No hay datos de almacén para el período seleccionado',
  'reports.segment_all': 'Todos',
  'reports.segment_no30': 'Sin visita 30+ días',
  'reports.segment_new': 'Nuevos',
  'reports.segment_vip': 'VIP',
  'reports.segment_once': 'Una sola vez',
  'reports.segment_services_only': 'Solo servicios',
  'reports.segment_products_only': 'Solo productos',
  'reports.productContactsCol': 'Ped. de prod.',
  'reports.serviceContactsCol': 'Ped. de serv.',
  'reports.servicesIncome': 'Servicios ₴',
  'reports.productsIncome': 'Productos ₴',
  'reports.lastContact': 'Últ. contacto',
  'reports.operations': 'Operaciones',
  'reports.noClientsInSegment': 'No hay clientes en este segmento',
  'reports.tryChangeDateOrStaff': 'Intente cambiar la fecha o el empleado',
  'reports.tryChangeDateOrFilters': 'Intente cambiar la fecha o los filtros',
  'reports.tryChangeDateOrClient': 'Intente cambiar la fecha o el cliente',
  'reports.servicesRevenue': 'Ingresos por servicios',
  'reports.productSales': 'Ventas de productos',
  'reports.totalRevenue': 'Ingreso total',
  'reports.share': 'Participación',
  'reports.materialCosts': 'Costos de materiales',
  'reports.margin': 'Margen',
  'reports.abcClass': 'Clase',
  'reports.abcLeaders': 'líderes',
  'reports.abcMiddle': 'medios',
  'reports.abcSlow': 'baja rotación',
  'reports.avgPerDay': 'Prom. por día',
  'reports.discountCount': 'Cantidad de descuentos',
  'reports.discountSum': 'Monto de descuentos',
  'reports.discountShare': 'Participación de descuentos',
  'reports.noDiscountsForPeriod': 'No hay descuentos para el período seleccionado',
  'reports.grossPrice': 'Precio bruto',
  'reports.avgDiscount': 'Descuento prom.',
  'reports.supplier': 'Proveedor',
  'reports.allSuppliers': 'Todos los proveedores',
  'reports.suppliersCount': 'Proveedores',
  'reports.invoices': 'Facturas',
  'reports.avgPrice': 'Precio prom.',
  'reports.noPurchasesForPeriod': 'No hay compras para el período seleccionado',
  'reports.productUnits': 'Unidades de producto',
  'reports.invoiceCount': 'Cant. facturas',
  'reports.netto': 'Neto',
  'reports.peakDay': 'Pico',
  'reports.purchases': 'Compras',
  'reports.categories': 'Categorías',
  'reports.remainder': 'Restante',
  'reports.ordered': 'Pedido',
  'reports.returned': 'Devuelto',
  'reports.received': 'Recibido',
  'reports.productsCompared': 'Productos comparados',
  'reports.noPriceComparison': 'No hay datos de comparación',
  'reports.needMultipleSuppliers': 'Se necesitan compras de un producto a diferentes proveedores',
  'reports.turnoverRatio': 'Rotación',
  'reports.turnoverStatus': 'Estado',
  'reports.highTurnover': 'Alta',
  'reports.medTurnover': 'Media',
  'reports.lowTurnover': 'Baja',

  // ── Financial result page ──
  'finResult.month_jan': 'Enero', 'finResult.month_feb': 'Febrero', 'finResult.month_mar': 'Marzo',
  'finResult.month_apr': 'Abril', 'finResult.month_may': 'Mayo', 'finResult.month_jun': 'Junio',
  'finResult.month_jul': 'Julio', 'finResult.month_aug': 'Agosto', 'finResult.month_sep': 'Septiembre',
  'finResult.month_oct': 'Octubre', 'finResult.month_nov': 'Noviembre', 'finResult.month_dec': 'Diciembre',
  'finResult.sourceDeleted': 'Este documento ha sido eliminado del sistema',
  'finResult.title': 'Resultado financiero',
  'finResult.subtitle': 'Análisis de ingresos y gastos',
  'finResult.allLocations': 'Todas las ubicaciones',
  'finResult.income': 'Ingreso',
  'finResult.incomes': 'Ingresos',
  'finResult.expenses': 'Gastos',
  'finResult.financialResult': 'Resultado financiero',
  'finResult.profitability': 'Rentabilidad',
  'finResult.sales': 'Ventas',
  'finResult.servicesCompleted': 'Servicios prestados',
  'finResult.productSales': 'Venta de productos',
  'finResult.orderProductSales': 'Venta de productos (envíos)',
  'finResult.posProductSales': 'Venta de productos (POS / tienda)',
  'finResult.aptProductSales': 'Venta de productos en servicios',
  'finResult.subscriptions': 'Suscripciones',
  'finResult.refunds': 'reembolsos',
  'finResult.cogsOrders': 'Costo — envíos',
  'finResult.cogsAppointments': 'Costo — servicios',
  'finResult.cogsPos': 'Costo — tienda',
  'finResult.cogsWriteoffs': 'Costo de otras salidas',
  'finResult.orders': 'Pedidos',
  'finResult.visits': 'Visitas',
  'finResult.salaries': 'Salarios',
  'finResult.addExpense': 'Agregar gasto',
  'finResult.otherIncome': 'Otros ingresos',
  'finResult.addOtherIncome': 'Agregar otro ingreso',
  'finResult.incomeName': 'Nombre del ingreso',
  'finResult.deleteIncomeConfirm': '¿Eliminar este ingreso?',
  'finResult.exportExcel': 'Exportar a Excel',
  'finResult.add': 'Agregar',
  'finResult.cancel': 'Cancelar',
  'finResult.delete': 'Eliminar',
  'finResult.expenseName': 'Nombre del gasto',
  'finResult.expenseSum': 'Importe',
  'finResult.monthly': 'Mensual',
  'finResult.monthlyOption': 'Mensual',
  'finResult.oneTime': 'Único',
  'finResult.oneTimeOption': 'Único',
  'finResult.deleteExpenseTitle': '¿Eliminar gasto?',
  'finResult.deleteExpenseConfirm': '¿Está seguro de que desea eliminar este gasto?',
  'finResult.notCalculated': 'No calculado',
  'finResult.print': 'Imprimir',
  'finResult.printPdf': 'Imprimir PDF',
  'finResult.dynamics6months': 'Dinámica de 6 meses',
  'finResult.expenseStructure': 'Estructura de gastos',
  'finResult.incomeStructure': 'Estructura de ingresos',
  'finResult.donutServices': 'Servicios',
  'finResult.donutProducts': 'Productos',
  'finResult.noIncomeYet': 'Aún no hay ingresos este mes',
  'finResult.salaryFundTitle': 'Estructura del fondo salarial',
  'finResult.salaryNotCalculated': 'Los salarios de este mes aún no se han calculado',
  'finResult.salaryNoData': 'Sin datos para mostrar',
  'finResult.fundSalary': 'Salario fijo',
  'finResult.fundPercent': 'Porcentaje',
  'finResult.fundHybrid': 'Por acción',
  'finResult.vsPrev': 'vs ant.',
  'finResult.cashFlowTitle': 'Flujo de caja (diario)',
  'finResult.cashFlowEmpty': 'Aún no hay transacciones este mes',
  'finResult.cashFlowReceipts': 'Ingresos',
  'finResult.cashFlowRefunds': 'Reembolsos',
  'finResult.cashFlowNet': 'Flujo neto',
  'finResult.groupCogsProducts': 'Costo de bienes',
  'finResult.groupSalaries': 'Salarios',
  'finResult.groupFixed': 'Gastos fijos',
  'finResult.groupOther': 'Bajas y otros',
  'finResult.noExpensesYet': 'Aún no hay gastos este mes',
  'finResult.effectiveFrom': 'Vigente desde',
  'finResult.edit': 'Editar',
  'finResult.save': 'Guardar',
  'finResult.applyForwardOnly': 'Aplicar solo desde el mes elegido en adelante (mantener importe anterior para meses pasados)',
  'finResult.total': 'Total',
  'finResult.hintAddNew': 'El gasto se aplicará desde {month} en adelante (hasta que lo cambies).',
  'finResult.hintMutateSingle': 'El importe se actualizará para: {month}',
  'finResult.hintMutateRange': 'El importe se actualizará para: {from} — {to}',
  'finResult.hintMutateForward': 'El importe se actualizará para: {month} y todos los meses siguientes',
  'finResult.hintSplit': 'Se creará una nueva versión desde {newMonth}. Los meses anteriores ({oldFrom} — {oldTo}) mantendrán {oldAmount} ₴.',

  // ── Inventory products page ──
  'invProd.title': 'Productos',
  'invProd.subtitle': 'Gestión de productos, categorías y almacenes',
  'invProd.tabProducts': 'Productos',
  'invProd.tabCategories': 'Categorías',
  'invProd.tabWarehouses': 'Almacenes',
  'invProd.statProducts': 'Productos',
  'invProd.statCategories': 'Categorías',
  'invProd.statWarehouses': 'Almacenes',
  'invProd.productsCount': 'Productos',
  'invProd.positionsCount': 'Posiciones',
  'invProd.searchPlaceholder': 'Buscar por nombre, referencia...',
  'invProd.allCategories': 'Todas las categorías',
  'invProd.addProduct': 'Agregar producto',
  'invProd.newProduct': 'Nuevo producto',
  'invProd.editProduct': 'Editar producto',
  'invProd.emptyProducts': 'Aún no hay productos',
  'invProd.emptyProductsHint': 'Agregue el primer producto',
  'invProd.emptyCategories': 'Crea tu primera categoría de productos',
  'invProd.emptyCategoriesHint': 'Las categorías ayudan a organizar productos y encontrar lo que necesitas',
  'invProd.emptyWarehouses': 'Añade tu primer almacén',
  'invProd.emptyWarehousesHint': 'Los almacenes son necesarios para controlar el stock y realizar compras',
  'invProd.colName': 'Nombre',
  'invProd.colSku': 'Referencia',
  'invProd.colCategory': 'Categoría',
  'invProd.colUnit': 'Unidad',
  'invProd.colStock': 'Stock',
  'invProd.colMin': 'Mín.',
  'invProd.colSellPrice': 'Precio de venta',
  'invProd.labelName': 'Nombre',
  'invProd.labelSku': 'Referencia',
  'invProd.labelCategory': 'Categoría',
  'invProd.labelUnit': 'Unidad de medida',
  'invProd.labelMinStock': 'Stock mín.',
  'invProd.labelSellPrice': 'Precio de venta',
  'invProd.labelImageUrl': 'URL de imagen',
  'invProd.labelImage': 'Foto del producto',
  'invProd.uploadImage': 'Subir foto',
  'invProd.maxSize': 'hasta 200 KB',
  'invProd.pasteUrl': 'O pegar URL',
  'invProd.noCategory': 'Sin categoría',
  'invProd.unitPcs': 'uds',
  'invProd.unitG': 'g',
  'invProd.unitKg': 'kg',
  'invProd.unitMl': 'ml',
  'invProd.unitL': 'l',
  'invProd.unitPack': 'paq',
  'invProd.save': 'Guardar',
  'invProd.cancel': 'Cancelar',
  'invProd.publishOnOlx': 'Publicar en OLX',
  'invProd.olxPublished': 'OLX: anuncio creado',
  'olxPublish.title': 'Publicar en OLX',
  'olxPublish.fieldTitle': 'Título del anuncio',
  'olxPublish.fieldDescription': 'Descripción',
  'olxPublish.descriptionHint': 'OLX suele requerir ~80+ caracteres. Describe el producto, su estado, detalles.',
  'olxPublish.fieldCategory': 'Categoría',
  'olxPublish.suggesting': 'Buscando categoría por el título…',
  'olxPublish.noCategorySuggestions': 'No se pudo sugerir categoría. Ajusta el título o introduce el ID abajo.',
  'olxPublish.orManualCategoryId': 'o introduce ID de categoría OLX',
  'olxPublish.fieldCity': 'Ciudad',
  'olxPublish.cityPlaceholder': 'Empieza a escribir, ej. "Kyiv"',
  'olxPublish.searching': 'Buscando…',
  'olxPublish.fieldPrice': 'Precio',
  'olxPublish.fieldPhotoUrl': 'URL de la foto',
  'olxPublish.fieldContactName': 'Nombre de contacto',
  'olxPublish.contactNamePlaceholder': 'Cómo firmar el anuncio',
  'olxPublish.fieldContactPhone': 'Teléfono',
  'olxPublish.errorTitle': 'OLX devolvió un error:',
  'olxPublish.showRawError': 'Mostrar respuesta completa de OLX',
  'olxPublish.categoryAttrsTitle': 'OLX requiere campos extra para esta categoría:',
  'olxPublish.loadingAttrs': 'Cargando campos de la categoría…',
  'olxPublish.choose': 'elegir',
  'olxPublish.fieldDistrict': 'Distrito',
  'olxPublish.loadingDistricts': 'Cargando distritos de la ciudad…',
  'olxPublish.success': 'Anuncio creado, enviado a moderación OLX',
  'olxPublish.cancel': 'Cancelar',
  'olxPublish.publish': 'Publicar',
  'invProd.add': 'Agregar',
  'invProd.delete': 'Eliminar',
  'invProd.deleteProduct': 'Eliminar producto',
  'invProd.deleteCategory': 'Eliminar categoría',
  'invProd.deleteWarehouse': 'Eliminar almacén',
  'invProd.deleteConfirmMsg': '¿Está seguro de que desea eliminar?',
  'invProd.cannotDelete': 'No se puede eliminar',
  'invProd.errName': 'Ingrese el nombre',
  'invProd.nameDuplicate': 'Ya existe un producto con este nombre',
  'invProd.catDuplicate': 'Ya existe una categoría con este nombre',
  'invProd.whDuplicate': 'Ya existe un almacén con este nombre',
  'invProd.understood': 'Entendido',
  'invProd.newCategoryPlaceholder': 'Nombre de la nueva categoría',
  'invProd.newWarehousePlaceholder': 'Nombre del nuevo almacén',
  'invProd.blockProduct': 'Productos',
  'invProd.blockCategory': 'Categorías',
  'invProd.blockWarehouse': 'Almacenes',

  // ── Inventory stock page ──
  'invStock.title': 'Existencias',
  'invStock.subtitle': 'Control de existencias en almacenes',
  'invStock.statProducts': 'Productos',
  'invStock.statLow': 'Stock bajo',
  'invStock.searchPlaceholder': 'Buscar por nombre...',
  'invStock.allCategories': 'Todas las categorías',
  'invStock.allWarehouses': 'Todos los almacenes',
  'invStock.lowStockOnly': 'Solo stock bajo',
  'invStock.emptyTitle': 'No hay datos',
  'invStock.emptyHint': 'Agregue productos en la sección "Productos"',
  'invStock.colProduct': 'Producto',
  'invStock.colCategory': 'Categoría',
  'invStock.colUnit': 'Unidad',
  'invStock.colTotal': 'Stock',
  'invStock.colMin': 'Mín.',
  'invStock.colStatus': 'Estado',
  'invStock.statusLow': 'Bajo',
  'invStock.statusEmpty': 'Agotado',
  'invStock.available': 'Disponible',
  'invStock.transfer': 'Traslado',
  'invStock.transferTitle': 'Traslado de producto',
  'invStock.transferBtn': 'Trasladar',
  'invStock.labelProduct': 'Producto',
  'invStock.labelFromWarehouse': 'Desde almacén',
  'invStock.labelToWarehouse': 'A almacén',
  'invStock.labelQuantity': 'Cantidad',
  'invStock.cancel': 'Cancelar',

  // ── Inventory purchases page ──
  'invPurch.title': 'Compras',
  'invPurch.subtitle': 'Registro de compras de productos',
  'invPurch.statPurchases': 'Compras',
  'invPurch.searchPlaceholder': 'Buscar por proveedor...',
  'invPurch.newPurchase': 'Nueva compra',
  'invPurch.emptyTitle': 'Aún no hay compras',
  'invPurch.emptyHint': 'Cree la primera compra',
  'invPurch.colDate': 'Fecha',
  'invPurch.colSupplier': 'Proveedor',
  'invPurch.colWarehouse': 'Almacén',
  'invPurch.colItems': 'Artículos',
  'invPurch.colTotal': 'Total',
  'invPurch.modalTitle': 'Nueva compra',
  'invPurch.labelSupplier': 'Proveedor',
  'invPurch.supplierPlaceholder': 'Ingrese el nombre del proveedor...',
  'invPurch.labelDestWarehouse': 'Almacén de destino',
  'invPurch.sectionProducts': 'Productos',
  'invPurch.selectProduct': 'Seleccione un producto',
  'invPurch.searchProduct': 'Buscar producto...',
  'invPurch.noProducts': 'No se encontraron productos',
  'invPurch.addItem': 'Agregar producto',
  'invPurch.qty': 'Cant.',
  'invPurch.pricePerUnit': 'Precio por ud.',
  'invPurch.totalSum': 'Importe total',
  'invPurch.pos': 'posiciones',
  'invPurch.units': 'unidades',
  'invPurch.receive': 'Recibir',
  'invPurch.cancel': 'Cancelar',
  'invPurch.errWarehouse': 'Seleccione un almacén',
  'invPurch.errItems': 'Agregue al menos un producto',
  'invPurch.errNegPrice': 'El precio no puede ser negativo',
  'invPurch.errZeroPrice': 'Ingrese el precio de compra para cada producto',
  'invPurch.periodWeek': 'Semana',
  'invPurch.periodMonth': 'Mes',
  'invPurch.periodYear': 'Año',
  'invPurch.periodAll': 'Todo el tiempo',
  'invPurch.periodCustom': 'Personalizado',
  'invPurch.returnToSupplier': 'Devolver al proveedor',
  'invPurch.returnTitle': 'Devolución al proveedor',
  'invPurch.returnHint': 'Indique la cantidad a devolver',
  'invPurch.returnAmount': 'Monto de devolución',
  'invPurch.confirmReturn': 'Devolver',
  'invPurch.returnSuccess': 'Devolución completada',
  'invPurch.allReturned': 'Todos los artículos ya devueltos o sin stock',
  'invPurch.deletePurchase': 'Eliminar compra',
  'invPurch.deleteTitle': 'Eliminar compra',
  'invPurch.deleteWarning': '¿Está seguro? Se revertirán los siguientes artículos del stock:',
  'invPurch.deleteStockNote': 'Las cantidades en stock se reducirán correspondientemente.',
  'invPurch.deleteConfirm': 'Eliminar',
  'invPurch.deleteBlockedTitle': 'Eliminación no posible',
  'invPurch.deleteBlockedText': 'Esta compra no se puede eliminar porque hay movimientos posteriores para estos productos:',
  'invPurch.deleteBlockedHint': 'Primero elimine o cancele las operaciones posteriores, luego intente de nuevo.',
  'invPurch.understood': 'Entendido',

  // ── Tabs ──
  'invPurch.tabPurchases': 'Recepción de mercancías',
  'invPurch.tabSuppliers': 'Proveedores',
  'invPurch.selectSupplier': 'Seleccionar proveedor',

  // ── Suppliers ──
  'invPurch.searchSupplier': 'Buscar proveedor...',
  'invPurch.newSupplier': 'Nuevo proveedor',
  'invPurch.editSupplier': 'Editar proveedor',
  'invPurch.statSuppliers': 'proveedores',
  'invPurch.emptySuppliersTitle': 'No hay proveedores',
  'invPurch.emptySuppliersHint': 'Añada proveedores para un seguimiento cómodo de las compras',
  'invPurch.colSupplierName': 'Nombre',
  'invPurch.colContact': 'Persona de contacto',
  'invPurch.colPhone': 'Teléfono',
  'invPurch.colEdrpou': 'CIF',
    'invPurch.supplierDuplicate': 'A supplier with this name already exists',
'invPurch.supplierName': 'Nombre',
  'invPurch.supplierNamePh': 'S.L. "Proveedor"',
  'invPurch.contactPerson': 'Persona de contacto',
  'invPurch.contactPersonPh': 'Apellido Nombre',
  'invPurch.phone': 'Teléfono',
  'invPurch.email': 'Email',
  'invPurch.bankDetails': 'Datos bancarios',
  'invPurch.edrpou': 'CIF',
  'invPurch.mfo': 'Código bancario',
  'invPurch.iban': 'IBAN / Número de cuenta',
  'invPurch.supplierNotes': 'Notas',
  'invPurch.supplierNotesPh': 'Información adicional sobre el proveedor...',
  'invPurch.create': 'Crear',
  'invPurch.deleteSupplierTitle': '¿Eliminar proveedor?',
  'invPurch.deleteSupplierWarning': '¿Está seguro de que desea eliminar al proveedor',

  // ── Inventory movements page ──
  'invMov.title': 'Movimientos de stock',
  'invMov.subtitle': 'Historial de movimientos de productos en almacenes',
  'invMov.statOperations': 'Operaciones',
  'invMov.filterType': 'Tipo',
  'invMov.filterAll': 'Todos',
  'invMov.filterPurchase': 'Compra',
  'invMov.filterWriteoff': 'Baja',
  'invMov.filterTransfer': 'Traslado',
  'invMov.filterAppointment': 'Cita',
  'invMov.filterOrder': 'Pedido',
  'invMov.filterReturn': 'Devolución',
  'invMov.filterAllProducts': 'Todos los productos',
  'invMov.emptyTitle': 'No hay operaciones',
  'invMov.emptyHint': 'Aquí se mostrarán todas las operaciones con productos',
  'invMov.colDate': 'Fecha',
  'invMov.colType': 'Tipo',
  'invMov.colProduct': 'Producto',
  'invMov.colQty': 'Cant.',
  'invMov.colCost': 'Costo',
  'invMov.colWarehouse': 'Almacén',
  'invMov.colAuthor': 'Autor',
  'invMov.colDetails': 'Detalles',
  'invMov.typePurchase': 'Compra',
  'invMov.typeWriteoff': 'Baja',
  'invMov.typeTransfer': 'Traslado',
  'invMov.typeAppointment': 'Cita',
  'invMov.typeSale': 'Venta',
  'invMov.typeOrder': 'Pedido',
  'invMov.typeOrderCancel': 'Cancelación de pedido',
  'invMov.typeSaleCancel': 'Cancelación de venta',
  'invMov.typeAppointmentCancel': 'Cancelación de cita',
  'invMov.typeReturn': 'Devolución',
  'invMov.supplier': 'Proveedor',
  'invMov.writeoffTitle': 'Baja de producto',
  'invMov.writeoffBtn': 'Dar de baja',
  'invMov.writeoffConfirm': 'Confirmar baja',
  'invMov.labelProduct': 'Producto',
  'invMov.labelQuantity': 'Cantidad',
  'invMov.labelWarehouse': 'Almacén',
  'invMov.labelReason': 'Motivo',
  'invMov.labelNote': 'Nota',
  'invMov.available': 'Disponible',
  'invMov.cancel': 'Cancelar',
  'invMov.reasonExpired': 'Caducado',
  'invMov.reasonDamaged': 'Dañado',
  'invMov.reasonLost': 'Perdido',
  'invMov.reasonUsed': 'Usado',
  'invMov.reasonOther': 'Otro',

  // ── Salary calculation page ──
  'salCalc.month_jan': 'Enero', 'salCalc.month_feb': 'Febrero', 'salCalc.month_mar': 'Marzo',
  'salCalc.month_apr': 'Abril', 'salCalc.month_may': 'Mayo', 'salCalc.month_jun': 'Junio',
  'salCalc.month_jul': 'Julio', 'salCalc.month_aug': 'Agosto', 'salCalc.month_sep': 'Septiembre',
  'salCalc.month_oct': 'Octubre', 'salCalc.month_nov': 'Noviembre', 'salCalc.month_dec': 'Diciembre',
  'salCalc.title': 'Cálculo de nóminas',
  'salCalc.subtitle': 'Cálculo de salarios',
  'salCalc.selectMonthHint': 'Seleccione un mes para calcular',
  'salCalc.calculate': 'Calcular',
  'salCalc.save': 'Guardar',
  'salCalc.loadSaved': 'Cargar guardado',
  'salCalc.exportExcel': 'Exportar Excel',
  'salCalc.staffCount': 'Empleados',
  'salCalc.staffWithSchemes': 'Con esquemas',
  'salCalc.allStaff': 'Todos',
  'salCalc.noDataTitle': 'No hay datos',
  'salCalc.noDataDesc': 'Seleccione un mes y pulse "Calcular"',
  'salCalc.noStaffTitle': 'No hay empleados',
  'salCalc.noStaffDesc': 'Agregue empleados en la sección "Personal"',
  'salCalc.totalByRules': 'Por reglas',
  'salCalc.manualAdjustments': 'Ajustes',
  'salCalc.totalLabel': 'Total',
  'salCalc.grandTotal': 'Importe total',
  'salCalc.adjustments': 'Ajustes',
  'salCalc.addAdjustment': 'Agregar ajuste',
  'salCalc.adjDescPlaceholder': 'Descripción...',
  'salCalc.adjAmountPlaceholder': 'Importe',
  'salCalc.edit': 'Editar',
  'salCalc.back': 'Atrás',
  'salCalc.cancel': 'Cancelar',
  'salCalc.saved': 'Guardado',
  'salCalc.savedNotice': 'Cálculo guardado',
  'salCalc.overwriteTitle': '¿Sobrescribir?',
  'salCalc.overwriteDesc': 'Ya existe un cálculo guardado para este mes. ¿Sobrescribir?',
  'salCalc.overwrite': 'Sobrescribir',
  'salCalc.hourlyRate': 'Tarifa por hora',
  'salCalc.monthlySalary': 'Salario mensual',
  'salCalc.monthlyFixed': 'fijo al mes',
  'salCalc.tiered': 'tramos',
  'salCalc.dailyRate': 'Tarifa diaria',
  'salCalc.fixedPerAppointment': 'Fijo por cita',
  'salCalc.percentOwnServices': '% de servicios propios',
  'salCalc.percentTotalRevenue': '% de ingresos totales',
  'salCalc.percentOwnProductSales': '% own product sales',
  'salCalc.percentAllProductSales': '% all product sales',
  'salCalc.percentCreatedAppointments': '% created appointments',
  'salCalc.fixedPerCreatedAppointment': 'Fixed per created apt',
  'salCalc.percentOwnMaterials': '% materials',
  'salCalc.percentAllServices': '% of all location services',
  'salCalc.hours': 'h',
  'salCalc.days': 'días',
  'salCalc.appts': 'citas',
  'salCalc.services': 'serv.',
  'salCalc.individual': 'individual',
  'salCalc.otherService': 'otro',
  'salCalc.exFileName': 'Nóminas',
  'salCalc.exStaff': 'Empleado',
  'salCalc.exScheme': 'Esquema',
  'salCalc.exByRules': 'Por reglas',
  'salCalc.exAdjustments': 'Ajustes',
  'salCalc.exTotal': 'Total',

  // ── Salary schemes page ──
  'salSchemes.title': 'Esquemas de motivación',
  'salSchemes.subtitle': 'Reglas de cálculo de salarios',
  'salSchemes.schemesCount': 'Esquemas',
  'salSchemes.newScheme': 'Nuevo esquema',
  'salSchemes.emptyTitle': 'Aún no hay esquemas',
  'salSchemes.emptyDesc': 'Cree el primer esquema de cálculo',
  'salSchemes.newSchemeTitle': 'Nuevo esquema',
  'salSchemes.editScheme': 'Editar esquema',
  'salSchemes.schemeName': 'Nombre del esquema',
  'salSchemes.nameDuplicate': 'Ya existe un esquema con este nombre',
  'salSchemes.schemeNamePlaceholder': 'Ingrese el nombre...',
  'salSchemes.rulesSection': 'Reglas de cálculo',
  'salSchemes.groupBase': 'Base',
  'salSchemes.groupServices': 'Services',
  'salSchemes.groupProducts': 'Products',
  'salSchemes.groupGeneral': 'General',
  'salSchemes.groupAdmin': 'Admin',
  'salSchemes.noRules': 'Aún no hay reglas',
  'salSchemes.hourlyRate': 'Tarifa por hora',
  'salSchemes.dailyRate': 'Tarifa diaria',
  'salSchemes.fixedPerAppointment': 'Fijo por servicio',
  'salSchemes.percentOwnServices': '% de servicios propios',
  'salSchemes.percentTotalRevenue': '% de ingresos totales',
  'salSchemes.hintHourlyRate': 'UAH/h',
  'salSchemes.hintDailyRate': 'UAH/día',
  'salSchemes.hintFixedPer': 'UAH/cita',
  'salSchemes.hintPercentOwn': '% propios',
  'salSchemes.hintPercentTotal': '% del total',
  'salSchemes.percentOwnProductSales': '% own product sales',
  'salSchemes.hintPercentOwnProducts': '% of products sold by employee',
  'salSchemes.percentAllProductSales': '% all product sales',
  'salSchemes.hintPercentAllProducts': '% of total product sales',
  'salSchemes.percentCreatedAppointments': '% created appointments',
  'salSchemes.hintPercentCreated': '% from appointments created by employee',
  'salSchemes.fixedPerCreatedAppointment': 'Fixed per created appointment',
  'salSchemes.hintFixedCreated': 'Fixed amount per created appointment',
  'salSchemes.percentOwnMaterials': '% materials',
  'salSchemes.hintPercentMaterials': '% of materials in appointments',
  'salSchemes.percentAllServices': '% of all location services',
  'salSchemes.hintPercentAllServices': 'Percentage of total service and subscription revenue at location',
  'salSchemes.subscriptionLabel': 'Subscription services',
  'salSchemes.subModeVisitPrice': 'At subscription price',
  'salSchemes.subModeFullPrice': 'At list price',
  'salSchemes.subModeSkip': 'Do not count',
  'salSchemes.unitHour': 'UAH/h',
  'salSchemes.unitDay': 'UAH/día',
  'salSchemes.unitRecord': 'UAH/cita',
  'salSchemes.unitService': 'UAH/serv.',
  'salSchemes.useOverrides': 'Tarifas por servicio',
  'salSchemes.overrideService': 'Servicio',
  'salSchemes.overrideRate': 'Tarifa',
  'salSchemes.overrideAdd': 'Añadir excepción',
  'salSchemes.overrideRemove': 'Eliminar excepción',
  'salSchemes.overridesShort': 'excepciones',
  'salSchemes.staffShort': 'emp.',
  'salSchemes.save': 'Guardar',
  'salSchemes.create': 'Crear',
  'salSchemes.cancel': 'Cancelar',
  'salSchemes.editBtn': 'Editar',
  'salSchemes.deleteBtn': 'Eliminar',
  'salSchemes.delete': 'Eliminar',
  'salSchemes.deleteTitle': '¿Eliminar esquema?',
  'salSchemes.deleteConfirmText': '¿Está seguro de que desea eliminar este esquema?',
  'salSchemes.deleteAssigned': 'Este esquema está asignado a empleados y no puede ser eliminado',
  'salSchemes.understood': 'Entendido',
  'salSchemes.monthlySalary': 'Salario mensual',
  'salSchemes.hintMonthlySalary': 'Monto fijo por mes independiente del horario',
  'salSchemes.unitMonth': '₴/mes',
  'salSchemes.useBrackets': 'Tramos escalonados',
  'salSchemes.bracketModeProgressive': 'Progresivo (por tramo)',
  'salSchemes.bracketModeFlat': 'Plano (total al tramo alcanzado)',
  'salSchemes.bracketFrom': 'Desde',
  'salSchemes.bracketTo': 'Hasta',
  'salSchemes.bracketAdd': 'Añadir tramo',
  'salSchemes.bracketRemove': 'Eliminar tramo',

  // ── Checkbox settings page ──
  'checkbox.title': 'Checkbox POS',
  'checkbox.subtitle': 'Configuración de conexión con Checkbox',
  'checkbox.licenseKey': 'Clave de licencia',
  'checkbox.licenseKeyHint': 'Clave del panel de Checkbox',
  'checkbox.licenseKeyPlaceholder': 'Ingrese la clave de licencia...',
  'checkbox.pinCode': 'PIN del cajero',
  'checkbox.pinCodeHint': 'PIN del cajero de Checkbox',
  'checkbox.pinPlaceholder': 'Ingrese el PIN...',
  'checkbox.save': 'Guardar',
  'checkbox.saving': 'Guardando...',
  'checkbox.settingsSaved': 'Configuración guardada',
  'checkbox.testConnection': 'Probar conexión',
  'checkbox.testing': 'Probando...',
  'checkbox.connectionSuccess': 'Conexión exitosa',
  'checkbox.connectionSuccessToast': 'Checkbox conectado correctamente',
  'checkbox.shiftOpen': 'Turno abierto',
  'checkbox.shiftClosed': 'Turno cerrado',
  'checkbox.guideTitle': 'Cómo funciona la integración',
  'checkbox.guideStep1': 'Regístrese en checkbox.ua y cree una caja registradora. Copie la clave de licencia de su gabinete.',
  'checkbox.guideStep2': 'Cree un cajero y anote el código PIN. Pegue la clave y el PIN arriba, haga clic en "Probar conexión".',
  'checkbox.guideStep3': '¡Listo! Ahora al procesar pagos de pedidos o citas, el sistema creará automáticamente recibos fiscales.',
  'checkbox.guideCapabilities': 'Funciones:',
  'checkbox.guideCap1': 'Fiscalización automática en pagos de pedidos y citas',
  'checkbox.guideCap2': 'Apertura y cierre de turnos de caja',
  'checkbox.guideCap3': 'Soporte para pagos en efectivo y sin efectivo',
  'checkbox.guideCap4': 'Informe X e informe Z para control de caja',
  'checkbox.taxGroup': 'Grupo fiscal',
  'checkbox.taxGroupHint': 'Seleccione las tasas de impuestos para incluir en cada recibo. Haga clic en "Probar conexión" para cargar las tasas disponibles.',
  'checkbox.noTax': 'Sin impuesto',

  // ── Nova Poshta settings page ──
  'np.title': 'Nova Poshta',
  'np.subtitle': 'Configuración de integración con Nova Poshta',
  'np.apiKey': 'Clave API',
  'np.apiKeyPlaceholder': 'Ingrese la clave API de Nova Poshta...',
  'np.apiKeyHint': 'Clave desde my.novaposhta.ua → Configuración → Seguridad',
  'np.save': 'Guardar',
  'np.saving': 'Guardando...',
  'np.settingsSaved': 'Configuración de Nova Poshta guardada',
  'np.error': 'Error: ',
  'np.testConnection': 'Probar conexión',
  'np.testing': 'Probando...',
  'np.connectionSuccess': '¡Conectado! Remitentes encontrados: {count}',
  'np.connectionSuccessToast': 'Nova Poshta conectado exitosamente',
  'np.connectionFailed': 'Error de conexión. Verifique la clave API.',
  'np.senderSection': 'Datos del remitente',
  'np.sender': 'Remitente (contraparte)',
  'np.contactPerson': 'Persona de contacto',
  'np.senderPhone': 'Teléfono del remitente',
  'np.senderAddress': 'Dirección de envío',
  'np.senderAddressHint': 'Sucursal de Nova Poshta desde donde envía paquetes',
  'np.loadingSenders': 'Cargando datos del remitente...',
  'np.senderWarehouse': 'Sucursal del remitente',
  'np.senderWarehouseHint': 'Su cuenta NP no tiene direcciones registradas. Seleccione la sucursal desde donde envía.',
  'np.senderCity': 'Ciudad del remitente',
  'np.senderCityPlaceholder': 'Ingrese el nombre de la ciudad...',
  'np.senderWarehouseSelect': 'Sucursal',
  'np.noWarehouses': 'No se encontraron sucursales',
  'np.clearSelection': 'Limpiar',
  'np.guideTitle': 'Cómo funciona la integración',
  'np.guideStep1': 'Inicie sesión en my.novaposhta.ua → Configuración → Seguridad → copie la clave API.',
  'np.guideStep2': 'Pegue la clave arriba, haga clic en "Probar conexión". Seleccione remitente, persona de contacto y dirección.',
  'np.guideStep3': '¡Listo! Ahora seleccione "Nova Poshta" como método de envío al crear pedidos.',
  'np.guideCapabilities': 'Funciones:',
  'np.guideCap1': 'Crear TTN con un clic desde la página del pedido (estado "Empaquetado")',
  'np.guideCap2': 'Sincronización automática del estado de entrega cada 10 minutos',
  'np.guideCap3': 'Seguimiento de paquetes en tiempo real',
  'np.guideCap4': 'Impresión de etiquetas de envío',
  'np.guideCap5': 'Cálculo automático del costo de envío al seleccionar sucursal',

  // ── Meest Express settings page ──
  'meest.title': 'Meest Express',
  'meest.subtitle': 'Configuración de integración',
  'meest.apiToken': 'Token API',
  'meest.apiTokenPlaceholder': 'Pegue el token API del gabinete Meest',
  'meest.apiTokenHint': 'Encuéntrelo en 24.meest.com → Configuración → Integración API',
  'meest.contractId': 'Contract ID',
  'meest.contractIdPlaceholder': 'Ej. b0004cad-27a3-...',
  'meest.contractIdHint': 'Encuéntrelo en el gabinete Meest junto al token API',
  'meest.save': 'Guardar',
  'meest.saving': 'Guardando...',
  'meest.settingsSaved': 'Configuración de Meest Express guardada',
  'meest.error': 'Error: ',
  'meest.testConnection': 'Probar conexión',
  'meest.testing': 'Probando...',
  'meest.testingConnection': 'Probando conexión con Meest Express...',
  'meest.connectionSuccess': 'Meest Express conectado correctamente',
  'meest.connectionSuccessToast': 'Meest Express conectado',
  'meest.connectionFailed': 'Error de conexión. Verifique el token y Contract ID.',
  'meest.senderSection': 'Datos del remitente',
  'meest.senderName': 'Nombre completo del remitente',
  'meest.senderNamePlaceholder': 'Apellido Nombre',
  'meest.senderPhone': 'Teléfono del remitente',
  'meest.senderCity': 'Ciudad del remitente',
  'meest.senderCityPlaceholder': 'Comience a escribir el nombre de la ciudad',
  'meest.senderBranch': 'Sucursal del remitente',
  'meest.branchPlaceholder': 'Buscar sucursal',
  'meest.noBranches': 'No se encontraron sucursales',
  'meest.clearSelection': 'Limpiar',
  'meest.guideTitle': 'Cómo funciona la integración',
  'meest.guideStep1': 'Regístrese en 24.meest.com y firme el contrato. En Configuración → Integración API copie el token y Contract ID.',
  'meest.guideStep2': 'Péguelos arriba, haga clic en "Probar conexión". Los datos del remitente se llenarán automáticamente.',
  'meest.guideStep3': '¡Listo! Ahora seleccione "Meest Express" como método de envío al crear pedidos.',
  'meest.guideCapabilities': 'Funciones:',
  'meest.guideCap1': 'Crear envío con un clic desde la página del pedido (estado "Empaquetado")',
  'meest.guideCap2': 'Sincronización automática del estado de entrega cada 10 minutos',
  'meest.guideCap3': 'Seguimiento de paquetes en tiempo real',
  'meest.guideCap4': 'Impresión de etiqueta para el paquete',

  // ── Telegram settings page ──
  'telegram.title': 'Recordatorios Telegram',
  'telegram.subtitle': 'Configuración del bot para recordatorios a clientes',
  'telegram.botToken': 'Bot Token',
  'telegram.botTokenHint': 'Token del bot de @BotFather',
  'telegram.saveAndConnect': 'Guardar y conectar',
  'telegram.connecting': 'Conectando...',
  'telegram.checkingBot': 'Verificando bot...',
  'telegram.settingWebhook': 'Configurando webhook...',
  'telegram.botConnected': 'Bot conectado',
  'telegram.botReady': 'El bot está listo para funcionar',
  'telegram.invalidToken': 'Token inválido',
  'telegram.webhookError': 'Error de webhook',
  'telegram.webhookFailed': 'No se pudo configurar el webhook',
  'telegram.error': 'Error',
  'telegram.howItWorks': 'Cómo funciona',
  'telegram.step1': '1. Cree un bot a través de @BotFather en Telegram',
  'telegram.step2': '2. Copie el token del bot',
  'telegram.step3': '3. Pegue el token arriba y pulse "Guardar y conectar"',
  'telegram.step4': '4. Los clientes podrán conectarse mediante un enlace',
  'telegram.guideCapabilities': 'Funciones:',
  'telegram.guideCap1': 'Recordatorios automáticos de citas para clientes',
  'telegram.guideCap2': 'Los clientes pueden ver sus próximas citas',
  'telegram.guideCap3': 'Confirmar o cancelar citas a través del bot',
  'telegram.guideCap4': 'Enlace personal para cada cliente',

  // ── SMS settings page ──
  'sms.title': 'Envío SMS',
  'sms.subtitle': 'Configuración de la pasarela SMS',
  'sms.provider': 'Proveedor',
  'sms.apiKey': 'Clave API',
  'sms.apiKeyPlaceholder': 'Ingrese la clave API...',
  'sms.senderName': 'Nombre del remitente',
  'sms.senderNameHint': 'Nombre que verá el destinatario (hasta 11 caracteres)',
  'sms.save': 'Guardar',
  'sms.settingsSaved': 'Configuración guardada',
  'sms.testConnection': 'Probar conexión',
  'sms.testing': 'Probando...',
  'sms.checkingConnection': 'Verificando conexión...',
  'sms.connectionSuccess': 'Conexión exitosa',
  'sms.connectionError': 'Error de conexión',
  'sms.gatewayWorks': 'La pasarela SMS funciona',
  'sms.error': 'Error',
  'sms.unknown': 'Error desconocido',
  'sms.howItWorks': 'Cómo funciona',
  'sms.step1': '1. Regístrese en un proveedor SMS',
  'sms.step2': '2. Obtenga la clave API',
  'sms.step3': '3. Pegue la clave arriba y guarde',
  'sms.step4': '4. Ahora puede enviar SMS a los clientes',
  'sms.howToConnect': 'Cómo conectar {name}',
  'sms.openSite': 'Abrir sitio de {name}',
  'sms.apiKeyLocation': 'La API key se encuentra aquí: {path}',
  'sms.recommended': 'Recomendado',
  'sms.tagline_turbosms': 'El más popular en Ucrania. Panel sólido, API simple.',
  'sms.tagline_smsclub': 'Precios flexibles, alpha-name soportado.',
  'sms.tagline_alphasms': 'Precios transparentes, registro rápido.',
  'sms.guide_turbosms.step1': 'Regístrate en TurboSMS y recarga el saldo.',
  'sms.guide_turbosms.step2': 'Solicita un alpha-name (etiqueta del remitente) en el panel. Aprobación normalmente el mismo día.',
  'sms.guide_turbosms.step3': 'Ve a Perfil → API y copia la API key.',
  'sms.guide_turbosms.step4': 'Pega la key + alpha-name abajo y pulsa "Probar conexión".',
  'sms.guide_smsclub.step1': 'Crea una cuenta SMSClub y recarga el saldo.',
  'sms.guide_smsclub.step2': 'Solicita un alpha-name en el panel (moderación ~1 día hábil).',
  'sms.guide_smsclub.step3': 'Abre Configuración / Perfil → encuentra el token API.',
  'sms.guide_smsclub.step4': 'Pega el token + alpha-name abajo y pulsa "Probar conexión".',
  'sms.guide_alphasms.step1': 'Regístrate en AlphaSMS y recarga el saldo.',
  'sms.guide_alphasms.step2': 'Solicita un alpha-name (moderación toma unas horas).',
  'sms.guide_alphasms.step3': 'Panel: Configuración → API → copia la API key.',
  'sms.guide_alphasms.step4': 'Pega la key + alpha-name abajo y pulsa "Probar conexión".',

  // ── Email settings page ──
  'emailSet.title': 'Envío Email',
  'emailSet.subtitle': 'Configuración de envío de email',
  'emailSet.gmailAddress': 'Dirección Gmail',
  'emailSet.gmailHint': 'Dirección Gmail desde la que se enviarán los correos',
  'emailSet.appPassword': 'Contraseña de aplicación',
  'emailSet.appPasswordHint': 'Contraseña de aplicación de Google (no la contraseña principal)',
  'emailSet.fromName': 'Nombre del remitente',
  'emailSet.fromNameHint': 'Nombre que verá el destinatario',
  'emailSet.save': 'Guardar',
  'emailSet.settingsSaved': 'Configuración guardada',
  'emailSet.sendTestEmail': 'Enviar correo de prueba',
  'emailSet.sendingTest': 'Enviando...',
  'emailSet.testing': 'Probando...',
  'emailSet.testSent': 'Correo de prueba enviado',
  'emailSet.testSubject': 'Correo de prueba',
  'emailSet.testBody': 'Este es un correo de prueba de Systemic CRM',
  'emailSet.emailWorks': 'El email funciona',
  'emailSet.sendError': 'Error de envío',
  'emailSet.error': 'Error',
  'emailSet.unknown': 'Error desconocido',
  'emailSet.howToGetAppPassword': 'Cómo obtener la contraseña de aplicación',
  'emailSet.important': 'Importante',
  'emailSet.importantText': 'Use la contraseña de aplicación, no la contraseña principal de Gmail',
  'emailSet.step1': '1. Inicie sesión en su cuenta de Google',
  'emailSet.step2': '2. Vaya a Seguridad → Verificación en dos pasos',
  'emailSet.step2direct': '2. Active la verificación en dos pasos',
  'emailSet.step3': '3. Vaya a Contraseñas de aplicaciones',
  'emailSet.step4': '4. Cree una nueva contraseña de aplicación',
  'emailSet.step5': '5. Copie la contraseña generada',

  // ── Locations settings page ──
  'locations.title': 'Ubicaciones',
  'locations.subtitle': 'Gestión de ubicaciones de su negocio',
  'locations.locationsLabel': 'Ubicaciones',
  'locations.staffCount': 'Empleados',
  'locations.warehousesCount': 'Almacenes',
  'locations.addLocation': 'Agregar ubicación',
  'locations.tabMain': 'General',
  'locations.tabBooking': 'Reserva online',
  'locations.tabCompany': 'Datos de la empresa',
  'locations.photo': 'Foto de ubicación',
  'locations.uploadPhoto': 'Subir foto',
  'locations.changePhoto': 'Cambiar foto',
  'locations.photoHint': 'Foto del interior o fachada — se muestra en la página de reservas',
  'locations.scheduleLabel': 'Horario de trabajo',
  'locations.dayOff': 'Día libre',
  'locations.mon': 'Lun', 'locations.tue': 'Mar', 'locations.wed': 'Mié',
  'locations.thu': 'Jue', 'locations.fri': 'Vie', 'locations.sat': 'Sáb', 'locations.sun': 'Dom',
  'locations.workingHoursLabel': 'Horario de trabajo',
  'locations.workingHoursPlaceholder': 'Lun-Vie 9:00-18:00, Sáb 10:00-15:00',
  'locations.hasLinkedData': 'No se puede eliminar — la ubicación tiene personal o almacenes vinculados.',
  'locations.limitReached': 'Límite de ubicaciones alcanzado. Actualice su plan.',
  'locations.newLocation': 'Nueva ubicación',
  'locations.editLocation': 'Editar ubicación',
  'locations.nameLabel': 'Nombre',
  'locations.namePlaceholder': 'Ingrese el nombre...',
  'locations.nameDuplicate': 'Ya existe una ubicación con este nombre',
  'locations.addressLabel': 'Dirección',
  'locations.addressPlaceholder': 'Calle Mayor 1',
  'locations.cityLabel': 'Ciudad',
  'locations.cityPlaceholder': 'Madrid',
  'locations.phoneLabel': 'Teléfono',
  'locations.colorLabel': 'Color',
  'locations.save': 'Guardar',
  'locations.cancel': 'Cancelar',
  'locations.add': 'Agregar',
  'locations.edit': 'Editar',
  'locations.delete': 'Eliminar',
  'locations.cannotDelete': 'No se puede eliminar',
  'locations.ordersCount': 'Pedidos',
  'locations.needAtLeastOne': 'Se necesita al menos una ubicación',
  'locations.added': 'Ubicación agregada',
  'locations.updated': 'Ubicación actualizada',
  'locations.deleted': 'Ubicación eliminada',
  'locations.deleteTitle': 'Eliminar ubicación',
  'locations.deleteMessage': '¿Está seguro? Esta acción no se puede deshacer.',
  'locations.companyDetailsHint': 'Datos de la empresa (para facturas y documentos)',
  'locations.officialNameLabel': 'Nombre oficial',
  'locations.officialNamePlaceholder': 'SL "Nombre" / Autónomo',
  'locations.edrpouLabel': 'NIF / CIF',
  'locations.edrpouShort': 'NIF',
  'locations.bankAccountLabel': 'Cuenta bancaria (IBAN)',
  'locations.bankNameLabel': 'Nombre del banco',
  'locations.bankNamePlaceholder': 'Nombre del banco',

  // ── Users page ──
  'users.title': 'Usuarios',
  'users.subtitle': 'Gestión de usuarios del sistema',
  'users.usersCount': 'Usuarios',
  'users.addUser': 'Agregar usuario',
  'users.limitReached': 'Límite de usuarios alcanzado. Actualice su plan.',
  'users.newUser': 'Nuevo usuario',
  'users.editUser': 'Editar usuario',
  'users.noUsers': 'Aún no hay usuarios',
  'users.thName': 'Nombre',
  'users.thEmail': 'Email',
  'users.thRole': 'Rol',
  'users.thStaff': 'Empleado',
  'users.thActions': 'Acciones',
  'users.nameLabel': 'Nombre',
  'users.namePlaceholder': 'Ingrese el nombre...',
  'users.emailLabel': 'Email',
  'users.passwordLabel': 'Contraseña',
  'users.passwordPlaceholder': 'Mínimo 6 caracteres',
  'users.passwordMin': 'La contraseña debe tener al menos 6 caracteres',
  'users.roleLabel': 'Rol',
  'users.selectRole': 'Seleccione un rol',
  'users.selectRoleOption': '— Seleccione un rol —',
  'users.showPassword': 'Mostrar contraseña',
  'users.hidePassword': 'Ocultar contraseña',
  'users.enterName': 'Ingrese el nombre',
  'users.enterEmail': 'Ingrese email',
  'users.emailAlreadyUsed': 'Este email ya está en uso',
  'users.error': 'Error',
  'users.edit': 'Editar',
  'users.delete': 'Eliminar',
  'users.confirmDelete': '¿Está seguro de que desea eliminar este usuario?',
  'users.yes': 'Sí',
  'users.no': 'No',
  'users.staffBinding': 'Vinculación con empleado',
  'users.noStaffBinding': '— Ninguno —',
  'users.noPosition': 'sin cargo',
  'users.staffBindingHint': 'Link user to employee for salary calculation and work schedule',
  'users.viewScope': 'Data visibility',
  'users.viewScopeAll': 'Show all records and orders',
  'users.viewScopeOwn': 'Show only own',
  'users.viewScopeHint': '"Own only" — user will see only their appointments, orders and sales',
  'users.createWarning': 'Atención: después de crear un usuario, es posible que se cierre su sesión. Simplemente vuelva a iniciar sesión.',

  // ── Roles ──
  'roles.title': 'Roles',
  'roles.subtitle': 'Gestión de roles y permisos de acceso',
  'roles.rolesCount': 'Roles',
  'roles.addRole': 'Agregar rol',
  'roles.noRoles': 'Aún no hay roles.',
  'roles.systemBadge': 'Sistémico',
  'roles.permsOf': 'permisos',
  'roles.newRole': 'Nuevo rol',
  'roles.editRole': 'Editar rol',
  'roles.roleName': 'Nombre del rol',
  'roles.roleNamePlaceholder': 'Por ejemplo: Administrador, Gerente, Maestro',
  'roles.nameDuplicate': 'Ya existe un rol con este nombre',
  'roles.permissions': 'Permisos de acceso',
  'roles.confirmDelete': '¿Eliminar?',
  'roles.cannotDelete': 'No se puede eliminar el rol',
  'roles.usersAssigned': 'usuarios con este rol',
  'roles.groupClients': 'Clientes',
  'roles.groupStaff': 'Personal',
  'roles.groupCalendar': 'Calendario',
  'roles.groupSales': 'Ventas',
  'roles.groupInventory': 'Almacén',
  'roles.groupLoyalty': 'Fidelización',
  'roles.groupSalary': 'Salarios',
  'roles.groupFinances': 'Finanzas y analítica',
  'roles.groupCommunication': 'Comunicaciones',
  'roles.groupSettings': 'Configuración',
  'roles.groupSystem': 'Sistema',
  'roles.permClientsView': 'Ver clientes',
  'roles.permClientsEdit': 'Editar clientes',
  'roles.permClientsDelete': 'Eliminar clientes',
  'roles.permClientsCategories': 'Categorías de clientes',
  'roles.permClientsDocuments': 'Documentos de clientes',
  'roles.permStaffView': 'Ver personal',
  'roles.permStaffEdit': 'Editar personal',
  'roles.permScheduleView': 'Horario de trabajo',
  'roles.permScheduleEdit': 'Plantillas de horarios',
  'roles.permServicesView': 'Ver servicios',
  'roles.permServicesEdit': 'Editar servicios',
  'roles.permCalendarView': 'Ver calendario',
  'roles.permCalendarCreate': 'Crear citas',
  'roles.permCalendarEdit': 'Editar citas',
  'roles.permPosSell': 'Tienda (POS)',
  'roles.permOrdersView': 'Pedidos (ver)',
  'roles.permOrdersCreate': 'Pedidos (crear)',
  'roles.permOrdersEdit': 'Pedidos (editar)',
  'roles.permInvView': 'Productos y stock',
  'roles.permInvPurchases': 'Compras',
  'roles.permInvMovements': 'Movimientos de stock',
  'roles.permProductionView': 'Ver producción',
  'roles.permProductionCreate': 'Crear producción',
  'roles.permLoyaltyView': 'Ver programas de fidelización',
  'roles.permLoyaltyEdit': 'Editar programas de fidelización',
  'roles.permSalaryView': 'Cálculo de salarios',
  'roles.permSalaryEdit': 'Esquemas de motivación',
  'roles.permFinancesView': 'Ver finanzas',
  'roles.permCashRegister': 'Caja (Checkbox)',
  'roles.permReportsView': 'Informes',
  'roles.permFinancialResult': 'Resultado financiero',
  'roles.permBusinessMonitor': 'Monitor de negocio',
  'roles.permCommunicationView': 'Mensajes',
  'roles.permCommSettingsEdit': 'Configuración de comunicaciones',
  'roles.permSettingsLocations': 'Ubicaciones',
  'roles.permSettingsBooking': 'Reservas online',
  'roles.permSettingsIntegrations': 'Integraciones',
  'roles.permSettingsTariffs': 'Planes tarifarios',
  'roles.permManageUsers': 'Usuarios',
  'roles.permManageRoles': 'Roles',
  'roles.permAuditLog': 'Registro de auditoría',

  // ── Communication ──
  'comm.title': 'Comunicación',
  'comm.subtitle': 'Mensajes y contacto con clientes',
  'comm.searchPlaceholder': 'Buscar cliente...',
  'comm.allClients': 'Todos los clientes',
  'comm.nothingFound': 'No se encontró nada',
  'comm.noConnectedClients': 'No hay clientes conectados',
  'comm.you': 'Tú: ',
  'comm.noMessages': 'Sin mensajes',
  'comm.noHistory': 'Sin historial',
  'comm.selectChat': 'Seleccione un chat',
  'comm.selectChatHint': 'Seleccione un cliente a la izquierda para iniciar la comunicación',
  'comm.telegramNotConnected': 'Telegram no está conectado',
  'comm.smsNotConfigured': 'La pasarela SMS no está configurada',
  'comm.clientNoPhone': 'El cliente no tiene número de teléfono',
  'comm.noPhone': 'Sin teléfono',
  'comm.emailNotConfigured': 'Email no está configurado',
  'comm.clientNoEmail': 'El cliente no tiene dirección de email',
  'comm.noEmail': 'Sin email',
  'comm.defaultSubject': 'Mensaje',
  'comm.emailSent': 'Email enviado',
  'comm.smsSent': 'SMS enviado',
  'comm.messageSent': 'Mensaje enviado',
  'comm.error': 'Error: ',
  'comm.linkCopied': 'Enlace copiado',
  'comm.yesterday': 'Ayer',
  'comm.clientNoTelegram': 'El cliente aún no ha conectado Telegram',
  'comm.sendBotLink': 'Envíe este enlace al cliente:',
  'comm.copy': 'Copiar',
  'comm.sendSmsInstead': 'Enviar SMS en su lugar',
  'comm.botNotConfigured': 'El bot de Telegram no está configurado',
  'comm.configureTelegram': 'Configúrelo en Sistema → Recordatorios de Telegram',
  'comm.configureSms': 'Configúrelo en Sistema → Envío de SMS',
  'comm.addPhoneToCard': 'Agregue un número de teléfono a la tarjeta del cliente',
  'comm.configureEmail': 'Configúrelo en Sistema → Envío de email',
  'comm.addEmailToCard': 'Agregue email a la tarjeta del cliente',
  'comm.noMessagesYet': 'Aún no hay mensajes. ¡Escriba primero!',
  'comm.openAttachment': 'Abrir adjunto',
  'comm.attachHintWeb': 'La conversación pasará a la ficha del cliente con su historial; los próximos mensajes de este chat también irán a la ficha.',
  'comm.createCardFromVisitor': 'Crear ficha con los datos del visitante',
  'comm.cardCreated': 'Ficha creada',
  'comm.showOlder': 'Mostrar anteriores',
  'comm.emailSubjectPlaceholder': 'Asunto del correo...',
  'comm.emailPlaceholder': 'Texto del correo...',
  'comm.smsPlaceholder': 'Escribir SMS...',
  'comm.sendingVia': 'Canal actual: {channel}',
  'comm.messagePlaceholder': 'Escribir mensaje...',
  'comm.sendEnter': 'Enviar (Enter)',

  // ── Orders ──
  'orders.title': 'Pedidos',
  'orders.subtitle': 'Venta de productos',
  'orders.statTotal': 'Total',
  'orders.statusNew': 'Nuevos',
  'orders.statusPaid': 'Pagados',
  'orders.searchPlaceholder': 'Buscar por cliente o producto...',
  'orders.filterAll': 'Todos',
  'orders.status_new': 'Nuevo',
  'orders.status_confirmed': 'Confirmado',
  'orders.status_packed': 'Empaquetado',
  'orders.status_shipped': 'Enviado',
  'orders.status_delivered': 'Recibido',
  'orders.status_cancelled': 'Cancelado',
  'orders.periodAll': 'Todos',
  'orders.periodWeek': 'Semana',
  'orders.periodMonth': 'Mes',
  'orders.periodYear': 'Año',
  'orders.periodCustom': 'Personalizado',
  'orders.newOrder': 'Nuevo pedido',
  'orders.editOrder': 'Editar pedido',
  'orders.emptyTitle': 'No hay pedidos',
  'orders.emptyHint': 'Cree su primer pedido de venta de productos',
  'orders.pos': 'pos.',
  'orders.discount': 'Descuento',
  'orders.total': 'Total',
  'orders.pay_unpaid': 'No pagado',
  'orders.pay_partial': 'Parcial',
  'orders.pay_paid': 'Pagado',
  'orders.pay_refunded': 'Reembolsado',
  'orders.refund': 'Reembolsar',
  'orders.refunded': 'Pago reembolsado',
  'orders.refundTitle': 'Reembolso',
  'orders.refundMessage': '¿Reembolsar {amount} ₴ al cliente?',
  'orders.refundWarning': 'Se creará una transacción de reembolso',
  'orders.refundDescription': 'Reembolso de pedido',
  'orders.confirmRefund': 'Confirmar reembolso',
  'orders.refundAmountLabel': 'Monto del reembolso',
  'orders.paidOf': 'Pagado {paid} de {total} ₴',
  'orders.payRemaining': 'Pagar restante',
  'orders.payAmountLabel': 'Monto del pago',
  'orders.fullAmount': 'monto total',
  'orders.returnProducts': 'Devolver productos',
  'orders.returnTitle': 'Devolución de productos',
  'orders.returnHint': 'Indique las cantidades a devolver al almacén',
  'orders.confirmReturn': 'Confirmar devolución',
  'orders.returnFrom': 'Devolución del pedido',
  'orders.fullyReturned': 'Productos devueltos',
  'orders.partiallyReturned': 'Devolución parcial',
  'orders.action_confirmed': 'Confirmar',
  'orders.action_packed': 'Empaquetar',
  'orders.action_shipped': 'Enviar',
  'orders.action_delivered': 'Recibido',
  'orders.action_cancelled': 'Cancelar',
  'orders.markPaid': 'Marcar pagado',
  'orders.payBtn': 'Pagar',
  'orders.cashGiven': 'El cliente dio',
  'orders.change': 'Cambio',
  'orders.notEnough': 'No es suficiente',
  'orders.confirmPayment': 'Confirmar pago',
  'orders.back': 'Volver',
  'orders.edit': 'Editar',
  'orders.errCustomerName': 'Ingrese el nombre del cliente',
  'orders.errItems': 'Agregue al menos un producto',
  'orders.errWarehouse': 'Seleccione un almacén',
  'orders.errStockInsufficient': 'Stock insuficiente',
  'orders.errNegPrice': 'El precio no puede ser negativo',
  'orders.errQuantity': 'Indique la cantidad para los productos seleccionados',
  'orders.inStock': 'En stock',
  'orders.available': 'disponible',
  'orders.needed': 'necesario',
  'orders.paymentDescription': 'Venta de productos',
  'orders.sectionCustomer': 'Cliente',
  'orders.sectionProducts': 'Productos',
  'orders.sectionPayment': 'Pago',
  'orders.labelName': 'Nombre',
  'orders.namePlaceholder': 'Nombre del cliente',
  'orders.labelPhone': 'Teléfono',
  'orders.labelTariff': 'Plan tarifario',
  'orders.standardPrice': 'Precio estándar',
  'orders.labelEmail': 'Email',
  'orders.labelWarehouse': 'Almacén',
  'orders.selectWarehouse': 'Seleccione un almacén',
  'orders.labelPaymentMethod': 'Método de pago',
  'orders.pm_cash': 'Efectivo',
  'orders.pm_terminal': 'Terminal',
  'orders.pm_transfer': 'Transferencia',
  'orders.pm_online': 'En línea',
  'orders.selectProduct': 'Seleccione un producto',
  'orders.qty': 'Cantidad',
  'orders.price': 'Precio',
  'orders.addItem': 'Agregar producto',
  'orders.colProduct': 'Producto',
  'orders.colWarehouse': 'Almacén',
  'orders.colQty': 'Cant.',
  'orders.colPrice': 'Precio',
  'orders.colDiscount': 'Desc.',
  'orders.colSum': 'Total',
  'orders.labelDiscount': 'Descuento (₴)',
  'orders.labelNote': 'Nota',
  'orders.notePlaceholder': 'Comentario del pedido...',
  'orders.cancel': 'Cancelar',
  'orders.save': 'Guardar',
  'orders.saving': 'Guardando…',
  'orders.searchProduct': 'Buscar producto...',
  'orders.noProducts': 'No se encontraron productos',
  'orders.changeProduct': 'Cambiar producto',
  'orders.noWarehouse': 'Sin almacén con stock',
  'orders.noCategory': 'Sin categoría',
  'orders.printInvoice': 'Factura',
  'orders.printBill': 'Presupuesto',
  'orders.sectionShipping': 'Envío',
  'orders.labelShippingMethod': 'Método de envío',
  'orders.labelShippingAddress': 'Dirección de entrega',
  'orders.shippingNone': 'Sin envío (recogida)',
  'orders.shippingNP': 'Nova Poshta',
  'orders.shippingPickup': 'Recogida',
  'orders.shippingCourier': 'Mensajero',
  'orders.shippingOther': 'Otro',
  'orders.shipping_novaposhta': 'Nova Poshta',
  'orders.shipping_pickup': 'Recogida',
  'orders.shipping_courier': 'Mensajero',
  'orders.shipping_other': 'Otro envío',
  'orders.npCity': 'Ciudad',
  'orders.npCityPlaceholder': 'Ingrese el nombre de la ciudad...',
  'orders.npWarehouse': 'Sucursal / Punto de entrega',
  'orders.npWarehousePlaceholder': 'Buscar sucursal...',
  'orders.npTTN': 'Número de seguimiento',
  'orders.npTTNPlaceholder': 'Número de guía',
  'orders.npTrack': 'Rastrear',
  'orders.npStatus': 'Estado',
  'orders.npFrom': 'Desde',
  'orders.npTo': 'Hasta',
  'orders.npDeliveryTo': 'Entrega',
  'orders.npDeliveryDate': 'Fecha de entrega',
  'orders.npTTNOnlyPacked': 'TTN solo se puede crear desde el estado «Empaquetado»',
  'orders.npSyncTracking': 'Sincronizar seguimiento',
  'orders.npSyncing': 'Sincronizando...',
  'orders.npAutoSyncActive': 'El estado se actualizará automáticamente vía Nova Poshta',
  'orders.meestAutoSyncActive': 'El estado se actualizará automáticamente vía Meest Express',
  'orders.meestAll': 'Todos',
  'orders.meestOffice': 'Oficinas',
  'orders.meestParcelLocker': 'Buzones de paquetes',
  'orders.npCodConfirmTitle': 'Crear guía Nova Poshta',
  'orders.meestCodConfirmTitle': 'Crear envío Meest',
  'orders.codChoiceMessage': 'El pedido no está pagado. Puede crear el envío con Contra Reembolso.',
  'orders.codWithCod': 'Sí, con Contra Reembolso',
  'orders.codWithoutCod': 'No, sin Contra Reembolso',
  'orders.codCancel': 'Cancelar creación del envío',
  'orders.addressPlaceholder': 'Dirección de entrega...',
  'orders.courierAddressPlaceholder': 'Dirección para el mensajero...',
  'orders.npSettingsRequired': 'Primero configure Nova Poshta en Sistema → Nova Poshta',
  'orders.npResaveSettings': 'Vuelva a guardar la configuración de Nova Poshta (Sistema → Nova Poshta → Guardar) para actualizar los datos del remitente.',
  'orders.npMissingFields': 'Faltan datos para crear la guía. Vaya a Sistema → Nova Poshta y vuelva a guardar. Campos faltantes',
  'orders.npAddressRequired': 'Indique la ciudad y sucursal NP en el pedido',
  'orders.npRecipientRequired': 'Ingrese nombre y teléfono del destinatario',
  'orders.npCreateTTN': 'Crear guía',
  'orders.npTTNCreated': 'Guía creada',
  'orders.npTTNError': 'Error al crear guía',
  'orders.npPrintSticker': 'Imprimir etiqueta',
  'orders.npDeliveryPriceLabel': 'Costo de envío estimado',
  'orders.npUAH': 'UAH',
  'orders.npCalcPrice': 'Calculando costo',
  'orders.author': 'Autor',
  'invoice.title': 'Albarán de entrega',
  'invoice.date': 'Fecha',
  'invoice.status': 'Estado',
  'invoice.customer': 'Cliente',
  'invoice.note': 'Nota',
  'invoice.items': 'Artículos',
  'invoice.product': 'Producto',
  'invoice.unit': 'Ud.',
  'invoice.qty': 'Cant.',
  'invoice.price': 'Precio',
  'invoice.discountCol': 'Dto.',
  'invoice.sum': 'Importe',
  'invoice.discount': 'Descuento',
  'invoice.total': 'Total',
  'invoice.paid': 'Pagado',
  'invoice.remaining': 'Pendiente',
  'invoice.seller': 'Vendedor',
  'invoice.bankAccount': 'Cuenta',
  'invoice.sellerSign': 'Firma del vendedor',
  'invoice.buyerSign': 'Firma del comprador',
  'invoice.pcs': 'uds',

  // ── Bill ──
  'bill.title': 'Presupuesto',
  'bill.amountDue': 'Importe a pagar',
  'bill.payTo': 'Datos de pago',
  'bill.service': 'servicio',
  'bill.itemName': 'Descripción',

  // ── Services: default materials ──
  'services.materials': 'Materiales',
  'services.hasMaterials': 'Tiene materiales predeterminados',
  'services.defaultMaterials': 'Materiales predeterminados',
  'services.defaultMaterialsHint': 'Estos materiales se agregarán automáticamente al seleccionar este servicio',
  'services.addMaterial': 'Agregar material',
  'services.noProductsAvailable': 'No hay productos disponibles',

  'nav.production': 'Producción',

  'production.title': 'Producción',
  'production.subtitle': 'Especificaciones y fabricación',
  'production.recipesCount': 'Especificaciones',
  'production.operationsCount': 'Operaciones',
  'production.tab_recipes': 'Especificaciones',
  'production.tab_produce': 'Producir',
  'production.tab_history': 'Historial',
  'production.newRecipe': 'Nueva especificación',
  'production.newProduction': 'Nueva operación',
  'production.searchRecipes': 'Buscar especificaciones...',
  'production.searchHistory': 'Buscar en historial...',
  'production.noRecipes': 'Aún no hay especificaciones',
  'production.noRecipesHint': 'Cree una especificación para fabricar productos a partir de materias primas',
  'production.createRecipeFirst': 'Primero cree una especificación en la pestaña "Especificaciones"',
  'production.noHistory': 'El historial de producción está vacío',
  'production.output': 'Salida',
  'production.inputs': 'Entradas',
  'production.produce': 'Producir',
  'production.edit': 'Editar',
  'production.delete': 'Eliminar',
  'production.stockOk': 'En stock',
  'production.stockLow': 'Insuficiente',
  'production.inputCost': 'Costo de materias',
  'production.unitCost': 'Costo unitario',
  'production.uah': 'UAH',
  'production.warehouse': 'Almacén',
  'production.recipeName': 'Nombre de la especificación',
  'production.recipeNamePlaceholder': 'Ej. "Crema de manos 100ml"',
  'production.selectWarehouse': 'Seleccionar almacén',
  'production.noInputsYet': 'Agregue materias primas a la especificación',
  'production.outputSection': 'Producto terminado',
  'production.outputProduct': 'Producto de salida',
  'production.selectProduct': 'Seleccionar producto',
  'production.outputQty': 'Cantidad',
  'production.inputsSection': 'Materias primas',
  'production.addInput': 'Agregar entrada',
  'production.searchProduct': 'Buscar producto...',
  'production.qty': 'Cant.',
  'production.cancel': 'Cancelar',
  'production.save': 'Guardar',
  'production.create': 'Crear',
  'production.editRecipe': 'Editar especificación',
  'production.recipeCreated': 'Especificación creada',
  'production.recipeUpdated': 'Especificación actualizada',
  'production.recipeDeleted': 'Especificación eliminada',
  'production.cannotDeleteRecipe': 'No se puede eliminar — usada en producción',
  'production.executeProduction': 'Ejecutar producción',
  'production.selectRecipeLabel': 'Especificación',
  'production.selectRecipe': 'Seleccionar especificación',
  'production.multiplier': 'Multiplicador (lotes)',
  'production.preview': 'Vista previa',
  'production.willConsume': 'Se consumirá',
  'production.willProduce': 'Se producirá',
  'production.need': 'necesario',
  'production.available': 'disponible',
  'production.note': 'Nota',
  'production.notePlaceholder': 'Comentario sobre la operación',
  'production.executeProduce': 'Producir',
  'production.produced': 'Producido: {qty} × {name}',
  'production.errNameRequired': 'Nombre de especificación requerido',
  'production.errOutputRequired': 'Seleccione el producto de salida',
  'production.errInputsRequired': 'Agregue al menos una materia prima',
  'production.errOutputInInputs': 'El producto de salida no puede estar entre las entradas',
  'production.errSelectRecipe': 'Seleccione una especificación',
  'production.errSelectWarehouse': 'Seleccione un almacén',
  'production.errMultiplier': 'El multiplicador debe ser >= 1',
  'production.cancelTitle': 'Cancelar producción',
  'production.cancelMessage': '¿Cancelar producción "{name}" ×{qty}?',
  'production.cancelDescription': 'El producto terminado se deducirá del almacén, las materias primas serán devueltas',
  'production.cancelWarning': 'Esta acción no se puede deshacer',
  'production.confirmCancel': 'Confirmar cancelación',
  'production.cancelledLabel': 'Cancelado',
  'production.cancelBtn': 'Cancelar',
  'production.alreadyCancelled': 'Esta producción ya fue cancelada',
  'production.cancelNotEnoughStock': 'No se puede cancelar — solo quedan {available} de {needed} unidades en stock. El producto ya fue enviado.',
  'production.cancelNote': 'Cancelación de producción',
  'production.cancelledSuccess': 'Producción cancelada',

  'invMov.typeProductionOut': 'Producción (consumido)',
  'invMov.typeProductionIn': 'Producción (salida)',
  'invMov.filterProduction': 'Producción',

  // ── Navigation: audit log ──
  'nav.auditLog': 'Registro de auditoría',

  // ── Audit Log ──
  'auditLog.title': 'Registro de auditoría',
  'auditLog.dateTime': 'Fecha y hora',
  'auditLog.user': 'Usuario',
  'auditLog.action': 'Acción',
  'auditLog.collection': 'Sección',
  'auditLog.documentId': 'ID del documento',
  'auditLog.document': 'Documento',
  'auditLog.details': 'Detalles',
  'auditLog.actionCreate': 'Creación',
  'auditLog.actionUpdate': 'Modificación',
  'auditLog.actionDelete': 'Eliminación',
  'auditLog.filterCollection': 'Sección',
  'auditLog.filterAction': 'Acción',
  'auditLog.filterFrom': 'Desde',
  'auditLog.filterTo': 'Hasta',
  'auditLog.allCollections': 'Todas las secciones',
  'auditLog.allActions': 'Todas las acciones',
  'auditLog.noEntries': 'No se encontraron registros',
  'auditLog.loadMore': 'Cargar más',
  'auditLog.changes': 'Cambios',
  'auditLog.field': 'Campo',
  'auditLog.oldValue': 'Antes',
  'auditLog.newValue': 'Después',
  'auditLog.deletedData': 'Datos eliminados',
  'auditLog.newRecord': 'Nuevo registro creado',
  'auditLog.fieldsChanged': 'campos modificados',
  'auditLog.colCustomers': 'Clientes',
  'auditLog.colStaff': 'Personal',
  'auditLog.colAppointments': 'Citas',
  'auditLog.colTransactions': 'Transacciones',
  'auditLog.colOrders': 'Pedidos',
  'auditLog.colProducts': 'Productos',
  'auditLog.colStock': 'Stock',
  'auditLog.colStockMovements': 'Movimientos de stock',
  'auditLog.colServices': 'Servicios',
  'auditLog.colCategories': 'Categorías',
  'auditLog.colLocations': 'Ubicaciones',
  'auditLog.colRoles': 'Roles',
  'auditLog.colUsers': 'Usuarios',
  'auditLog.colSalaryHistory': 'Historial de salarios',
  'auditLog.colSalarySchemes': 'Esquemas de salario',
  'auditLog.colFixedExpenses': 'Gastos fijos',
  'auditLog.colWarehouses': 'Almacenes',
  'auditLog.colScheduleTemplates': 'Plantillas de horario',
  'auditLog.colCashShifts': 'Turnos de caja',
  'auditLog.colProductions': 'Producción',
  'auditLog.colTechCards': 'Fichas técnicas',

  // ── Loyalty (4 modules) ──
  'nav.loyalty': 'Programas de fidelización',
  'loyalty.title': 'Programas de fidelización',
  'loyalty.subtitle': 'Puntos, niveles, códigos promo y suscripciones',
  'custModal.tabLoyalty': 'Fidelización',
  'loyalty.tabPoints': 'Puntos',
  'loyalty.tabTiers': 'Niveles',
  'loyalty.tabCoupons': 'Códigos Promo',
  'loyalty.tabSubscriptions': 'Suscripciones',
  'loyalty.tabSettings': 'Configuración',
  'loyalty.tabBalances': 'Saldos',
  'loyalty.tabHistory': 'Historial',
  'loyalty.tabTierOverview': 'Vista de clientes',
  'loyalty.tabPlans': 'Planes',
  'loyalty.tabPlansSettings': 'Configuración de planes',
  'loyalty.tabActiveSubs': 'Suscripciones activas',
  'loyalty.statMembers': 'miembros',
  'loyalty.statPoints': 'puntos activos',
  'loyalty.saveSettings': 'Guardar configuración',
  'loyalty.saved': 'Configuración guardada',
  'loyalty.searchCustomer': 'Buscar cliente...',
  'loyalty.days': 'días',
  'loyalty.pts': 'puntos',
  'loyalty.cancel': 'Cancelar',
  'loyalty.colCustomer': 'Cliente',
  'loyalty.colTier': 'Nivel',
  'loyalty.colBalance': 'Saldo',
  'loyalty.colTotalEarned': 'Acumulados',
  'loyalty.colTotalRedeemed': 'Canjeados',
  'loyalty.colTotalSpent': 'Total gastado',
  'loyalty.colDate': 'Fecha',
  'loyalty.colType': 'Tipo',
  'loyalty.colPoints': 'Puntos',
  'loyalty.colNote': 'Nota',
  'loyalty.colStatus': 'Estado',
  'loyalty.enablePoints': 'Activar programa de puntos',
  'loyalty.pointsDisabled': 'Programa de puntos desactivado',
  'loyalty.sectionEarning': 'Acumulación de puntos',
  'loyalty.currencyPerPoint': 'Importe por punto',
  'loyalty.currencyPerPointHint': 'Cuánto debe gastar el cliente para obtener puntos',
  'loyalty.pointsPerUnit': 'Puntos por unidad',
  'loyalty.sectionRedemption': 'Canje de puntos',
  'loyalty.pointValue': 'Valor del punto',
  'loyalty.maxRedeemPercent': 'Máx. % de pago con puntos',
  'loyalty.sectionAutoBonuses': 'Bonificaciones automáticas',
  'loyalty.birthdayBonus': 'Bonificación de cumpleaños',
  'loyalty.referralBonus': 'Bonificación por referido',
  'loyalty.inactivityDays': 'Días de inactividad',
  'loyalty.inactivityBonus': 'Bonificación por regreso',
  'loyalty.noBalances': 'Aún no hay miembros',
  'loyalty.noBalancesHint': 'Los puntos se acumularán automáticamente al pagar',
  'loyalty.noHistory': 'Historial vacío',
  'loyalty.txEarn': 'Acumulación',
  'loyalty.txRedeem': 'Canje',
  'loyalty.txBirthday': 'Cumpleaños',
  'loyalty.txReferral': 'Referido',
  'loyalty.txInactivity': 'Regreso',
  'loyalty.txManual': 'Manual',
  'loyalty.sectionPoints': 'Puntos',
  'loyalty.pointsBalance': 'puntos',
  'loyalty.earned': 'acumulados',
  'loyalty.redeemed': 'canjeados',
  'loyalty.manualPlaceholder': '±puntos',
  'loyalty.manualApply': 'Aplicar',
  'loyalty.manualAdd': 'Crédito manual',
  'loyalty.manualDeduct': 'Débito manual',
  'loyalty.history': 'Historial de puntos',
  'loyalty.noTransactions': 'Aún no hay operaciones con puntos',
  'loyalty.enableTiers': 'Activar programa de niveles',
  'loyalty.tiersDisabled': 'Programa de niveles desactivado',
  'loyalty.tierPeriod': 'Período de cálculo',
  'loyalty.periodAllTime': 'Todo el tiempo',
  'loyalty.periodMonths': 'Últimos {n} meses',
  'loyalty.tierPeriodHint': 'Período para calcular el gasto y determinar el nivel',
  'loyalty.sectionTiers': 'Niveles de clientes',
  'loyalty.tiersHint': 'El descuento se determina automáticamente por el gasto total del cliente',
  'loyalty.tierName': 'Nombre',
  'loyalty.tierMinSpent': 'Gasto mín.',
  'loyalty.tierDiscount': 'Descuento',
  'loyalty.tierLoadingBtn': 'Calculando descuento',
  'loyalty.tierLoadingHint': 'Calculando descuento por nivel…',
  'loyalty.addTier': 'Añadir nivel',
  'loyalty.noTierCustomers': 'Aún no hay clientes con gastos',
  'loyalty.sectionTierStatus': 'Nivel del cliente',
  'loyalty.tierDiscountLabel': 'Descuento del nivel',
  'loyalty.nextTier': 'Siguiente nivel',
  'loyalty.enableCoupons': 'Activar códigos promo',
  'loyalty.couponsDisabled': 'Códigos promo desactivados',
  'loyalty.searchCoupon': 'Buscar código promo...',
  'loyalty.addCoupon': 'Crear código promo',
  'loyalty.newCoupon': 'Nuevo código promo',
  'loyalty.editCoupon': 'Editar código promo',
  'loyalty.saveCoupon': 'Guardar código promo',
  'loyalty.couponCode': 'Código',
  'loyalty.couponType': 'Tipo de descuento',
  'loyalty.couponPercent': 'Porcentaje',
  'loyalty.couponFixed': 'Importe fijo',
  'loyalty.couponValue': 'Valor del descuento',
  'loyalty.couponMinOrder': 'Pedido mínimo',
  'loyalty.couponMaxUses': 'Usos máximos',
  'loyalty.couponMaxUsesHint': '0 = sin límite',
  'loyalty.couponExpiry': 'Válido hasta',
  'loyalty.couponUsed': 'Usado',
  'loyalty.generateCode': 'Generar',
  'loyalty.noCoupons': 'Aún no hay códigos promo',
  'loyalty.statusActive': 'Activo',
  'loyalty.statusInactive': 'Inactivo',
  'loyalty.statusExpired': 'Expirado',
  'loyalty.statusMaxed': 'Agotado',
  'loyalty.enableSubscriptions': 'Activar suscripciones',
  'loyalty.subscriptionsDisabled': 'Suscripciones desactivadas',
  'loyalty.disableConfirmTitle': '¿Desactivar programa?',
  'loyalty.disableConfirmMessage': '¿Está seguro de que desea desactivar este programa de fidelización? Dejará de funcionar para los clientes.',
  'loyalty.disableConfirm': 'Desactivar',
  'loyalty.addPlan': 'Crear plan',
  'loyalty.newPlan': 'Nuevo plan',
  'loyalty.editPlan': 'Editar plan',
  'loyalty.savePlan': 'Guardar plan',
  'loyalty.planName': 'Nombre del plan',
  'loyalty.planType': 'Tipo',
  'loyalty.planTypeVisits': 'Por visitas',
  'loyalty.planTypeTime': 'Por tiempo',
  'loyalty.planTotalVisits': 'Total de visitas',
  'loyalty.planValidDays': 'Período de validez',
  'loyalty.planPrice': 'Precio',
  'loyalty.planServices': 'Servicios',
  'loyalty.planServicesHint': 'Seleccione servicios o deje vacío para todos',
  'loyalty.allServices': 'Todos los servicios',
  'loyalty.noPlans': 'Aún no hay planes',
  'loyalty.visits': 'visitas',
  'loyalty.noActiveSubs': 'Aún no hay suscripciones activas',
  'loyalty.subVisits': 'Visitas',
  'loyalty.subExpires': 'Expira',
  'loyalty.consumedVisitsTitle': 'Visitas usadas',
  'loyalty.noConsumedVisits': 'Aún no se usaron visitas',
  'loyalty.subStatus_active': 'Activo',
  'loyalty.subStatus_expired': 'Expirado',
  'loyalty.subStatus_used_up': 'Agotado',
  'loyalty.sectionSubscriptions': 'Suscripciones',
  'loyalty.sellSubscription': 'Vender suscripción',
  'loyalty.sellSubTitle': 'Venta de suscripción',
  'loyalty.selectCustomer': 'Seleccionar cliente',
  'loyalty.selectPlan': 'Seleccionar plan',
  'loyalty.confirmSell': 'Confirmar',
  'loyalty.toPayment': 'Ir al pago',
  'loyalty.paymentTitle': 'Pago de suscripción',
  'loyalty.subSold': 'Suscripción vendida con éxito',
  'loyalty.refund': 'Reembolso',
  'loyalty.refundConfirm': '¿Reembolsar la suscripción "{name}"? Se desactivará.',
  'loyalty.subRefunded': 'Reembolsado, suscripción desactivada',
  'loyalty.subStatus_refunded': 'Reembolsado',
  'loyalty.subPurchased': 'Comprado',
  'loyalty.subPrice': 'Precio',
  'loyalty.noActiveModules': 'No hay programas de fidelización activos',

  // ── Loyalty integration (checkout) ──
  'loyalty.usePoints': 'Usar puntos',
  'loyalty.balance': 'Saldo',
  'loyalty.max': 'Máx.',
  'loyalty.apply': 'Aplicar',
  'loyalty.enterCoupon': 'Ingrese código promo',
  'loyalty.couponNotFound': 'Código promo no encontrado',
  'loyalty.couponInvalid': 'Código promo no válido',
  'loyalty.couponErr_not_found': 'Código promo no encontrado',
  'loyalty.couponErr_inactive': 'Código promo inactivo',
  'loyalty.couponErr_expired': 'Código promo expirado',
  'loyalty.couponErr_maxed': 'Código promo agotado',
  'loyalty.couponErr_min_order': 'Monto inferior al mínimo del código promo',
  'loyalty.payBySubscription': 'Pagar con suscripción',
  'loyalty.subscription': 'Suscripción',
  'loyalty.pointsRedeemed': 'Puntos canjeados al pagar',
  'presence.editing': 'Este registro está siendo editado por',

  // ── Rozetka integration ──
  'rozetka.title': 'Rozetka Marketplace',
  'rozetka.subtitle': 'Integración con el marketplace Rozetka para sincronización de pedidos',
  'rozetka.login': 'Login (email del vendedor)',
  'rozetka.loginRequired': 'Ingrese el login',
  'rozetka.password': 'Contraseña',
  'rozetka.save': 'Guardar',
  'rozetka.saved': 'Configuración guardada',
  'rozetka.error': 'Error: ',
  'rozetka.testConnection': 'Probar conexión',
  'rozetka.testSuccess': 'Conexión exitosa',
  'rozetka.testError': 'Error de conexión',
  'rozetka.ordersCount': 'Pedidos',
  'rozetka.help': 'Se requiere una cuenta de vendedor en Rozetka. Use el mismo login y contraseña que para seller.rozetka.com.ua',

  // ── Prom.ua integration ──
  'prom.title': 'Prom.ua',
  'prom.subtitle': 'Integración con el marketplace Prom.ua para sincronización de pedidos',
  'prom.apiToken': 'Token API',
  'prom.tokenRequired': 'Ingrese el token API',
  'prom.save': 'Guardar',
  'prom.saved': 'Configuración guardada',
  'prom.error': 'Error: ',
  'prom.testConnection': 'Probar conexión',
  'prom.testSuccess': 'Conexión exitosa',
  'prom.testError': 'Error de conexión',
  'prom.help': 'Para obtener un token API: Gabinete del vendedor → Configuración → Gestión de tokens API. Cree un token con permisos de pedidos y productos.',

  // ── POS (venta rápida) ──
  'pos.title': 'Tienda',
  'pos.selectWarehouse': 'Seleccione almacén',
  'pos.noWarehouseHint': 'Seleccione un almacén para comenzar a vender',
  'pos.tariffPlan': 'Plan tarifario',
  'pos.standardPrice': 'Precio estándar',
  'pos.search': 'Buscar producto...',
  'pos.allCategories': 'Todos',
  'pos.outOfStock': 'Agotado',
  'pos.noProducts': 'No se encontraron productos',
  'pos.cart': 'Carrito',
  'pos.emptyCart': 'El carrito está vacío',
  'pos.subtotal': 'Subtotal',
  'pos.discount': 'Descuento',
  'pos.loyaltyPoints': 'Puntos de lealtad',
  'pos.available': 'disponible',
  'pos.total': 'Total',
  'pos.coupon': 'Coupon',
  'pos.couponPlaceholder': 'Enter coupon code...',
  'pos.applyCoupon': 'Apply',
  'pos.invalidCoupon': 'Coupon is invalid or not found',
  'pos.cash': 'Efectivo',
  'pos.card': 'Tarjeta',
  'pos.transfer': 'Transferencia',
  'pos.cashGiven': 'Recibido',
  'pos.change': 'Cambio',
  'pos.confirm': 'Confirmar',
  'pos.saleComplete': '¡Venta completada!',
  'pos.returnTitle': 'Devolución de producto',
  'pos.returnHint': 'Indique la cantidad a devolver',
  'pos.returnAmount': 'Monto de devolución',
  'pos.confirmReturn': 'Devolver',
  'pos.tabSale': 'Venta',
  'pos.tabHistory': 'Historial',
  'pos.historyEmpty': 'Aún no hay ventas',
  'pos.historyDate': 'Fecha',
  'pos.historyItems': 'Artículos',
  'pos.historyTotal': 'Total',
  'pos.historyMethod': 'Método',
  'pos.historyAuthor': 'Autor',
  'pos.historyCancel': 'Cancelar',
  'pos.historyCancelConfirm': '¿Cancelar esta venta? Los artículos volverán al stock.',
  'pos.historyCancelled': 'Venta cancelada',
  'pos.historyCustomer': 'Cliente',
  'pos.historyReturn': 'Devolución',
  'pos.historyReturned': 'Devolución',
  'pos.partialReturn': 'Dev. parcial',
  'pos.warehouse': 'Almacén',
  'pos.customer': 'Cliente',
  'pos.selectCustomer': 'Buscar cliente...',
  'bizMonitor.title': 'Monitor de Negocio',
  'bizMonitor.subtitle': 'Visión estratégica para el propietario',
  'bizMonitor.revenue': 'Ingresos', 'bizMonitor.profit': 'Beneficio', 'bizMonitor.profitability': 'Rentabilidad',
  'bizMonitor.activeClients': 'Clientes activos', 'bizMonitor.retention': 'Retención',
  'bizMonitor.services': 'Servicios', 'bizMonitor.goods': 'Productos',
  'bizMonitor.new': 'Nuevos', 'bizMonitor.returning': 'Recurrentes', 'bizMonitor.prevMonth': 'Mes ant.',
  'bizMonitor.revenueTrend': 'Tendencia de ingresos', 'bizMonitor.clientHealth': 'Salud de clientes',
  'bizMonitor.viewDetails': 'Ver detalles', 'bizMonitor.newClients': 'Nuevos', 'bizMonitor.returningClients': 'Recurrentes',
  'bizMonitor.sleeping': 'Inactivos (30d+)', 'bizMonitor.avgCheckServices': 'Ticket medio servicios',
  'bizMonitor.avgCheckProducts': 'Ticket medio productos', 'bizMonitor.channels': 'Canales de venta',
  'bizMonitor.channelAppts': 'Citas', 'bizMonitor.channelOrders': 'Pedidos', 'bizMonitor.channelPos': 'POS',
  'bizMonitor.topStaff': 'Top empleados', 'bizMonitor.topServices': 'Top servicios', 'bizMonitor.topProducts': 'Top productos',
  'bizMonitor.appointments': 'citas', 'bizMonitor.times': 'veces', 'bizMonitor.pcs': 'uds', 'bizMonitor.margin': 'Margen',
  'bizMonitor.stockAnalytics': 'Inventario', 'bizMonitor.stockValue': 'Valor stock', 'bizMonitor.positions': 'artículos',
  'bizMonitor.lowStockCount': 'Stock bajo', 'bizMonitor.noMovementCount': 'Sin movimiento 30d+',
  'bizMonitor.alerts': 'Requiere atención', 'bizMonitor.alertFinance': 'Finanzas', 'bizMonitor.alertClients': 'Clientes',
  'bizMonitor.alertStock': 'Productos/Inventario', 'bizMonitor.alertStaff': 'Personal', 'bizMonitor.noData': 'Sin datos',
  'sidebar.businessMonitor': 'Monitor de Negocio',

  // ── Comunicación: claves que faltaban respecto a uk (2026-09-25) ──
  'nav.instagram': 'Instagram',
  'nav.messenger': 'Messenger',
  'instagram.tagline': 'Mensajes directos de tu cuenta Instagram Business — en el CRM',
  'instagram.connected': 'Conectado',
  'instagram.notConnected': 'No conectado',
  'instagram.connectIntro': 'Conecta tu cuenta Instagram Business mediante OAuth para recibir los mensajes directos de tus clientes en el CRM.',
  'instagram.connectBtn': 'Conectar Instagram',
  'instagram.tabOpened': 'Instagram se abrió en una pestaña nueva. Inicia sesión y vuelve aquí.',
  'instagram.connectFailed': 'Error de conexión:',
  'instagram.confirmDisconnect': '¿Desconectar la integración con Instagram?',
  'instagram.disconnected': 'Instagram desconectado',
  'instagram.disconnectBtn': 'Desconectar',
  'instagram.testBtn': 'Probar conexión',
  'instagram.testOk': 'La conexión funciona:',
  'instagram.testFailed': 'Error de prueba',
  'instagram.account': 'Cuenta',
  'instagram.userId': 'IG User ID',
  'instagram.scope': 'Permisos',
  'instagram.connectedAt': 'Conectado',
  'instagram.expiresAt': 'Válido hasta',
  'instagram.reconnectRequired': 'Se requiere volver a autorizar',
  'instagram.reconnectExplain': 'No se pudo renovar el token de larga duración (normalmente por más de 60 días de inactividad o por un cambio de contraseña de Instagram). Pulsa «Conectar Instagram» para seguir recibiendo mensajes.',
  'instagram.howItWorks': 'Cómo funciona',
  'instagram.step1': 'Pulsa «Conectar Instagram»: la autorización de Instagram se abrirá en una pestaña nueva.',
  'instagram.step2': 'Inicia sesión en tu cuenta Instagram Business (cuenta profesional vinculada a una página de Facebook) y permite a la aplicación el acceso a Direct.',
  'instagram.step3': 'Vuelve a esta pestaña: el estado se actualizará solo; compruébalo con «Probar conexión».',
  'instagram.capabilities': 'Qué aporta la conexión',
  'instagram.capInboxTitle': 'Mensajes directos — en el CRM',
  'instagram.capInboxText': 'Todos los mensajes de Instagram Direct llegan a Comunicación en tiempo real mediante los webhooks de Meta, junto a Telegram, SMS y email.',
  'instagram.capOutboundTitle': 'Responder desde el CRM directamente en Instagram',
  'instagram.capOutboundText': 'Abre el hilo en Comunicación y elige el canal «Instagram»: el mensaje irá al Direct del cliente.',
  'instagram.limitations': 'Limitaciones',
  'instagram.limitationsText': 'Funciona solo con cuentas profesionales de Instagram (Business o Creator) vinculadas a una página de Facebook. Meta no admite cuentas personales en la Messaging API.',
  'instagram.resubscribed': 'Suscripción a webhooks renovada. Pulsa «Probar conexión» para ver el nuevo estado.',
  'instagram.resubscribeFailed': 'No se pudo renovar la suscripción:',
  'instagram.errorPrefix': 'Error:',
  'custModal.subscriptionPurchase': 'Compra de abono',
  'custModal.subscriptionRefund': 'Devolución de abono',
  'custModal.methodOnline': 'En línea',
  'custModal.methodSubscription': 'Abono',
  'custModal.servicesLabel': 'Servicios',
  'custModal.messageSent': 'Enviado',
  'emailSet.provider': 'Servicio de correo',
  'emailSet.presetGmail': 'Gmail / Google Workspace',
  'emailSet.presetOutlook': 'Outlook / Microsoft 365',
  'emailSet.presetUkrnet': 'Ukr.net',
  'emailSet.presetMeta': 'Meta.ua',
  'emailSet.presetCustom': 'SMTP propio',
  'emailSet.hintGmail': 'Necesitas una contraseña de aplicación de myaccount.google.com/apppasswords (activa antes la verificación en dos pasos)',
  'emailSet.hintOutlook': 'El usuario es la dirección completa (you@outlook.com). Con la verificación en dos pasos puede hacer falta una contraseña de aplicación',
  'emailSet.hintUkrnet': 'En Ukr.net: Ajustes → Correo → Permitir el acceso de clientes de correo externos',
  'emailSet.hintMeta': 'En Meta.ua: Ajustes → IMAP/SMTP → Activar',
  'emailSet.hintCustom': 'Introduce a mano el host, el puerto y las credenciales de tu servidor de correo',
  'emailSet.host': 'Servidor SMTP',
  'emailSet.port': 'Puerto',
  'emailSet.secure': 'TLS/SSL',
  'emailSet.smtpUser': 'Usuario SMTP',
  'emailSet.smtpUserHint': 'Normalmente la dirección de correo completa',
  'emailSet.password': 'Contraseña SMTP',
  'emailSet.passwordHint': 'Para Gmail/Outlook: contraseña de aplicación, no la principal',
  'emailSet.fromEmail': 'Dirección del remitente',
  'emailSet.fromEmailHint': 'Si está vacío, se usa el usuario SMTP',
  'emailSet.invalidEmail': 'Dirección de correo no válida (debe ser user@domain.com)',
  'emailSet.sectionProvider': 'Servicio de correo y servidor',
  'emailSet.sectionCredentials': 'Credenciales',
  'emailSet.sectionFrom': 'Remitente',
  'emailSet.howToConnect': 'Cómo conectar {provider}',
  'emailSet.instrGmail': '<ol><li>Activa la verificación en dos pasos en tu cuenta de Google: <a href="https://myaccount.google.com/security" target="_blank">myaccount.google.com/security</a> → <strong>Verificación en dos pasos</strong> → <strong>Activar</strong>.</li><li>Ve a <a href="https://myaccount.google.com/apppasswords" target="_blank">myaccount.google.com/apppasswords</a>.</li><li>Crea una contraseña de aplicación: tipo <strong>Correo</strong> (u <strong>Otro</strong> con el nombre <code>Systemic CRM</code>).</li><li>Copia la contraseña de 16 caracteres (parece <code>abcd efgh ijkl mnop</code>).</li><li>Pégala en el campo <strong>Contraseña SMTP</strong> de arriba y pulsa <strong>Enviar correo de prueba</strong>.</li></ol>',
  'emailSet.instrOutlook': '<ol><li>Entra en <a href="https://account.microsoft.com/security" target="_blank">account.microsoft.com/security</a>.</li><li>Abre <strong>Opciones de seguridad avanzadas</strong>.</li><li>En <strong>Contraseñas de aplicación</strong> pulsa <strong>Crear una nueva contraseña</strong>.</li><li>Copia la contraseña generada y pégala en <strong>Contraseña SMTP</strong>.</li><li><em>Si no aparece la opción «Contraseñas de aplicación», activa antes la verificación en dos pasos.</em></li></ol>',
  'emailSet.instrUkrnet': '<ol><li>Entra en el correo de Ukr.net.</li><li>Ve a <strong>Ajustes → Todos los ajustes → Programas de correo</strong>.</li><li>Activa el <strong>acceso por IMAP/SMTP</strong>.</li><li>En <strong>Contraseña SMTP</strong> indica la contraseña principal del correo de Ukr.net.</li><li><em>Si tienes activada la verificación en dos pasos, crea una contraseña de aplicación aparte en los ajustes de seguridad.</em></li></ol>',
  'emailSet.instrMeta': '<ol><li>Entra en el correo de Meta.ua.</li><li>Ve a <strong>Ajustes → IMAP/SMTP</strong>.</li><li>Activa el protocolo SMTP.</li><li>Indica la contraseña principal del correo en el campo <strong>Contraseña SMTP</strong>.</li></ol>',
  'emailSet.instrCustom': '<ol><li>Pide al administrador del sistema o al proveedor de hosting los parámetros SMTP de tu servidor de correo.</li><li>Normalmente hacen falta: <strong>host</strong> (smtp.tu-dominio.com), <strong>puerto</strong> (587 o 465), <strong>TLS/SSL</strong> (para 465, activado).</li><li>El usuario es la dirección de correo completa.</li><li>La contraseña es la misma con la que entras al correo (o una contraseña SMTP aparte si el proveedor la ofrece).</li></ol>',
  'notifAuto.title': 'Ajustes de comunicación',
  'notifAuto.subtitle': 'Prioridad de canales, mensajes automáticos y recordatorios',
  'notifAuto.navItem': 'Ajustes de comunicación',
  'notifAuto.sectionDefaultPriority': 'Prioridad predeterminada para mensajes manuales',
  'notifAuto.defaultPriorityHint': 'Cuando el administrador escribe a un cliente en Comunicación por primera vez, se elige el primer canal disponible de esta lista; después se mantiene el canal usado por última vez con ese cliente. Arrastra para reordenar y desactiva los que no uses.',
  'notifAuto.sectionBooking': 'Mensaje al crear una cita de servicios',
  'notifAuto.sectionOrder': 'Mensaje al crear un pedido de productos',
  'notifAuto.enable': 'Activar',
  'notifAuto.mode': 'Modo de entrega',
  'notifAuto.modePriority': 'Prioridad (primer canal disponible)',
  'notifAuto.modeAll': 'Todos los canales a la vez',
  'notifAuto.channelsOrder': 'Prioridad de canales (arrastra para reordenar)',
  'notifAuto.channelsEmpty': 'Ningún canal activado: activa al menos uno abajo',
  'notifAuto.otherChannels': 'Otros canales',
  'notifAuto.dragHint': 'Arrastra para cambiar el orden',
  'notifAuto.channelNotConfigured': 'El canal no está configurado en su sección: el mensaje no se enviará',
  'notifAuto.channelTelegram': 'Telegram',
  'notifAuto.channelSms': 'SMS',
  'notifAuto.channelEmail': 'Email',
  'notifAuto.channelWeb': 'Chat del sitio web',
  'notifAuto.template': 'Plantilla del mensaje',
  'notifAuto.templateHint': 'Variables disponibles: {clientName}, {date}, {time}, {serviceName}, {staffName}, {locationName}, {phone}, {orderNumber}, {total}, {items}',
  'notifAuto.templateHtmlNote': 'Admite HTML para Telegram/Email; para SMS se convierte automáticamente a texto plano',
  'notifAuto.preview': 'Vista previa',
  'notifAuto.previewHint': 'Ejemplo con datos de prueba',
  'notifAuto.save': 'Guardar',
  'notifAuto.saved': 'Ajustes guardados',
  'notifAuto.moveUp': 'Subir',
  'notifAuto.moveDown': 'Bajar',
  'notifAuto.defaultBookingTemplate': '¡Hola, {clientName}! Tu cita está confirmada para el {date} a las {time}. Servicio: {serviceName}, especialista: {staffName}. ¡Te esperamos!',
  'notifAuto.defaultOrderTemplate': 'Gracias por tu pedido #{orderNumber} por {total} ₴. Te contactaremos para confirmar la entrega.',
  'notifAuto.sectionReminders': 'Recordatorios antes de la visita',
  'notifAuto.remindersHint': 'Puedes añadir varias reglas con distintos intervalos (por ejemplo, 24 horas y 2 horas antes). Mínimo: 1 hora.',
  'notifAuto.noReminders': 'Aún no hay recordatorios configurados',
  'notifAuto.addReminder': 'Añadir recordatorio',
  'notifAuto.removeReminder': 'Eliminar recordatorio',
  'notifAuto.hoursBefore': 'Cuánto antes de la visita',
  'notifAuto.hoursBeforeUnit': 'horas',
  'notifAuto.defaultReminderTemplate': 'Recordatorio: tu visita es el {date} a las {time}. Servicio: {serviceName}, especialista: {staffName}. ¡Te esperamos!',
  'comm.filterAll': 'Todos',
  'comm.channelWeb': 'Chat del sitio web',
  'comm.noChannelsForClient': 'El cliente no tiene canales de contacto conectados',
  'comm.addContactToCard': 'Añade un teléfono o email en la ficha del cliente, o envíale el enlace al bot de Telegram',
  'sms.testText': 'Systemic CRM: mensaje de prueba.',
  'sms.testSent': 'Enviado: revisa el teléfono',
  'sms.testNotSent': 'No enviado',
  'sms.senderRule1': 'Máximo 11 caracteres latinos, sin espacios: es el límite del estándar GSM. El nombre debe estar',
  'sms.senderRuleStrong': 'registrado en la cuenta del proveedor',
  'sms.senderRule2': 'y coincidir carácter a carácter, incluidas mayúsculas y minúsculas.',
  'sms.lastFailed': 'El último envío falló',
  'sms.lastOk': 'Último envío correcto',
  'sms.testLabel': 'Prueba con un SMS real',
  'telegram.statusChecking': 'Comprobando el estado del bot…',
  'telegram.statusRecheck': 'Comprobar',
  'telegram.statusLastError': 'Último error:',
  'telegram.statusBot': 'Bot',
  'telegram.statusWebhook': 'Webhook',
  'telegram.statusWebhookNone': 'no configurado',
  'telegram.statusWebhookExpected': 'se esperaba',
  'telegram.statusQueue': 'En cola',
  'telegram.statusSubscribers': 'Suscriptores',
  'telegram.statusSubscribersSub': 'clientes que pulsaron «Iniciar»',
  'telegram.verdictOk': 'El bot está conectado y funciona',
  'telegram.verdictNoToken': 'El bot no está configurado',
  'telegram.verdictNoTokenHint': 'Pega el token de @BotFather y pulsa «Guardar y conectar».',
  'telegram.verdictBadToken': 'Token no válido',
  'telegram.verdictBadTokenHint': 'El bot fue eliminado o el token se regeneró en @BotFather. Pega el nuevo.',
  'telegram.verdictNoWebhook': 'Webhook no configurado',
  'telegram.verdictNoWebhookHint': 'Telegram no sabe adónde enviar las actualizaciones. Pulsa «Guardar y conectar».',
  'telegram.verdictHostMismatch': 'El webhook apunta a otra dirección',
  'telegram.verdictHostMismatchHint': 'Suele ocurrir cuando el bot se conectó desde un enlace de prueba. Pulsa «Guardar y conectar» en esta dirección.',
  'telegram.verdictWebhookError': 'Telegram no consigue contactarnos',
  'telegram.verdictPending': 'Las actualizaciones están atascadas en la cola',
  'telegram.verdictPendingHint': 'Telegram ha acumulado actualizaciones que no pudo entregar.',
  'telegram.verdictNoSubscribers': 'El bot funciona, pero no tiene suscriptores',
  'telegram.verdictNoSubscribersHint': 'Ningún cliente ha pulsado «Iniciar» en el bot todavía. El enlace personal está en la ficha del cliente.',
  'telegram.verdictUnreachable': 'No se pudo comprobar el estado',
  'telegram.statusForward': 'Reenvío',
  'telegram.statusForwardOk': 'funciona',
  'telegram.statusForwardError': 'error',
  'telegram.statusForwardPending': 'aún sin actualizaciones',
  'telegram.fwdTitle': 'Bot externo: menús y flujos',
  'telegram.fwdIntro': 'Si este bot tiene un servidor aparte para menús (botones, flujos), Systemic sigue siendo el dueño del webhook y le reenvía una copia de cada actualización. Las conversaciones y las respuestas de los operadores se quedan aquí, como hasta ahora.',
  'telegram.fwdUrl': 'Dirección de reenvío (https)',
  'telegram.fwdUrlHint': 'Déjalo vacío para desactivar el reenvío.',
  'telegram.fwdSecret': 'Contraseña de reenvío',
  'telegram.fwdSecretHint': 'Cualquier cadena que elijas. Systemic la enviará en la cabecera X-Systemic-Secret y una firma del cuerpo en X-Systemic-Signature, para que el servidor externo verifique que la petición es nuestra.',
  'telegram.fwdSecretStored': 'La contraseña está guardada en el servidor y no se devuelve al navegador. Introduce una nueva para reemplazarla.',
  'telegram.fwdSave': 'Guardar reenvío',
  'telegram.fwdSaved': 'Reenvío guardado',
  'telegram.fwdInvalidUrl': 'La dirección debe empezar por https://',
  'telegram.fwdHowTitle': 'Cómo funciona y qué tener en cuenta',
  'telegram.fwdHow1': 'El webhook del bot se queda en Systemic. El servidor externo no debe cambiarlo: la tarjeta de estado mostraría «El webhook apunta a otra dirección» y «Guardar y conectar» lo recuperaría.',
  'telegram.fwdHow2': 'Systemic procesa cada actualización (conversaciones, vinculación del cliente, teléfono) y en paralelo reenvía una copia a la dirección indicada, incluidas las pulsaciones de botones, que Systemic ignora.',
  'telegram.fwdHow3': 'El servidor externo muestra los menús mediante el token del bot. Es interfaz, no conversación: no llega a Comunicación. A los clientes les responden los operadores desde Systemic.',
  'telegram.fwdHow4': 'Haz los menús con botones inline (bajo el mensaje). El teclado inferior envía las pulsaciones como texto normal y el hilo del operador se llena de «Servicios», «Atrás».',
  'telegram.fwdHow5': 'Systemic ya responde a /start: saluda y pide el teléfono para encontrar al cliente. Muestra el menú después de eso o con un comando aparte; si no, el cliente recibe dos mensajes seguidos.',
  'telegram.fwdHow6': 'El servidor debe responder 200 en 4 segundos. No hay reintentos; el estado del último reenvío se ve en la tarjeta de estado de arriba.',
  'messengerSet.tagline': 'Mensajes de tu página de Facebook — en el CRM',
  'messengerSet.tabOpened': 'Facebook se abrió en una pestaña nueva. Inicia sesión y vuelve aquí.',
  'messengerSet.connectFailed': 'Error de conexión:',
  'messengerSet.confirmDisconnect': '¿Desconectar la integración con Messenger?',
  'messengerSet.disconnected': 'Messenger desconectado',
  'messengerSet.pageActivated': 'Página «{name}» activada',
  'messengerSet.subscribeFailed': 'Página activada, pero la suscripción al webhook falló: {error}. Pulsa «Renovar suscripción a webhooks».',
  'messengerSet.activateFailed': 'No se pudo activar la página',
  'messengerSet.errorPrefix': 'Error:',
  'messengerSet.pagesRefreshed': 'Lista de páginas actualizada',
  'messengerSet.resubscribed': 'Suscripción a webhooks renovada. Pulsa «Probar conexión».',
  'messengerSet.resubscribeFailed': 'No se pudo renovar la suscripción:',
  'messengerSet.needsReconnect': 'Se requiere volver a autorizar',
  'messengerSet.reconnectHint': 'Facebook anuló el token. Pulsa «Conectar» para continuar.',
  'messengerSet.howTitle': 'Cómo funciona',
  'messengerSet.how1': 'Pulsa «Conectar Messenger»: Facebook abrirá la autorización en una pestaña nueva.',
  'messengerSet.how2': 'Permite a la aplicación gestionar los mensajes de tus páginas.',
  'messengerSet.how3': 'Vuelve aquí: verás la lista de tus páginas de Facebook. Elige una para el CRM.',
  'messengerSet.how4': 'Listo. Los mensajes de esa página llegan a Comunicación automáticamente.',
  'messengerSet.givesTitle': 'Qué aporta la conexión',
  'messengerSet.capInboxTitle': 'Mensajes de la página de Facebook — en el CRM',
  'messengerSet.capInboxText': 'Todos los mensajes a tu página llegan a Comunicación en tiempo real, junto a Telegram, SMS y email.',
  'messengerSet.capReplyTitle': 'Responder desde el CRM directamente en Messenger',
  'messengerSet.capReplyText': 'Abre el hilo en Comunicación y elige el canal «Messenger»: la respuesta irá al cliente. Meta permite responder durante las 24 horas siguientes a su mensaje.',
  'messengerSet.limitsLabel': 'Limitaciones:',
  'messengerSet.limitsText': 'Funciona solo con páginas de empresa de Facebook, no con perfiles personales.',
  'messengerSet.statusOff': 'No conectado',
  'messengerSet.statusPending': 'Esperando la elección de página',
  'messengerSet.statusOn': 'Conectado',
  'messengerSet.connectIntro': 'Conecta tu cuenta de Facebook y elige la página cuyos mensajes llegarán al CRM.',
  'messengerSet.connectBtn': 'Conectar Messenger',
  'messengerSet.noPages': 'No se encontró ninguna página de Facebook en esta cuenta. Crea una en facebook.com → Pages y actualiza la lista.',
  'messengerSet.refreshPages': 'Actualizar lista de páginas',
  'messengerSet.disconnectBtn': 'Desconectar',
  'messengerSet.pickIntro': 'Elige la página de Facebook de la que el CRM recibirá mensajes:',
  'messengerSet.pageActive': 'Activa',
  'messengerSet.pageUse': 'Usar',
  'messengerSet.refreshList': 'Actualizar lista',
  'messengerSet.fbAccount': 'Cuenta de Facebook:',
  'messengerSet.activePage': 'Página activa:',
  'messengerSet.connectedAt': 'Conectado:',
  'messengerSet.userTokenUntil': 'Token de usuario válido hasta:',
  'messengerSet.unknown': '(desconocido)',
  'messengerSet.testBtn': 'Probar conexión',
  'messengerSet.resubscribeBtn': 'Renovar suscripción a webhooks',
  'messengerSet.switchPage': 'Cambiar página',
  'messengerSet.patOk': '✓ El token de la página es válido:',
  'messengerSet.patFailed': '✗ El token de la página no pasó la comprobación:',
  'messengerSet.subsTitle': 'Suscripciones a webhooks:',
  'messengerSet.noApps': 'Ninguna aplicación está suscrita a esta página. Pulsa «Renovar suscripción a webhooks».',
  'messengerSet.subscribedFields': 'Campos suscritos:',
  'messengerSet.noMessagesField': '⚠ Falta el campo «messages»: Meta no entregará mensajes. Pulsa «Renovar suscripción a webhooks».',
  'messengerSet.subsFailed': '✗ La comprobación de suscripciones falló:',
};

export default es;
